const BUILDING_INSPECTION = {
  // help text shown in the info "i" next to inspection fields
  tooltips: {
    info: {
      buildingCategory:
        'Valitse rakennuksen pääluokka, esimerkiksi toimisto, koulu tai varasto. Kenttää käytetään oikeiden vakioarvojen ja profiilien valitsemiseen laskennassa.',
      yearOfConstruction:
        'Anna rakennuksen rakennusvuosi tai viimeisimmän merkittävän peruskorjauksen vuosi, jos se on edustavampi. Käytetään muun muassa todennäköisen teknisen tason arviointiin.',
      numberOfFloors:
        'Anna rakennuksen maanpäällisten kerrosten kokonaismäärä. Kenttää käytetään geometrian, tilavuuden ja vyöhykkeisiin jaon perustana.',
    },
    thermalZones: {
      zoneCategory:
        'Terminen vyöhyke on rakennuksen osa, jota käsitellään laskennassa yhtenä kokonaisuutena, tyypillisesti samanlaisella käytöllä ja sisäilmastolla. Anna vyöhykkeelle selkeä nimi ja valitse vyöhykeluokka. Luokka määrittää käyttöajan, sisäisten kuormien ja teknisten lähtöoletusten vakioprofiilit.',
      buildingSubcategory:
        'Valitse alaluokka, jos haluat tarkemman vyöhykkeen luokittelun. Jätä kenttä tyhjäksi, jos tavallinen vyöhykeluokka riittää.',
      zoneClimate:
        'Ilmaisee, onko vyöhyke lämmitetty, osittain lämmitetty vai lämmittämätön. Ilmastotila määrää, miten vyöhyke sisältyy lämmitys- ja jäähdytystarpeeseen, ja on energialaskennan perustavanlaatuinen lähtöoletus.',
      bra: 'BRA on vyöhykkeen hyötyala, eli ulkoseinien sisäpuolinen lattiapinta-ala, joka lasketaan lämmitetyksi alaksi. Anna BRA neliömetreinä. Ala on yksi tärkeimmistä lähtötiedoista ja vaikuttaa suoraan lähes kaikkiin laskelmiin.',
      floors:
        'Anna, kuinka monen kerroksen yli vyöhyke ulottuu, jos se ei rajoitu yhteen tasoon. Jos vyöhyke sijaitsee vain yhdessä tasossa, kentän voi usein jättää tyhjäksi.',
      floorHeight:
        'Anna vyöhykkeen keskimääräinen kerroskorkeus metreinä. Käytetään yhdessä pinta-alan kanssa tilavuuden ja ilmamäärien laskemiseen.',
      indoorTemp:
        'Vyöhykkeen lämpötila simuloinnin alkaessa. Tämä ei ole asetusarvo: lämmityksen ja jäähdytyksen asetusarvot annetaan lämmitysaikataulussa ja jäähdytysaikataulussa.',
      tekStandard:
        'TEK tarkoittaa Norjan rakentamismääräyksiä, esimerkiksi TEK10 ja TEK17, jotka asettavat vaatimuksia muun muassa U-arvoille ja tiiviydelle. Valitse relevantti TEK-standardi, jos haluat ohjata vakioarvoja tarkemmin kuin pelkkä rakennusvuosi mahdollistaa.',
      airLeakageN50:
        'Ilmavuotoluku (n50) kuvaa rakennuksen ilmatiiviyttä, mitattuna ilmanvaihtokertoina tunnissa 50 Pa paine-erolla. Anna arvo, jos se on tiedossa painekokeesta tai dokumentaatiosta. Jos kenttä on tyhjä, käytetään edustavia vakioarvoja.',
      thermalBridgeCoeff:
        'Kylmäsilta on rakenteen kohta, jossa lämpöhäviö on suurempi, tyypillisesti siellä missä välipohjat ja seinät kohtaavat ulkorakenteen. Valitse kantava rakenne tai kylmäsiltaluokka, jos haluat mallintaa kylmäsillat tarkemmin. Käytetään yleensä vain, kun käytettävissä on hyvää rakennusfysikaalista tietoa.',
      thermalBridgePsiValue:
        'Normalisoitu kylmäsilta-arvo (ψ) ilmaisee kylmäsiltojen aiheuttaman ylimääräisen kokonaislämpöhäviön lattianeliötä kohti. Anna arvo, jos se on tiedossa laskelmasta. Voidaan tavallisessa kartoituksessa yleensä jättää tyhjäksi.',
      heatingEmissionSystem:
        'Lämmönluovutusjärjestelmä on tapa, jolla lämpö tuodaan huoneeseen, esimerkiksi patteri, konvektori tai lattialämmitys. Valinta vaikuttaa tarvittavaan menolämpötilaan ja säätöön. Hyödyllinen tarkentamiseen, mutta yleensä ei tarpeen ensimmäisessä rekisteröinnissä.',
      coolingEmissionSystem:
        'Jäähdytyksen luovutusjärjestelmä on tapa, jolla jäähdytys tuodaan huoneeseen, esimerkiksi jäähdytyspalkki, puhallinkonvektori tai jäähdytyskatto. Valinta vaikuttaa lämpötilatasoon ja säätöön. Hyödyllinen tarkentamiseen, mutta yleensä ei tarpeen ensimmäisessä rekisteröinnissä.',
      zoneConnections:
        'Vyöhykekytkentä kuvaa pintaa, jossa kaksi vyöhykettä, tai vyöhyke ja ilmasto-olosuhde, vaihtavat lämpöä, esimerkiksi väliseinä kylmempää vyöhykettä vasten. Käytä tätä, kun tällainen lämmönvaihto on tärkeä mallille. Yleensä tarpeen vain yksityiskohtaisemmassa määrittelyssä.',
      connectionArea:
        'Anna vyöhykkeitä yhdistävän pinnan ala neliömetreinä. Yhdessä U-arvon kanssa se määrittää, kuinka paljon lämpöä vaihdetaan. Täytetään vain, kun todella mallinnat vyöhykekytkentää.',
      connectionUValue:
        'U-arvo kuvaa, kuinka hyvin vyöhykkeiden välinen pinta eristää (W/m²K). Anna se, jos se on saatavilla. Muussa tapauksessa kytkentä voidaan yleensä yksinkertaistaa tai jättää pois.',
      heatingSchedule:
        'Lämmitysaikataulu kuvaa, miten asetusarvo ja käyttö vaihtelevat vuorokauden ja viikon aikana, esimerkiksi yöpudotus. Käytä sitä, kun vyöhykkeellä on poikkeavaa käyttöä. Antaa realistisemman simuloinnin kuin kiinteät vakioprofiilit.',
      hasFloorToGround:
        'Ota tämä käyttöön, jos vyöhykkeellä on maata vasten oleva lattia. Käytöstä poistaminen piilottaa elementin ja poistaa tallennetun pinta-alan energialaskennasta.',
      hasRoof:
        'Ota tämä käyttöön, jos vyöhykkeellä on ulkoilmaa vasten oleva katto. Käytöstä poistaminen piilottaa elementin ja poistaa tallennetun pinta-alan energialaskennasta.',
      isBasement:
        'Ota tämä käyttöön, kun vyöhyke on maanpinnan alapuolella oleva kellari. Lämpöhäviö maahan lasketaan silloin Kellarirakenne elementistä, ja tämän vyöhykkeen katto, maanvarainen lattia, ulkoseinät, ikkunat ja ovet jätetään energialaskennan ulkopuolelle.',
      basement: {
        area: 'Syötä kellarin maata vasten olevan lattian pinta-ala m². Sitä tarvitaan maahan kohdistuvan lämpöhäviön laskentaan, ja se on yleensä sama kuin kellarivyöhykkeen BRA.',
        wallPerimeter:
          'Syötä maata vasten olevan kellarin seinän pituus metreinä. Yhdessä pinta-alan kanssa se antaa lattian ominaismitan. Jos kenttä jätetään tyhjäksi, oletetaan neliön muotoinen pohja.',
        fillHeight:
          'Syötä keskimääräinen syvyys maanpinnasta kellarin lattiaan metreinä. Se määrittää, kuinka suuri osa seinästä luovuttaa lämpöä maahan. 0 tarkoittaa maanvaraista laattaa.',
        wallThickness:
          'Syötä kellarin seinän kokonaispaksuus maanpinnan tasolla metreinä eristeineen. Jos kenttä jätetään tyhjäksi, käytetään arvoa 0,3 m.',
        wallConstructionType:
          'Valitse maanpinnan alapuolisen kellarin seinän rakenne tai TEK kausi, jonka vaatimusta käytetään. Valinta ehdottaa U-arvon.',
        wallUValue:
          'Maanpinnan alapuolisen kellarin seinärakenteen U-arvo (W/m²K). Syötä se, jos tiedät sen dokumentaatiosta, muuten käytetään ehdotettua arvoa.',
        floorConstructionType:
          'Valitse maata vasten olevan kellarin lattian rakenne tai TEK kausi, jonka vaatimusta käytetään. Valinta ehdottaa U-arvon.',
        floorUValue:
          'Maata vasten olevan kellarin lattiarakenteen U-arvo (W/m²K). Syötä se, jos tiedät sen dokumentaatiosta, muuten käytetään ehdotettua arvoa.',
      },
      floor: {
        type: 'Maata vasten olevan lattian tyyppi kuvaa, miten maata tai lämmittämätöntä tilaa vasten oleva lattia on rakennettu, esimerkiksi maanvarainen laatta tai kellarin päällä oleva lattia. Valitse se, joka kuvaa rakennetta parhaiten. Valintaa käytetään ehdottamaan relevantteja vakioarvoja, muun muassa U-arvo.',
        area: 'Anna maata vasten olevan lattian pinta-ala neliömetreinä sille vyöhykkeen osalle, joka rekisteröidään. Ala tarvitaan lattian läpi tapahtuvan lämpöhäviön laskemiseen.',
        uValue:
          'U-arvo ilmaisee, kuinka paljon lämpöä kulkee rakenteen läpi neliömetriä ja lämpötilaeron astetta kohti (W/m²K). Pienempi arvo tarkoittaa parempaa eristystä. Anna se, jos tunnet sen dokumentaatiosta tai laskelmasta, muuten käytetään valitun tyypin ja vuoden mukaisia nimellisarvoja.',
      },
      structuralNodes: {
        boundary:
          'Rakenteellinen solmu on kohta, jossa rakennusosat kohtaavat, esimerkiksi välipohjan ja ulkoseinän välissä, ja se on tyypillisesti kylmäsilta, jossa on ylimääräistä lämpöhäviötä. Käytä rakenteellisia solmuja, kun haluat rekisteröidä tällaisia yksityiskohtia. Yleensä tarpeen vain korkeammalla tarkkuustasolla.',
        length:
          'Anna kyseisen solmun tai kylmäsillan pituus metreinä. Täytetään vain, jos rakenteellisia solmuja käytetään.',
        height:
          'Anna kyseisen solmun korkeus metreinä, jos relevanttia. Käytetään yhdessä muiden mittojen kanssa yksityiskohtaiseen geometriakuvaukseen.',
        width:
          'Anna kyseisen solmun leveys metreinä, jos relevanttia. Kenttää käytetään vain rakenteellisten solmujen yksityiskohtaiseen rekisteröintiin.',
      },
      roof: {
        angle:
          'Kattokulma on kattopinnan kaltevuus asteina, jossa 0 tarkoittaa tasakattoa. Se kirjataan tarkastukseen, mutta energialaskenta ei vielä käytä sitä: katon lämpöhäviö lasketaan pinta-alasta ja U-arvosta, eivätkä kattoikkunat saa laskennassa auringon säteilyä.',
        type: 'Kattorakenne kuvaa, miten katto on rakennettu, esimerkiksi kompakti katto, tuuletettu lapekatto tai kattotuolit. Valitse se, joka kuvaa kattoa parhaiten. Valinta toimii perustana vakio-U-arvolle ja muille lähtöoletuksille.',
        area: 'Anna vyöhykkeeseen sisältyvä kattopinta-ala neliömetreinä. Ala tarvitaan katon läpi tapahtuvan transmission laskemiseen.',
        uValue:
          'U-arvo ilmaisee, kuinka paljon lämpöä kulkee kattorakenteen läpi neliömetriä ja lämpötilaeron astetta kohti (W/m²K). Pienempi arvo tarkoittaa parempaa eristystä. Anna se, jos se on tiedossa, muuten käytetään valitun rakenteen ja iän mukaista nimellisarvoa.',
        glassType:
          'Ota tämä käyttöön, jos katossa on ikkunoita tai kattovaloja, ja valitse lasityyppi. Lasityyppi, esimerkiksi kaksi- tai kolminkertainen lasitus, määrää sekä lämpöhäviön että sen, kuinka paljon auringon energiaa pääsee sisään kattopinnan läpi.',
        windowArea:
          'Anna ikkunoiden tai kattoikkunoiden kokonaispinta-ala neliömetreinä. Kenttä on relevantti vain, jos katossa todella on ikkunoita tai kattoikkunoita.',
        windowUValue:
          'Kattoikkunoiden U-arvo ilmaisee lämpöhäviön itse lasin ja karmin läpi (W/m²K). Pienempi arvo tarkoittaa parempaa eristystä. Anna se, jos se on tiedossa, muuten vakioarvot ovat usein riittäviä.',
        gValue:
          'G-arvo (auringonsäteilyn kokonaisläpäisykerroin) kuvaa, kuinka suuri osa auringon energiasta läpäisee lasin, välillä 0–1. Korkea g-arvo tuo enemmän ilmaista aurinkolämpöä talvella, mutta myös suuremman jäähdytystarpeen kesällä.',
        externalBlindsGt:
          'Ulkopuoliset sälekaihtimet ovat lasin ulkopinnalla ja vähentävät auringon säteilyä tehokkaasti. Aurinkokerroin (gt) kuvaa, kuinka paljon auringon energiaa läpäisee, kun varjostus on aktiivinen. Rekisteröi tämä, kun tällaisella aurinkosuojauksella on selvä vaikutus.',
        externalScreenGt:
          'Ulkopuolinen kangas tai screen on ulkopuolinen tekstiilivarjostus, joka vaimentaa auringon säteilyä. Aurinkokerroin (gt) ilmaisee, kuinka paljon auringon energiaa läpäisee kankaan ollessa alhaalla. Täytetään vain, jos ratkaisu on olemassa rakennuksessa.',
        internalShadingGt:
          'Sisäpuolinen aurinkosuojaus, esimerkiksi sälekaihtimet tai verhot sisäpuolella, vaimentaa aurinkoa mutta tehottomammin kuin ulkopuolinen varjostus. Aurinkokerroin (gt) kuvaa jäljelle jäävää auringon läpäisyä. Käytetään aurinkokuormien laskennan tarkentamiseen.',
      },
      groundConditions: {
        type: 'Maaperäolosuhteet kuvaavat rakennuksen alla olevia maamassoja, esimerkiksi savea, hiekkaa tai kalliota, jotka vaikuttavat lämpöhäviöön maahan. Käytä tätä, kun sinulla on tarkkaa tietoa maaperästä. Tämä on tyypillisesti yksityiskohtakenttä.',
        thermalConductivity:
          'Lämmönjohtavuus (λ) ilmaisee, kuinka hyvin maaperä johtaa lämpöä, yksikössä W/mK. Suurempi arvo aiheuttaa suuremman lämpöhäviön maahan. Anna dokumentoitu arvo, jos sinulla on sellainen, muuten kentän voi jättää tyhjäksi.',
        heatCapacity:
          'Lämpökapasiteetti kuvaa, kuinka paljon lämpöä maaperä voi varastoida, ja vaimentaa lämpöhäviön vaihteluja ajan myötä. Anna se, jos se on tiedossa. Voidaan tavallisessa energiakartoituksessa yleensä jättää tyhjäksi.',
        penetrationDepth:
          'Jaksottainen tunkeutumissyvyys on maaperän syvyys, johon lämpötilan vuodenaikaisvaihtelut vaikuttavat. Sitä käytetään yksityiskohtaisemmissa maaperämalleissa. Kenttää ei yleensä tarvita tavallisessa rekisteröinnissä.',
      },
      internalLoads: {
        lighting:
          'Valaistus on sisäinen lämpökuorma: valonlähteiden käyttämä energia päätyy suurelta osin lämmöksi vyöhykkeeseen. Rekisteröi valaistustaso ja mahdolliset käyttöprofiilit. Tämä vaikuttaa sekä sähkönkulutukseen että jäähdytystarpeeseen.',
        equipment:
          'Tekninen laitteisto, kuten tietokoneet, näytöt ja muu kiinteä laitteisto, luovuttaa lämpöä huoneeseen sähkönkäytön lisäksi, ja on siksi sisäinen lämpökuorma. Rekisteröi vyöhykkeen tyypillinen teho ja käyttöprofiili.',
        occupancy:
          'Ihmiset luovuttavat lämpöä ja kosteutta ja vaikuttavat samalla ilmanvaihtotarpeeseen. Rekisteröi henkilökuormitus määrien ja profiilien avulla tai vakioasetuksella, joka kuvaa vyöhykkeen normaalia käyttöä.',
        dishwasher:
          'Valitse astianpesukone, jos se on vyöhykkeellä merkittävä kuorma. Lämpimän veden osuus ilmaisee, kuinka suuri osa kulutuksesta katetaan lämmitetyllä käyttövedellä sen sijaan, että kone lämmittäisi sen itse. Käytetään yleensä vain, kun kodinkoneet ovat merkittäviä.',
        washingMachine:
          'Valitse pesukone, jos se on vyöhykkeellä merkittävä kuorma. Lämpimän veden osuus ilmaisee, kuinka suuren osan vedestä kone ottaa lämminvesijärjestelmästä sen sijaan, että lämmittäisi sen itse.',
        tumbleDryer:
          'Valitse kuivausrumpu, jos se on vyöhykkeellä merkittävä kuorma. Mahdollinen lämpimän veden osuus kuvaa, kuinka suuri osa energiantarpeesta katetaan lämpimällä käyttövedellä suoran sähkön sijaan.',
      },
      thermalMass: {
        heatCapacityCategory:
          'Terminen massa on rakennuksen kyky varastoida lämpöä, mikä vaimentaa lämpötilan vaihteluja ja siirtää lämmitys- ja jäähdytystarvetta ajassa. Valitse lämpökapasiteettiluokka, esimerkiksi kevyt tai raskas rakenne, jos haluat säätää tätä vakioarvojen lisäksi.',
        normalizedHeatCapacity:
          'Normalisoitu lämpökapasiteetti ilmaisee, kuinka paljon lämpöä vyöhyke voi varastoida lattianeliötä kohti (Wh/m²K). Anna tarkempi arvo, jos sinulla on sellainen, muuten kentän voi jättää tyhjäksi ja luokkaa käytetään.',
        cladding:
          'Sisäpuolinen pintamateriaali, esimerkiksi kipsilevy, puu tai näkyvä betoni, vaikuttaa siihen, kuinka suuri osa termisestä massasta on todella aktiivinen huonetta kohti. Valitse tyyppi, jos haluat yksityiskohtaisemman kuvauksen.',
        heatCapacity:
          'Anna sisäseinien lämpökapasiteetti, jos se on tiedossa. Tämä kuvaa, kuinka paljon lämpöä sisärakenteet voivat varastoida, ja sitä käytetään vain termisen massan yksityiskohtaisemmassa mallinnuksessa.',
        furnitureGrade:
          'Kalusteet ja varustelu vaikuttavat myös termiseen massaan. Valitse kalustusaste, joka kuvaa, kuinka kalustettu vyöhyke on, jos tällä on merkitystä. Kenttä on yleensä yksityiskohtakenttä.',
        massFactor:
          'Massakerroin säätää, kuinka paljon kalusteet ja varustelu vaikuttavat vyöhykkeen termiseen massaan. Anna arvo, jos haluat ohittaa vakioarvon.',
      },
      exteriorWall: {
        direction:
          'Ilmansuunta määrää, kuinka paljon aurinkoa julkisivu saa ja miten tuuli ja ulkoilmasto vaikuttavat lämpöhäviöön. Valitse suunta, esimerkiksi pohjoinen, etelä, itä tai länsi, rekisteröitävälle seinälle.',
        type: 'Seinätyyppi kuvaa, miten ulkoseinä on rakennettu, esimerkiksi rankarakenne, muuraus tai betoni eristyksellä. Valitse se, joka kuvaa seinää parhaiten. Valintaa käytetään ehdottamaan relevantteja vakioarvoja.',
        area: 'Syötä ulkoseinän bruttopinta-ala m², ikkunat, ovet ja portit mukaan lukien. Laskenta vähentää itse seinälle kirjatut aukot, joten nettopinta-ala antaisi liian pienen lämpöhäviön seinän läpi.',
        uValue:
          'U-arvo ilmaisee, kuinka paljon lämpöä kulkee seinän läpi neliömetriä ja lämpötilaeron astetta kohti (W/m²K). Pienempi arvo tarkoittaa parempaa eristystä. Anna se, jos se on tiedossa, muuten käytetään seinätyypin ja iän mukaisia nimellisarvoja.',
        windowShadingFactor:
          'Osuus suorasta auringonvalosta, jonka ikkuna menettää ulokkeiden, naapurirakennusten tai maaston varjostuksen vuoksi, välillä 0–1. 0 tarkoittaa ei varjostusta ja 1 täysin varjostettua. Vain suora auringonsäteily vähenee, ei hajasäteily. Alla olevat sälekaihtimet ja screenit kirjataan, mutta niitä ei käytetä laskennassa.',
      },
      heatingCooling: {
        name: 'Anna laitteelle selkeä nimi, joka helpottaa komponenttien erottamista toisistaan. Nimeä käytetään ensisijaisesti tunnistamiseen projektissa.',
        type: 'Tyyppi kuvaa, millainen lämmitys- tai jäähdytysyksikkö tämä on, esimerkiksi patteri, lattialämmitys, lämpöpumppu tai jäähdytyspalkki. Valinta ohjaa, mitkä kentät ovat relevantteja ja miten järjestelmä mallinnetaan.',
        energySource:
          'Energialähde on se, mitä yksikkö käyttää tuottaakseen lämmitystä tai jäähdytystä, esimerkiksi sähkö, kaukolämpö tai lämpöpumppu. Valitse lähde, jos komponentti on suoraan kytketty tiettyyn lähteeseen, muuten energiansyöttö voidaan kuvata keskitetysti.',
        co2eEmissionFactor:
          'CO₂e-päästökerroin ilmaisee, kuinka paljon kasvihuonekaasupäästöjä liittyy yksikön käyttämään energiaan, ilmoitettuna kilowattituntia kohti. Anna tietty arvo, jos haluat laskea päästöt tarkasti. Se ei vaikuta itse energiantarpeeseen.',
        quantity:
          'Anna samanlaisten yksiköiden lukumäärä, jos useita identtisiä yksiköitä on asennettu. Voidaan jättää tyhjäksi, jos teho ilmoitetaan yhteensä.',
        power:
          'Nimellisteho on yksikön suurin lämmitys- tai jäähdytysteho kilowatteina. Sitä käytetään arvioimaan, onko järjestelmällä kapasiteettia kattaa tarve ja miten useita järjestelmiä priorisoidaan. Anna yhteisteho, jos useita samanlaisia yksiköitä yhdistetään.',
        systemEfficiency:
          'Järjestelmän hyötysuhde kuvaa, kuinka suuri osa syötetystä energiasta muuttuu todella hyödylliseksi lämmöksi tai jäähdytykseksi, mukaan lukien jakelun ja säädön häviöt. Anna parempi luku kuin vakio, jos sinulla on sellainen. Usein ei tarpeen ensimmäisessä rekisteröinnissä.',
        priority:
          'Prioriteetti ohjaa järjestystä, jossa järjestelmät otetaan käyttöön, kun useat kattavat saman tarpeen. Pienempi prioriteetti tarkoittaa, että järjestelmää käytetään ensin ja loput kattavat huippukuorman. Aseta tämä, jos vyöhykkeellä on useita lämmitys- tai jäähdytyslähteitä.',
        cop: 'COP (Coefficient of Performance) on lämpöpumpun hyötysuhde lämmityksessä: tuotetun lämmön suhde syötettyyn sähköön. COP 3 tarkoittaa kolme kertaa niin paljon lämpöä kuin sähköä. Anna tietty arvo, jos sinulla on sellainen.',
        eer: 'EER (Energy Efficiency Ratio) on hyötysuhde jäähdytyksessä: tuotetun jäähdytyksen suhde syötettyyn sähköön. Suurempi arvo tarkoittaa tehokkaampaa jäähdytystä. Anna tietty arvo, jos sinulla on sellainen.',
        nominalLoad:
          'Nimelliskuorma (0-1) kuvaa, mille osuudelle täydestä kapasiteetista yksikkö on mitoitettu toimimaan normaalisti. Tämä on yksityiskohtakenttä ja voidaan yleensä jättää vakioarvoon.',
        minimumLoad:
          'Vähimmäiskuorma (0-1) on pienin osuus täydestä kapasiteetista, jolla yksikkö voi käydä vakaasti ennen kuin sen on kytkeydyttävä päälle ja pois. Anna arvo, jos haluat ohittaa vakioarvon.',
        degradeCoeff:
          'Heikkenemiskerroin (0-1) kuvaa, kuinka paljon hyötysuhde laskee, kun yksikkö käy osakuormalla täyden tehon sijaan. Invertteriohjatuilla yksiköillä on yleensä pienemmät häviöt. Asetetaan usein automaattisesti.',
        maxTemperatureSupplied:
          'Suurin menolämpötila on korkein lämpötila, jonka yksikkö voi tuottaa lämmönluovutusjärjestelmään. Se ratkaisee, kattaako yksikkö lämpötilatarpeen, esimerkiksi korkeaa menolämpötilaa vaativille pattereille.',
      },
      domesticHotWater: {
        name: 'Anna käyttövesikomponentille selkeä nimi, jos rekisteröit useita yksiköitä tai osajärjestelmiä.',
        heaterType:
          'Lämmitystyyppi kuvaa, miten käyttövesi lämmitetään, esimerkiksi suoralla sähkölämmittimellä, lämpöpumpulla tai keskitetyllä syötöllä kuten kaukolämmöllä. Valinta vaikuttaa sekä lämpimän käyttöveden energiantarpeeseen että päästöihin.',
        tapFrequency:
          'Vedenottotaajuus kuvaa, kuinka usein ja kuinka paljon lämmintä vettä otetaan, ja heijastaa vyöhykkeen todellista käyttötapaa. Se on tärkeä tekijä lasketussa käyttöveden energiantarpeessa.',
        tapCyclesPerDay:
          'Vedenottosyklien määrä vuorokaudessa on se, kuinka monta kertaa lämmintä vettä otetaan vuorokauden aikana. Anna arvo, jos haluat ohittaa vakioprofiilin tarkemmalla luvulla.',
        thermalZone:
          'Liitä käyttövesijärjestelmä siihen termiseen vyöhykkeeseen, jota se palvelee. Tämä sijoittaa energiankäytön ja mahdollisen lämmönluovutuksen oikein malliin.',
      },
      productionEquipment: {
        name: 'Anna tuotantolaitteistolle selkeä nimi. Käytetään kuorman tunnistamiseen projektissa ja raporteissa.',
        energySource:
          'Energialähde on se, mitä tuotantolaitteisto käyttää, esimerkiksi sähkö tai kaasu. Sitä käytetään energiankäytön jakamiseen oikealle energianlähteelle ja mahdolliseen päästölaskentaan.',
        power:
          'Nimellisteho on laitteiston tyypillinen tehonotto kilowatteina. Yhdessä käyttöaikataulun kanssa se antaa perustan energiankäytön ja vyöhykkeeseen luovutettavan lämmön laskennalle.',
        eligibleForHarvesting:
          'Energian talteenotto tarkoittaa laitteiston ylijäämälämmön hyödyntämistä muihin tarkoituksiin, esimerkiksi lämmitykseen. Rastita tämä, jos laitteisto luovuttaa tällaista ylijäämäenergiaa, jolloin talteenottopotentiaali arvioidaan.',
        operationalSchedule:
          'Käyttöaikataulu kuvaa, milloin laitteisto on todella käytössä vuorokauden ja viikon aikana. Lisää se, jos laitteisto ei noudata normaalia käyttöaikaa, jotta energiankäyttö ja sisäiset kuormat lasketaan realistisemmin.',
      },
      hvac: {
        name: 'Anna ilmanvaihtokoneelle selkeä nimi. Nimeä käytetään tunnistamiseen, jos rakennuksessa on useita koneita.',
        linkedZones:
          'Liitetyt vyöhykkeet ovat ne termiset vyöhykkeet, joita ilmanvaihtokone palvelee ilmalla. Valinta on tarpeen ilmamäärien, puhallinenergian ja lämmöntalteenoton jakamiseksi oikein vyöhykkeiden kesken.',
        flowSfpSettings:
          'Tässä annat koneen ilmamäärät ja SFP-oletukset. SFP (ominaissähköteho) ilmaisee, kuinka paljon sähkötehoa puhaltimet käyttävät ilmamäärää kohti, ja on ilmanvaihtolaskennan ydintietoa.',
        motorType:
          'Moottorityyppi, esimerkiksi AC tai EC, vaikuttaa puhaltimen hyötysuhteeseen ja siihen, miten teho muuttuu osakuormalla. Valitse tyyppi, jos se on tiedossa, tarkempaa laskentaa varten.',
        sfp100:
          'SFP (ominaissähköteho) on puhaltimien tehonoton suhde ilmamäärään, ilmoitettuna kilowatteina m³/s kohti. Pienempi SFP tarkoittaa energiatehokkaampaa puhallinta. Anna arvo 100 %:n käytöllä, tämä on ilmanvaihtolaskennan pääparametri.',
        sfp80:
          'SFP 80 %:n käytöllä kuvaa ominaissähkötehoa, kun kone käy pienennetyllä ilmamäärällä. Anna se, jos sinulla on osakuormatiedot, muuten kentän voi jättää tyhjäksi.',
        sfp60:
          'SFP 60 %:n käytöllä kuvaa ominaissähkötehoa pienemmällä ilmamäärällä. Käytetään vain osakuorman tarkemmassa mallinnuksessa.',
        sfp40:
          'SFP 40 %:n käytöllä. Anna se, jos näin pienen ilmamäärän osakuormatiedot ovat saatavilla.',
        sfp20:
          'SFP 20 %:n käytöllä. Anna se, jos näin pienen ilmamäärän osakuormatiedot ovat saatavilla.',
        fanPowerIn:
          'Tuloilmapuhaltimen teho on tuloilmapuhaltimen sähköinen tehonotto kilowatteina. Anna se, jos sinulla on se erikseen. Kentän voi normaalisti jättää tyhjäksi, kun SFP on rekisteröity, koska teho lasketaan silloin siitä.',
        fanPowerOut:
          'Poistoilmapuhaltimen teho on poistoilmapuhaltimen sähköinen tehonotto kilowatteina. Anna se, jos sinulla on se erikseen. Käytetään vain tarkemmassa rekisteröinnissä.',
        coverageArea:
          'Kattavuusala on lattiapinta-ala, jota kone palvelee, neliömetreinä. Anna se, jos kone kattaa vain osan rakennuksesta tai vyöhykkeestä. Voidaan usein johtaa liitetyistä vyöhykkeistä.',
        coverageVolume:
          'Kattavuustilavuus on ilmatilavuus, jota kone palvelee, kuutiometreinä. Anna se, jos se on tiedossa. Käytetään detaljikenttänä ilmanvaihdon mitoituksessa.',
        airVolumeOperating:
          'Tuloilmamäärä käytössä on ilmamäärä, jonka kone tuottaa normaalin käytön aikana, yksikössä m³/h. Tämä on keskeinen lähtötieto ilmanvaihtotarpeelle, puhallinenergialle sekä lämmitys- ja jäähdytyspattereille.',
        airVolumeCapacity:
          'Tuloilmakapasiteetti on suurin ilmamäärä, jonka kone voi tuottaa, yksikössä m³/h. Anna se, jos se on tiedossa. Hyödyllinen kapasiteettiarvioinneissa, mutta ei aina tarpeen.',
        airVolumeNonOperating:
          'Tuloilmamäärä käytön ulkopuolella on ilmamäärä, jonka kone tuottaa, kun rakennus ei ole käytössä, esimerkiksi pienennetyssä yökäytössä. Anna se, jos kone käy pienennetyllä ilmamäärällä osan ajasta.',
        airVolumeExtractionOperating:
          'Poistoilmamäärä käytössä on ilma, jonka kone poistaa vyöhykkeistä normaalin käytön aikana, yksikössä m³/h. Yhdessä tuloilmamäärän kanssa se kuvaa koneen todellista ilmatasapainoa ja vaikuttaa puhallinenergiaan ja lämmöntalteenottoon.',
        airVolumeExtractionCapacity:
          'Poistoilmakapasiteetti on suurin ilmamäärä, jonka kone voi poistaa, yksikössä m³/h. Anna se, jos se on tiedossa. Hyödyllinen kapasiteettiarvioinneissa, mutta ei aina tarpeen.',
        airVolumeExtractionNonOperating:
          'Poistoilmamäärä käytön ulkopuolella on ilma, jonka kone poistaa, kun rakennus ei ole käytössä, esimerkiksi yöpudotuksessa tai pienennetyssä käytössä. Anna se, jos kone käy pienennetyllä ilmamäärällä osan ajasta.',
        supplyTemperature:
          'Tuloilman lämpötila on sen ilman lämpötila, jonka kone puhaltaa vyöhykkeeseen, yksikössä °C. Käyttöaikataulun asetusarvot ovat etusijalla: tätä arvoa käytetään vain tunneille, joilla aikataulussa ei ole asetusarvoa. Muuta tuloilman asetusarvoa käyttöaikataulussa.',
        heatRecoveryType:
          'Lämmöntalteenotto käyttää poistoilman lämmön uudelleen tuloilman esilämmitykseen, mikä vähentää lämmitystarvetta. Valitse asennettu tyyppi, esimerkiksi pyörivä lämmönsiirrin, levylämmönsiirrin tai nestekiertoinen patteri. Valinta on tärkeä talteen otetun energian laskennalle.',
        efficiencyHR:
          'Hyötysuhde ilmaisee, kuinka suuren osan poistoilman lämmöstä talteenotto todella siirtää tuloilmaan, prosentteina. Suurempi arvo tarkoittaa pienempää lämmitystarvetta. Anna dokumentoitu arvo, jos sinulla on sellainen, muuten käytetään valitun tyypin mukaista vakioarvoa.',
        frostProtection:
          'Jäätymisenesto estää lämmöntalteenottoa jäätymästä matalissa ulkolämpötiloissa, mutta voi ajoittain vähentää talteen otettavan lämmön määrää. Rastita tämä, jos koneessa on jäätymisenesto, joka vaikuttaa käyttöön tai lämmöntalteenottoon. Hyödyllinen tarkemmassa mallinnuksessa.',
        frostProtectionTemperature:
          'Tämä on ulkolämpötila, jossa jäätymisenesto aktivoituu. Tämän lämpötilan alapuolella talteenottoa vähennetään tai säädetään jäätymisen välttämiseksi. Anna arvo, jos se on tiedossa, muuten käytetään vakioarvoa.',
        measuredSupplyTemp:
          'Mitattu tuloilman lämpötila on sen ilman todellinen lämpötila, jonka kone puhaltaa sisään, kirjattuna katselmuksessa tai loggauksessa. Anna se, jos sinulla on kenttämittauksia. Käytetään laadunvarmistukseen ja mallin tarkempaan kalibrointiin.',
        measuredExhaustTemp:
          'Mitattu poistoilman lämpötila on vyöhykkeistä ulos vedettävän ilman todellinen lämpötila, kirjattuna kenttämittauksella. Anna se, jos sinulla on tällaisia mittauksia. Yhdessä mitatun tuloilman lämpötilan kanssa sitä käytetään laadunvarmistukseen.',
        dx: {
          name: 'DX-järjestelmä (suora höyrystys) on jäähdytys- tai lämpöpumppupatteri, jossa kylmäaine höyrystyy suoraan ilmavirrassa ilman välissä olevaa vesipiiriä. Anna yksikölle selkeä nimi tunnistamista varten, jos koneessa on tällainen integroitu DX-yksikkö.',
          type: 'Tyyppi ilmaisee, mitä DX-yksikkö voi tehdä: vain jäähdytys, vain lämmitys tai molemmat (lämpöpumpputoiminto). Valinta ohjaa, mitkä teho- ja hyötysuhdekentät ovat relevantteja.',
          heatingEffect:
            'Lämpöteho on suurin lämpö, jonka DX-yksikkö voi luovuttaa ilmaan, kilowatteina. Anna se, jos järjestelmä tuottaa lämpöä. Voidaan jättää tyhjäksi, jos yksikköä käytetään vain jäähdytykseen.',
          coolingEffect:
            'Jäähdytysteho on suurin jäähdytys, jonka DX-yksikkö voi luovuttaa ilmaan, kilowatteina. Tämä on normaalisti tärkein kapasiteettiarvo jäähdytyskäytölle.',
          seasonalCop:
            'Kausi-COP on DX-yksikön keskimääräinen hyötysuhde lämmitykselle kauden aikana: tuotetun lämmön suhde syötettyyn sähköön. Anna se, jos yksikköä käytetään myös lämmitykseen. Käytä vakioarvoa, jos tarkkaa dokumentaatiota ei ole.',
          seasonalEer:
            'Kausi-EER on DX-yksikön keskimääräinen hyötysuhde jäähdytykselle kauden aikana: tuotetun jäähdytyksen suhde syötettyyn sähköön. Anna se, jos se on tiedossa. Käytetään jäähdytyksen sähkönkulutuksen laskemiseen.',
          systemEfficiency:
            'Laskenta käyttää järjestelmähyötysuhdetta DX-yksikön omana hyötysuhteena, prosentteina: 300 % tarkoittaa kolme kertaa niin paljon lämpöä tai jäähdytystä kuin sähköä. Kausi-COP/EER-kenttiä ei vielä käytetä, joten syötä COP tai EER tähän prosentteina. Jos kenttä jätetään tyhjäksi, käytetään 100 %.',
          energySource:
            'Energialähde on se, mitä DX-yksikkö käyttää lämmityksen tai jäähdytyksen tuottamiseen, normaalisti sähkö. Sitä käytetään energian jakamiseen ja mahdolliseen päästölaskentaan.',
        },
        heatingBattery: {
          name: 'Lämmityspatteri ilmanvaihdossa on koneen lämmönsiirrin, joka lämmittää tuloilman, tyypillisesti syötettynä lämpimällä vedellä kattilasta tai lämpöpumpusta, tai sähköisesti. Anna patterille selkeä nimi, jos samassa koneessa tai rakennuksessa on useita pattereita.',
          type: 'Patterityyppi ilmaisee, miten lämpö tuodaan, esimerkiksi vesikiertoinen (lämmin vesi patterin läpi) tai sähköinen. Valinta vaikuttaa energialähteeseen ja hyötysuhteeseen.',
          power:
            'Teho on suurin lämpö, jonka patteri voi tuoda tuloilmaan, kilowatteina. Käytetään kapasiteetin tarkistukseen ja energialaskentaan.',
          systemEfficiency:
            'Järjestelmän hyötysuhde ottaa huomioon jakelun ja säädön häviöt patterille asti. Anna arvo, jos sinulla on parempi luku kuin vakio, muuten kentän voi jättää tyhjäksi.',
          energySource:
            'Energialähde on se, mikä toimittaa lämmityspatterille lämpöä, esimerkiksi kaukolämpö, kattila, lämpöpumppu tai sähkö. Sitä käytetään energian jakamiseen ja mahdolliseen päästölaskentaan.',
        },
        coolingBattery: {
          name: 'Jäähdytyspatteri ilmanvaihdossa on koneen lämmönsiirrin, joka jäähdyttää tuloilman, tyypillisesti syötettynä kylmällä vedellä jäähdytyskoneesta tai suoralla höyrystyksellä (DX). Anna patterille selkeä nimi, jos pattereita on useita.',
          type: 'Tyyppi ilmaisee, miten jäähdytys tuodaan, esimerkiksi vesikiertoinen (kylmä vesi patterin läpi) tai DX (suora höyrystys). Valinta vaikuttaa energialähteeseen ja hyötysuhteeseen.',
          power:
            'Teho on suurin jäähdytys, jonka patteri voi tuoda tuloilmaan, kilowatteina. Käytetään kapasiteetin tarkistukseen ja energialaskentaan.',
          systemEfficiency:
            'Järjestelmän hyötysuhde ottaa huomioon jakelun ja säädön lisähäviöt nimellissuorituskyvyn lisäksi. Anna arvo, jos haluat sisällyttää tällaiset häviöt, muuten kentän voi jättää tyhjäksi.',
          eer: 'EER (Energy Efficiency Ratio) on jäähdytyspatterin hyötysuhde: tuotetun jäähdytyksen suhde syötettyyn sähköön. Anna se, jos se on tiedossa. Käytetään jäähdytyksen sähkönkulutuksen laskemiseen.',
          energySource:
            'Energialähde on se, mikä toimittaa jäähdytyspatterille jäähdytystä, esimerkiksi jäähdytyskone, kaukojäähdytys tai DX. Sitä käytetään energian jakamiseen ja mahdolliseen päästölaskentaan.',
        },
        naturalVentilation:
          'Painovoimainen ilmanvaihto on tuulen ja lämpötilaerojen aikaansaamaa ilmanvaihtoa ikkunoiden, venttiilien tai hormien kautta, ilman puhaltimia. Ota tämä käyttöön, jos vyöhykkeellä tai koneessa on painovoimainen ilmanvaihto, joka halutaan sisällyttää malliin.',
        operationalSchedule:
          'Käyttöaikataulu kuvaa, milloin ilmanvaihto on käynnissä vuorokauden ja viikon aikana. Lisää aikataulu painovoimaiselle ilmanvaihdolle tai koneen käytölle, jos käyttö poikkeaa vakiokäyttöajasta.',
        operationalScheduleExtra:
          'Käytä ylimääräistä aikataulua, kun samalla koneella tai ilmanvaihtotoiminnolla on useita käyttöjaksoja, joilla on erilainen käyttö, esimerkiksi vuodenajoittain. Kukin aikataulu kattaa oman jaksonsa.',
      },
      centralEnergy: {
        name: 'Keskitetty energiamoduuli on yhteinen energiakeskus, joka palvelee useita vyöhykkeitä tai toimintoja, esimerkiksi lämpökeskus tai jäähdytyskonekeskus. Anna sille selkeä nimi. Nimeä käytetään vain tunnistamiseen.',
        mode: 'Tila ilmaisee, tuottaako keskus lämmitystä, jäähdytystä, lämmintä käyttövettä vai näiden yhdistelmiä. Tämä on perusasetus, joka ohjaa, miten keskusta käytetään mallissa.',
        thermalZone:
          'Keskus voidaan kytkeä termiseen vyöhykkeeseen, jolloin keskuksen ympäristön lämpötila seuraa vyöhykettä, mikä vaikuttaa hyötysuhteeseen ja häviöihin. Kytke se relevanttiin vyöhykkeeseen, jos sijainti tai ympäristön lämpötila on tärkeä laskennalle, muuten se voi olla erillinen.',
        ambientTemperature:
          'Ympäristön lämpötila on sen tilan lämpötila, jossa keskus sijaitsee, esimerkiksi teknisen tilan. Sitä käytetään vain, kun keskusta ei ole kytketty termiseen vyöhykkeeseen, ja se vaikuttaa keskuksen ja varaajien lämpöhäviöihin. Jos vyöhyke on valittu, lämpötila otetaan sieltä.',
        sourceName:
          'Anna energialähteelle selkeä nimi, jotta se on helppo tunnistaa, jos keskuksessa on useita energialähteitä. Nimeä käytetään vain tunnistamiseen.',
        usage:
          'Nämä valinnat ohjaavat, mitä energialähde todella kattaa: lämmityksen, jäähdytyksen ja/tai lämpimän käyttöveden. Valitse tarpeet, joihin lähde osallistuu. Invertteriohjattu tarkoittaa, että yksikkö voi moduloida tehoaan, mikä parantaa hyötysuhdetta osakuormalla.',
        heatPump: {
          type: 'Lämpöpumpputyyppi kuvaa, mistä lämpöpumppu ottaa energiaa ja mihin se sen luovuttaa: ilma-vesi ottaa energiaa ulkoilmasta ja luovuttaa vesikiertoiseen lämmitykseen, neste-vesi ottaa maasta, kalliosta tai vedestä keruupiirin kautta, ja ilma-ilma lämmittää sisäilman suoraan. Valinta vaikuttaa hyötysuhteeseen ja siihen, mitkä lisäkentät näytetään.',
          co2eEmissionFactor:
            'CO₂e-päästökerroin ilmaisee, kuinka paljon kasvihuonekaasupäästöjä liittyy lämpöpumpun käyttämään energiaan, ilmoitettuna kilowattituntia kohti. Anna tietty arvo vain, jos haluat laskea päästöt tarkasti. Se ei vaikuta itse energiantarpeeseen.',
          heatingCapacity:
            'Lämpökapasiteetti on lämpöpumpun nimellinen lämpöteho kilowatteina, eli kuinka paljon lämpöä se voi tuottaa normaaleissa olosuhteissa. Tämä on tärkein kapasiteettiarvo ja sitä käytetään arvioimaan, kattaako pumppu lämmöntarpeen.',
          nominalLoad:
            'Nimelliskuorma (0-1) on se osuus täydestä kapasiteetista, jolla lämpöpumppu on mitoitettu toimimaan normaalisti. Anna se, jos dokumentaatio ilmoittaa sen erikseen. Käytetään yksityiskohtaisessa osakuormamallinnuksessa.',
          minimumLoad:
            'Vähimmäiskuorma (0-1) on pienin osuus täydestä kapasiteetista, jolla lämpöpumppu voi käydä vakaasti ennen kuin sen on kytkeydyttävä päälle ja pois. Anna se, jos pumppu voi moduloida ja tämä on tiedossa.',
          degradeCoeff:
            'Heikkenemiskerroin (0-1) kuvaa, kuinka paljon hyötysuhde laskee, kun lämpöpumppu käy osakuormalla täyden tehon sijaan. Anna se, jos valmistajan tiedot tai laskelmat ovat saatavilla. Voidaan normaalisti jättää tyhjäksi, jolloin se asetetaan arvoon 0,8 NS 3031:n mukaan, tai 0,6 invertteriohjatuille yksiköille.',
          maxTemperatureSupplied:
            'Korkein toimitettu lämpötila on lämpimin menolämpötila, jonka lämpöpumppu voi toimittaa lämmitysjärjestelmään, °C. Lämpöpumppujen hyötysuhde laskee korkealla menolämpötilalla. Käytetään arvioimaan, kattaako pumppu lämpötilatarpeen, esimerkiksi korkeaa lämpötilaa vaativille pattereille.',
          cop: 'COP (Coefficient of Performance) on lämpöpumpun hyötysuhde lämmityksessä: tuotetun lämmön suhde syötettyyn sähköön. COP 3 tarkoittaa kolme kertaa niin paljon lämpöä kuin sähköä. Anna tietty arvo, jos sinulla on sellainen, muuten käytetään vakioarvoja.',
          liquidSource:
            'Nestelähde on väliaine, josta neste-vesi-lämpöpumppu ottaa energiaa keruupiirin kautta, esimerkiksi maa, kallio, makea vesi tai merivesi. Lähde vaikuttaa käytettävissä olevaan lähdelämpötilaan ja siten hyötysuhteeseen.',
          sourceTemperature:
            'Lähdelämpötila on lähteestä lämpöpumppuun tulevan nesteen lämpötila, °C. Korkeampi lähdelämpötila antaa paremman hyötysuhteen. Anna se, jos se on tiedossa mittauksesta tai pohjatutkimuksesta.',
          sourceYearlyAverageTemperature:
            'Vuoden keskilämpötila on lähteen keskimääräinen lämpötila vuoden aikana, °C. Sitä käytetään lähtökohtana lämpöpumpun kausisuorituskyvyn laskennassa. Anna se, jos se on tiedossa, muuten käytetään valitun lähteen tyypillisiä arvoja.',
          liquidMaxTemperature:
            'Tämä on korkein lämpötila, jonka lähde saavuttaa vuoden aikana, °C. Yhdessä vuoden keskilämpötilan ja amplitudin kanssa se kuvaa, miten lähdelämpötila vaihtelee kauden aikana, mikä vaikuttaa hyötysuhteeseen.',
          sourceTemperatureAmplitude:
            'Lämpötila-amplitudi kuvaa, kuinka paljon lähdelämpötila vaihtelee vuoden keskiarvon ylä- ja alapuolella vuoden aikana, °C. Suurempi amplitudi tarkoittaa suurempaa hyötysuhteen vuodenaikaisvaihtelua. Anna se, jos se on tiedossa, muuten käytetään lähteen tyypillisiä arvoja.',
          energyWellDimensioning:
            'Ohjeellisia arvoja energiakaivojen (porakaivojen) vuosikeskilämpötilalle ja vuosiamplitudille. Valitse kuvaus, joka vastaa parhaiten kaivon käyttöä ja mitoitusta; lämpötila-arvot asetetaan sitten automaattisesti paikallisen ilmaston perusteella.',
          waterSourceDepth:
            'Ohjeellisia arvoja vuosikeskilämpötilalle ja vuosiamplitudille lämmönotossa merestä tai makeasta vedestä. Valitse lämmönoton syvyys; lämpötila-arvot asetetaan sitten automaattisesti paikallisen ilmaston perusteella.',
        },
        districtHeating: {
          maxCapacity:
            'Maksimikapasiteetti on suurin teho, jonka kaukolämpö- tai kaukojäähdytysliittymä voi toimittaa rakennukseen, kilowatteina. Anna se, jos se on tiedossa dokumentaatiosta tai laitostiedoista. Käytetään arvioimaan, kattaako lähde tehontarpeen.',
          efficiency:
            'Hyötysuhde kuvaa, kuinka suuri osa kaukolämpöverkosta toimitetusta energiasta muuttuu todella hyödylliseksi lämmöksi rakennuksessa, vaihtimen ja jakelun häviöiden jälkeen. Anna kokonaisarvo, jos haluat ohittaa keskuksen vakioarvot.',
          temperatureFromSource:
            'Lämpötila lähteestä on menolämpötila, jonka kaukolämpö- tai kaukojäähdytysverkko toimittaa lämmönvaihtimeen, °C. Anna se, jos se on tiedossa. Antaa realistisemman kuvauksen keskuksen toiminnasta ja hyötysuhteesta.',
          heatExchangerLoss:
            'Lämmönvaihdin siirtää energiaa kaukolämpöverkosta rakennuksen omaan järjestelmään, ja osa energiasta häviää matkalla. Valitse eristystaso ja ulostulolämpötila-alue kuvataksesi häviön tarkemmin, tai anna häviökerroin suoraan, jos dokumentoitu arvo on olemassa. Jätä kentät tyhjiksi käyttääksesi vakioarvoja.',
          distributionHeatLoss:
            'Jakelun lämpöhäviö on energiaa, joka häviää putkiverkostossa keskuksen ja rakennuksen järjestelmän välillä. Valitse jakelun syöttölämpötila-alue kuvataksesi häviön tarkemmin, tai anna häviökerroin suoraan, jos se on tiedossa. Jätä kentät tyhjiksi käyttääksesi vakioarvoja.',
          coolingHeatExchanger:
            'Jäähdytysvaihdin siirtää jäähdytystä kaukojäähdytyksestä tai jäähdytyskeskuksesta rakennuksen järjestelmään, ja osa energiasta häviää. Valitse eristystaso, jos jäähdytyspuoli halutaan mallintaa tarkemmin, tai anna U-arvo suoraan, jos se on tiedossa. Jätä kentät tyhjiksi käyttääksesi vakioarvoja.',
          co2eEmissionFactor:
            'CO₂e-päästökerroin ilmaisee, kuinka paljon kasvihuonekaasupäästöjä liittyy kaukolämmön tai kaukojäähdytyksen energiaan, ilmoitettuna grammoina kilowattituntia kohti. Anna tietty arvo, jos haluat käyttää verkon todellista päästölukua. Se vaikuttaa vain päästölaskentaan, ei itse energiantarpeeseen.',
          energyPrice:
            'Energiahinta on kaukolämmöstä tai kaukojäähdytyksestä toimitetun energian hinta kilowattituntia kohti. Anna tietty hinta, jos haluat kustannuslaskelmat todellisilla hinnoilla, muuten kentän voi jättää tyhjäksi. Vaikuttaa vain kustannuslukuihin, ei energiaan tai päästöihin.',
        },
        combustionBoiler: {
          boilerType:
            'Kattilatyyppi kuvaa, millainen polttokattila laitos on, esimerkiksi öljy, kaasu tai biomassa. Valitse se, joka kuvaa laitosta parhaiten. Valinta ohjaa vakio-oletuksia kuten hyötysuhdetta ja päästötasoa.',
          heatingCapacity:
            'Lämpökapasiteetti on kattilan nimellinen lämpöteho kilowatteina, eli kuinka paljon tehoa se voi tuottaa normaaleissa olosuhteissa. Tämä on pääarvo arvioitaessa, kattaako kattila tehontarpeen.',
          performance:
            'Suorituskyky ilmaisee kattilan nimellisen hyötysuhdetason, eli kuinka tehokkaasti polttoaine muunnetaan hyödylliseksi lämmöksi. Valitse tai anna taso, jos se on dokumentoitu kattilalle, muuten käytetään vakioarvoja.',
          fuelSource:
            'Polttoainelähde on se, mitä kattila polttaa, esimerkiksi öljy, kaasu tai biopolttoaine. Valinta määrää polttoaineen vakioenergiasisällön ja päästökertoimen, ja vaikuttaa siten sekä energia- että päästölaskentaan.',
          fuelEnergyContent:
            'Energiasisältö on se, kuinka paljon energiaa polttoaine sisältää yksikköä kohti, esimerkiksi kWh litraa kohti. Anna tietty arvo, jos haluat tarkemmat lähtöoletukset kuin valitun polttoaineen vakioarvot.',
          co2eEmissionFactor:
            'CO₂e-päästökerroin ilmaisee, kuinka paljon kasvihuonekaasupäästöjä polttoaineen poltto tuottaa, ilmoitettuna grammoina kilowattituntia kohti. Anna tietty arvo, jos haluat tarkan päästölaskennan. Se vaikuttaa vain päästölaskentaan, ei energiantarpeeseen.',
          efficiencyAtLowerLoad:
            'Tämä on kattilan lämpöteho, kun se käy noin 30 %:n kuormalla täydestä, kilowatteina. Arvo vaaditaan yhdessä täyskuorma-arvon kanssa, jotta simulointi voi mallintaa kattilan osakuormakäyttäytymisen.',
          effectAtFullLoad:
            'Tämä on kattilan lämpöteho täydellä kuormalla kilowatteina, eli kuinka paljon tehoa se tuottaa enimmäiskäytössä. Arvo vaaditaan, jotta simulointi mitoittaa kattilan oikein.',
          isCondensing:
            'Lauhdutuskattila ottaa talteen myös savukaasun vesihöyryn lämmön ja saavuttaa siten korkeamman hyötysuhteen kuin tavallinen kattila. Rastita tämä, jos kattila on lauhduttava.',
          isCHP:
            'Yhteistuotantolaitos (CHP) tuottaa sekä sähköä että lämpöä samanaikaisesti samasta polttoaineesta, mikä antaa korkean kokonaisenergiahyödyn. Rastita tämä, jos laitos on CHP-laitos, jolloin näytetään omat CHP-asetukset.',
          scheduleStart:
            'Aloitusajankohta on se, milloin kattilan käyttökausi alkaa, ilmoitettuna päivänä ja kuukautena. Täytä tämä, jos kattila ei käy jatkuvasti tai ei noudata vakiokäyttöprofiilia, esimerkiksi kattila, jota käytetään vain lämmityskaudella.',
          scheduleEnd:
            'Lopetusajankohta on se, milloin kattilan käyttökausi päättyy, ilmoitettuna päivänä ja kuukautena. Täytetään yhdessä aloitusajankohdan kanssa kuvaamaan jaksoa, jolloin kattila on käytössä.',
          seasonalMeanTemp:
            'Kauden keskilämpötila on käyttökauden keskimääräinen ulkolämpötila, °C. Anna se, jos laitos halutaan kuvata yksityiskohtaisemmilla lämpötilaoletuksilla kuin vakio.',
          temperatureSupply:
            'Menolämpötila on sen veden lämpötila, jonka kattila lähettää lämmitysjärjestelmään, °C. Matalampi menolämpötila antaa usein paremman hyötysuhteen, erityisesti lauhdutuskattiloille. Anna se, jos se on tiedossa.',
          temperatureReturn:
            'Paluulämpötila on sen veden lämpötila, joka palaa kattilaan lämmitysjärjestelmästä, °C. Lauhdutuskattiloille matala paluulämpötila on tärkeä lauhtumisen ja korkean hyötysuhteen saavuttamiseksi. Anna se, jos se on tiedossa.',
        },
        electricBoiler: {
          maxCapacity:
            'Maksimikapasiteetti on suurin teho, jonka sähkökattila voi tuottaa, kilowatteina. Tämä on pääarvo arvioitaessa, kattaako kattila tehontarpeen.',
          insulationGrade:
            'Eristysaste kuvaa, kuinka hyvin itse kattila on eristetty, ja määrää, kuinka paljon lämpöä se menettää ympäristöön ollessaan päällä. Valitse aste, jos haluat tarkemman mallinnuksen kattilan lämpöhäviöstä.',
          efficiency:
            'Hyötysuhde kuvaa, kuinka suuri osa syötetystä sähköstä muuttuu hyödylliseksi lämmöksi kattilan häviöiden jälkeen. Sähkökattiloilla on normaalisti korkea hyötysuhde. Anna arvo, jos haluat ohittaa vakio-oletukset.',
          co2eEmissionFactor:
            'CO₂e-päästökerroin ilmaisee, kuinka paljon kasvihuonekaasupäästöjä liittyy kattilan käyttämään sähköön, ilmoitettuna grammoina kilowattituntia kohti. Anna tietty arvo, jos haluat tarkan päästölaskennan. Se vaikuttaa vain päästölaskentaan, ei energiantarpeeseen.',
          temperatureSupply:
            'Menolämpötila on sen veden lämpötila, jonka kattila lähettää lämmitysjärjestelmään, °C. Se vaikuttaa siihen, mitä lämmönluovuttimia kattila voi palvella, ja järjestelmän lämpöhäviöön. Anna se, jos se on tiedossa.',
          temperatureReturn:
            'Paluulämpötila on sen veden lämpötila, joka palaa kattilaan lämmitysjärjestelmästä, °C. Yhdessä menolämpötilan kanssa se kuvaa järjestelmän lämpötilatasoa. Anna se, jos se on tiedossa.',
        },
        solarThermal: {
          solarType:
            'Aurinkokeräintyyppi kuvaa keräinperiaatetta, esimerkiksi tasokeräin tai tyhjiöputkikeräin. Tyhjiöputkikeräimet toimivat yleensä paremmin matalissa ulkolämpötiloissa. Valinta vaikuttaa laitoksen tuoton vakio-oletuksiin.',
          azimuth:
            'Atsimuutti on keräinten suuntaus ilmansuuntaan asteina, jossa 0 tarkoittaa yleensä suoraan etelään. Se kuvaa, mihin suuntaan keräimet osoittavat, ja vaikuttaa voimakkaasti siihen, kuinka paljon auringon energiaa ne keräävät.',
          tilt: 'Kallistus on keräinten kulma vaakatasosta asteina, jossa 0 on vaaka ja 90 pysty. Yhdessä atsimuutin kanssa se määrää, kuinka paljon auringonsäteilyä keräimet saavat vuoden aikana.',
          adjustmentFactor:
            'Korjauskerroin skaalaa lasketun aurinkotuoton ylös tai alas paikallisten olosuhteiden, kuten varjostuksen tai likaantumisen, huomioon ottamiseksi. Anna arvo vain, jos haluat korjata vakiolaskentaa, muuten kentän voi jättää tyhjäksi.',
          performance:
            'Suorituskyky ilmaisee aurinkolämpölaitoksen nimellisen hyötysuhde- tai kapasiteettitason, eli kuinka tehokkaasti keräimet muuntavat auringonsäteilyn hyödylliseksi lämmöksi. Valitse tai anna taso, jos se on tiedossa dokumentaatiosta, muuten käytetään vakioarvoja.',
          pipeLength:
            'Putkipituus on keräinten ja varaajan välisten putkien kokonaispituus metreinä. Pidemmät putket aiheuttavat suuremman lämpöhäviön. Anna se yhdessä putkieristystyypin kanssa, jos haluat laskea putkihäviöt tarkemmin.',
          pipeInsulationType:
            'Putkieristystyyppi kuvaa, kuinka hyvin keräinten ja varaajan väliset putket on eristetty, mikä määrää vakiolämpöhäviön putkimetriä kohti. Valitse se, jos tiedossa, muuten käytetään vakioarvoa.',
          pipeUValue:
            'Putkien U-arvo ilmaisee, kuinka paljon keräinpiirin putket menettävät lämpöä metriä ja lämpötilaeron astetta kohti (W/mK). Pienempi arvo tarkoittaa parempaa eristystä. Anna se, jos se on tiedossa, muuten se johdetaan valitusta putkieristystyypistä.',
          collectorArea:
            'Keräinala on aurinkokeräinten kokonaisaktiivinen ala neliömetreinä. Tämä on keskeinen lähtötieto tuotantolaskennalle, koska suurempi keräinala tuottaa enemmän aurinkoenergiaa.',
          tankSpiralPlacementFactor:
            'Säiliökierukan sijaintikerroin kuvaa, missä kohtaa varaajaa aurinkolämmön kierukka sijaitsee, mikä vaikuttaa siihen, kuinka tehokkaasti aurinkolämpö siirtyy veteen. Anna arvo, jos sinulla on järjestelmän yksityiskohtaiset tiedot, muuten käytetään vakioarvoa.',
          temperatureColdWater:
            'Kylmän veden lämpötila on järjestelmään tulevan veden lämpötila ennen kuin keräimet lämmittävät sen, °C. Matalampi kylmän veden lämpötila antaa suuremman aurinkotuoton. Anna arvo, jos haluat ohittaa vakioarvon.',
          percentageOfCollectorLoopOutside:
            'Tämä on se osuus keräinpiiristä (putket ja komponentit), joka sijaitsee ulkona, prosentteina. Ulkona kulkevat putket menettävät enemmän lämpöä. Anna arvo, jos tämä on oleellinen häviölaskennalle.',
          collectorSpecs:
            'Nämä arvot muodostavat keräimen hyötysuhdekäyrän, joka on otettu tuotetietolomakkeesta tai Solar Keymark -sertifikaatista. η₀ on optinen hyötysuhde ilman lämpötilaeroa, kun taas lämpöhäviökertoimet a₁ ja a₂ kuvaavat, kuinka nopeasti hyötysuhde laskee, kun keräin lämpenee ympäristöään lämpimämmäksi. Anna arvot, jos dokumentaatio on olemassa, muuten käytetään vakioarvoja.',
          snowCoverageMonths:
            'Valitse, minä kuukausina aurinkokeräimet ovat yleensä lumen peitossa. Näinä kuukausina keräimet tuottavat vähän tai ei lainkaan energiaa, joten tämä antaa realistisemman vuosilaskennan, jossa lumi vaikuttaa tuotantoon.',
          insulationFactorForCollectionLoop:
            'Keräinpiirin eristyskerroin kuvaa, kuinka hyvin aurinkolämpöpiirin putket ja komponentit on kokonaisuutena eristetty. Valitse taso, jos haluat tarkemman laskennan piirin lämpöhäviöstä, muuten käytetään vakioarvoa.',
        },
        otherSource: {
          fuelType:
            'Polttoainetyyppi on energianlähde, jota tämä toimitus käyttää, esimerkiksi öljy, kaasu, biopolttoaine, kaukolämpö tai sähkö. Valinta määrää vakiopäästökertoimen ja sen, miten energia kirjataan laskentaan.',
          maxCapacity:
            'Maksimikapasiteetti on suurin teho, jonka tämä energialähde voi tuottaa, kilowatteina. Tämä on pääarvo arvioitaessa, kattaako lähde tehontarpeen.',
          efficiency:
            'Hyötysuhde kuvaa, kuinka suuri osa syötetystä energiasta muuttuu hyödylliseksi lämmöksi tai jäähdytykseksi lähteen häviöiden jälkeen. Anna arvo, jos se on tiedossa, muuten käytetään vakio-oletusta.',
          co2eEmissionFactor:
            'CO₂e-päästökerroin ilmaisee, kuinka paljon kasvihuonekaasupäästöjä liittyy tämän lähteen käyttämään energiaan, ilmoitettuna grammoina kilowattituntia kohti. Anna tietty arvo, jos haluat tarkan päästölaskennan. Se vaikuttaa vain päästölaskentaan, ei energiantarpeeseen.',
          energyPrice:
            'Energiahinta on tästä lähteestä saatavan energian hinta kilowattituntia kohti. Anna tietty hinta, jos haluat kustannuslaskelmat todellisilla hinnoilla, muuten kentän voi jättää tyhjäksi. Vaikuttaa vain kustannuslukuihin, ei energiaan tai päästöihin.',
        },
        accumulationTank: {
          purpose:
            'Varaaja varastoi lämpöä tai jäähdytystä, jotta tuotantoa ja kulutusta voidaan siirtää ajassa. Valitse käyttötarkoitus, esimerkiksi lämpövarasto, kylmävarasto tai lämmin käyttövesi, joka kuvaa säiliön tehtävää järjestelmässä.',
          volume:
            'Tilavuus on säiliön varastointikapasiteetti litroina ja on pääparametri sille, kuinka paljon lämpöä tai jäähdytystä säiliö voi varastoida. Anna se, jos varaaja on olemassa.',
          insulation:
            'Eristystaso kuvaa, kuinka hyvin säiliö on eristetty, ja määrää, kuinka paljon lämpöä menetetään ympäristöön. Valitse taso tai tyyppi, jos tiedossa. Käytetään säiliön lämpöhäviön arvioimiseen tai ohittamiseen.',
          heatLoss:
            'Lämpöhäviö (W/K) ilmaisee, kuinka paljon tehoa säiliö menettää ympäristöön lämpötilaeron astetta kohti. Anna dokumentoitu arvo, jos sinulla on sellainen. Voidaan normaalisti jättää tyhjäksi, jos tilavuus ja vakioeristys ovat riittäviä.',
          setpoint:
            'Asetusarvolämpötila on säiliön haluttu varastointilämpötila, °C. Se ohjaa, kuinka kuumana tai kylmänä väliaine pidetään, ja vaikuttaa sekä häviöihin että kapasiteettiin.',
          maxTemp:
            'Maksimilämpötila on korkein lämpötila, johon säiliön sallitaan nousta, °C. Anna se, jos tämä on tiedossa tai oleellinen säädölle.',
          minTemp:
            'Minimilämpötila on alin lämpötila, johon säiliön sallitaan laskea, °C. Anna se, jos tämä on tiedossa tai oleellinen säädölle.',
          minTempDhw:
            'Minimilämpötila on alin lämpötila, johon säiliön sallitaan laskea, °C. Käyttövesisäiliöissä se tulisi pitää vähintään 70 °C:ssa legionellabakteerien kasvun estämiseksi.',
        },
      },
      excessEnergy: {
        medium:
          'Medium on se, missä ylijäämäenergia virtaa: ilma, esimerkiksi poistoilmakanava, tai neste, esimerkiksi jätevesiputki. Valinta määrää, mitkä kentät näytetään ja miten käytettävissä oleva energia lasketaan.',
        name: 'Anna ylijäämäenergialähteelle selkeä nimi. Nimeä käytetään tunnistamaan mahdolliset talteenoton lähteet, esimerkiksi keittiön poistoilma tai prosessin hukkalämpö.',
        ductShape:
          'Valitse lähteen medium ja kanavan muoto. Kanavan muotoa, esimerkiksi pyöreä tai suorakaide, käytetään yhdessä mittojen kanssa poikkipinta-alan ja siten käytettävissä olevan energiavirran laskemiseen, kun ylijäämäenergia otetaan ilmasta.',
        ductWidthDiameter:
          'Anna kanavan leveys tai halkaisija millimetreinä, jos se on tiedossa. Käytetään yhdessä kanavan muodon ja mahdollisesti korkeuden, ilman nopeuden tai tilavuusvirran kanssa laskemaan, kuinka paljon ilmaa kanavan läpi virtaa.',
        height:
          'Anna kanavan korkeus millimetreinä, jos kanavan muoto sitä edellyttää, esimerkiksi suorakaiteen muotoisessa kanavassa. Yhdessä leveyden kanssa se antaa kanavan poikkipinta-alan.',
        airspeed:
          'Ilman nopeus on se, kuinka nopeasti ilma virtaa kanavan läpi, m/s. Anna se, jos tilavuusvirta ei ole suoraan tiedossa; ilmamäärä lasketaan tällöin nopeuden ja kanavan poikkipinta-alan perusteella.',
        exhaustTempAir:
          'Poistoilman lämpötila on sen ilmavirran lämpötila, josta ylijäämäenergia otetaan, °C. Lämpötila on ratkaiseva arvioitaessa, kuinka paljon energiaa voidaan ottaa talteen; korkeampi lämpötila antaa enemmän käytettävissä olevaa lämpöä.',
        exhaustTempLiquid:
          'Anna sen nestevirran lämpötila, josta ylijäämäenergia otetaan, °C. Lämpötila on ratkaiseva arvioitaessa, kuinka paljon energiaa nesteestä voidaan ottaa talteen.',
        volumeFlowAir:
          'Tilavuusvirta on se, kuinka paljon ilmaa kulkee tunnissa, m³/h. Yhdessä lämpötilan kanssa se määrää, kuinka paljon energiaa on käytettävissä talteenottoon. Anna se, jos se on tiedossa, muuten se voidaan laskea kanavan geometriasta ja ilman nopeudesta.',
        volumeFlowLiquid:
          'Tilavuusvirta on se, kuinka paljon nestettä kulkee tunnissa, L/h. Yhdessä lämpötilan kanssa se määrää, kuinka paljon energiaa on käytettävissä talteenottoon. Anna se, jos se on tiedossa.',
      },
      solarPv: {
        panelAngle:
          'Aurinkopaneelien kallistuskulma vaakatasosta mitattuna, asteina. Katolla litteänä makaava paneeli on 0° ja pystysuorassa oleva paneeli 90°. Kallistus määrää, kuinka suoraan auringonvalo osuu paneeleihin vuoden aikana, ja vaikuttaa siksi voimakkaasti arvioituun vuosituotantoon.',
        name: 'Selkeä ja tunnistettava nimi tälle aurinkosähköjärjestelmälle. Nimeä käytetään järjestelmän tunnistamiseen luetteloissa, tuloksissa ja raporteissa, mikä on hyödyllistä, kun rakennuksessa on useita erillisiä aurinkosähköjärjestelmiä.',
        panelArea:
          'Aurinkopaneelien aktiivinen pinta-ala neliömetreinä. Anna joko yhden paneelin pinta-ala tai koko järjestelmän yhteenlaskettu pinta-ala sen mukaan, miten järjestelmä rekisteröidään, ja aseta Määrä vastaamaan tätä valintaa. Yhdessä hyötysuhteen kanssa pinta-ala on yksi keskeisistä lähtötiedoista, jotka määräävät, kuinka paljon sähköä järjestelmä voi tuottaa.',
        quantity:
          'Aurinkopaneelien lukumäärä järjestelmässä, jos se on tiedossa. Sitä käytetään yhdessä pinta-alan ja hyötysuhteen kanssa asennetun kapasiteetin laskemiseen, ja sen on vastattava tapaa, jolla pinta-ala on annettu: käytä paneelien lukumäärää, kun paneelipinta-ala on paneelikohtainen, ja arvoa 1, kun paneelipinta-ala on järjestelmän yhteispinta-ala.',
        yearInstalled:
          'Vuosi, jolloin aurinkosähköjärjestelmä otettiin käyttöön. Se kirjataan tarkastukseen, mutta laskenta ei käytä sitä: paneelien ikääntyminen lasketaan aina kiinteällä 30 vuoden käyttöiällä vuotuisen heikkenemishäviön avulla.',
        soilingLocation:
          'Sijaintityyppi, joka määrää, kuinka nopeasti pölyä, siitepölyä ja epäpuhtauksia kertyy paneeleihin. Kun valitset sijainnin, esimerkiksi kaupunkimainen, maaseutu tai muu altistuminen, ladataan kyseiselle ympäristölle vakiomuotoinen kuukausittainen likaantumisprofiili, jota voit sitten hienosäätää kuukausittain alla.',
        monthlySoiling:
          'Likaantuminen on tuoton menetys, joka aiheutuu paneelin pinnalla olevasta liasta, pölystä, lumesta ja epäpuhtauksista, ja se vaihtelee vuoden aikana. Sijainnin valinta täyttää yksinkertaistetun vakioprofiilin; anna oma arvosi jokaiselle kuukaudelle tähän, jos haluat korvata profiilin paikkakohtaisilla luvuilla.',
        cellType:
          'Paneelien aurinkokennoteknologia, esimerkiksi yksikiteinen tai monikiteinen pii. Kennotyyppi määrää, kuinka tehokkaasti paneelit muuntavat auringonvalon sähköksi, joten sen valinta asettaa edustavan oletushyötysuhteen, jota voit silti säätää.',
        nominalEfficiency:
          'Osuus tulevasta aurinkoenergiasta, jonka paneelit muuntavat sähköksi vakiotestiolosuhteissa, annettuna desimaalilukuna (esimerkiksi 0,20 eli 20 %). Anna datalehden dokumentoitu arvo, jos se on tiedossa; muuten käytetään valitun kennotyypin oletusarvoa.',
        panelAzimuth:
          'Ilmansuunta, johon paneelit ovat suunnattu, asteina 0–360 (etelä on noin 180° pohjoisella pallonpuoliskolla). Atsimuutti määrää yhdessä kallistuksen kanssa, kuinka suuren osan auringon radasta paneelit keräävät päivän ja vuoden aikana, joten se vaikuttaa suoraan arvioituun tuotantoon.',
        shadingFactor:
          'Osuus auringonvalosta, jonka paneelit menettävät naapurirakennusten, maaston tai kasvillisuuden varjostuksen vuoksi, välillä 0–1. 0 tarkoittaa ei varjostusta ja 1 täysin varjostettua, joten oletusarvo 0,05 on 5 %:n häviö. Arvo kirjataan, mutta laskenta ei vielä käytä sitä.',
        mountingType:
          'Miten paneelit on asennettu, esimerkiksi kattoon integroituna tai vapaasti seisten ilmaraolla. Asennustapa määrää, kuinka hyvin ympäröivä ilma jäähdyttää paneeleita, mikä sisältyy tarkempaan paneelin lämpötila- ja häviömalliin. Valitse se, jos haluat tämän tarkkuustason.',
        windExposure:
          'Kuinka altis järjestelmä on tuulelle. Tuuli jäähdyttää paneeleita ja laskee niiden käyttölämpötilaa, mikä parantaa hyötysuhdetta, joten tätä käytetään yhdessä asennustavan kanssa tarkemmassa paneelin lämpötilamallissa. Valitse se, jos se on tiedossa.',
        heatLossFactor:
          'Kuinka helposti paneelit luovuttavat lämpöä ympäristöönsä, W/m²K. Se johdetaan yleensä asennustavasta ja tuulialtistuksesta, mutta voit antaa tähän arvon korvataksesi nämä vakio-oletukset ja ohjataksesi, miten paneelin lämpötila mallinnetaan.',
        inverterEfficiency:
          'Osuus paneelien tasavirrasta, jonka invertteri toimittaa käyttökelpoisena vaihtovirtana, desimaalilukuna (esimerkiksi 0,945). Se kuvaa invertterin muunnoshäviötä; anna datalehden dokumentoitu arvo, jos se on tiedossa.',
        degradationLoss:
          'Paneelituoton vähittäinen ja pysyvä lasku moduulien ikääntyessä, desimaalilukuna (esimerkiksi 0,005 eli 0,5 % vuodessa). Anna se, jos haluat mallintaa heikentyneen suorituskyvyn järjestelmän elinkaaren aikana tarkemmin.',
        inverterLoss:
          'Invertteriin ja sen toimintaan liittyvät lisähäviöt, desimaalilukuna. Käytä tätä, kun haluat kirjata invertterihäviöt erikseen invertterin hyötysuhteesta sen sijaan, että yhdistäisit ne yhdeksi luvuksi.',
        transmissionProduct:
          'Yhdistetty kerroin (0–1) optisille häviöille, kun valo kulkee paneelin suojalasin läpi ja saavuttaa kennot, kuten heijastus ja absorptio. Anna se desimaalilukuna, kun valittu laskentatapa käyttää tätä termiä.',
        temperatureCoefficient:
          'Kuinka paljon paneelituotto muuttuu lämpötilan mukaan, %/°C. Se on yleensä negatiivinen, koska tuotto laskee, kun paneelit lämpenevät yli sen lämpötilan, jossa ne on mitattu. Anna datalehden dokumentoitu arvo, jos sellainen on näille paneeleille olemassa.',
        incidentAngleModifier:
          'Kerroin (0–1), joka ottaa huomioon ylimääräiset heijastushäviöt, kun auringonvalo osuu paneeliin vinosti suoran osumisen sijaan. Anna se desimaalilukuna, jos haluat käyttää tarkempaa aurinkomallia, joka huomioi nämä tulokulmavaikutukset.',
      },
      battery: {
        name: 'Selkeä ja tunnistettava nimi tälle akulle. Nimeä käytetään akun tunnistamiseen luetteloissa, tuloksissa ja raporteissa, mikä on hyödyllistä, kun rakennuksessa on useita akkuja.',
        maxCapacity:
          'Akun varastoiman energian kokonaismäärä, kWh. Tämä on akkujärjestelmän nimelliskapasiteetti, ja se asettaa ylärajan sille, kuinka paljon aurinkosähkön ylijäämää voidaan varastoida myöhempää käyttöä varten.',
        maxChargePower:
          'Suurin teho, jolla akkua voidaan ladata, kW. Se rajoittaa, kuinka nopeasti akku voi ottaa vastaan aurinkosähkön ylijäämää tai sähköä verkosta.',
        maxDischargePower:
          'Suurin teho, jonka akku voi antaa takaisin rakennukselle, kW. Se rajoittaa, kuinka suuren osan rakennuksen kuormasta akku voi kattaa kullakin hetkellä.',
        chargeEfficiency:
          'Kuinka suuri osuus akkuun syötetystä energiasta todella varastoituu, välillä 0 ja 1. Jätä arvoksi 0, jos haluat käyttää litiumioniakkujen tyypillistä oletusarvoa.',
        dischargeEfficiency:
          'Kuinka suuri osuus varastoidusta energiasta todella saadaan käyttöön akun purkautuessa, välillä 0 ja 1. Jätä arvoksi 0, jos haluat käyttää litiumioniakkujen tyypillistä oletusarvoa.',
        minStateOfCharge:
          'Alin taso, jolle akku saa purkautua, osuutena täydestä kapasiteetista välillä 0 ja 1. Varauksen säilyttäminen suojaa akun käyttöikää. Jätä arvoksi 0, jos haluat käyttää oletusarvoa.',
        maxStateOfCharge:
          'Ylin taso, jolle akku saa latautua, osuutena täydestä kapasiteetista välillä 0 ja 1. Hieman vajaaksi lataaminen suojaa akun käyttöikää. Jätä arvoksi 0, jos haluat käyttää oletusarvoa.',
        peakShavingThreshold:
          'Verkosta otettava teho, jonka alapuolella akku yrittää pitää rakennuksen, kW. Kun rakennus ottaisi verkosta tätä enemmän, akku purkautuu kattamaan erotuksen. Jätä arvoksi 0, jos haluat poistaa tehohuippujen leikkauksen käytöstä; akku varastoi silloin vain aurinkosähkön ylijäämää ja kattaa vajeet.',
        preChargeStateOfCharge:
          'Taso, jolle akku esiladataan verkosta hiljaisina tunteina, osuutena täydestä kapasiteetista välillä 0 ja 1, jotta se on valmis seuraavaan tehohuippuun. Käytetään vain, kun tehohuippujen raja on asetettu. Jätä arvoksi 0, jos haluat poistaa esilatauksen käytöstä.',
      },
    },
  },

  // Page titles
  title: 'Rakennustarkastukset',
  sidebarTitle: 'Tarkastus',
  new: 'Uusi rakennustarkastus',
  edit: 'Muokkaa tarkastusta',

  // List page
  fetchError: 'Rakennustarkastusten lataaminen epäonnistui.',
  noInspections: 'Rakennustarkastuksia ei löytynyt.',
  createNew: 'Uusi tarkastus',
  confirmDeleteTitle: 'Poista tarkastukset',
  confirmDeleteDescription: 'Haluatko varmasti poistaa tämän tarkastuksen?',
  duplicate: 'Monista',
  duplicating: 'Monistetaan tarkastusta...',
  duplicateSuccess: 'Tarkastus monistettu',
  duplicateError: 'Tarkastuksen monistaminen epäonnistui',
  renameInspection: 'Nimeä tarkastus uudelleen',

  // Common
  common: {
    // generic
    custom: 'Mukautettu',
    standard: 'Standardi',
    other: 'Muu',
    text: 'Teksti',
    from: 'Alkaen',
    to: 'Asti',
    hide: 'Piilota',
    show: 'Näytä',
    horizontal: 'Vaakasuora',
    vertical: 'Pystysuora',
    addImage: 'Lisää kuva',
    confirmDeleteImage: 'Haluatko varmasti poistaa tämän kuvan?',
    generating: 'Luodaan...',
    indoorClimate: 'Sisäilmasto',
    score: 'Pisteet',
    energyData: 'Energiatiedot',
    air: 'Ilma',
    liquid: 'Neste',
    round: 'Pyöreä',
    square: 'Neliö/suorakulmio',

    // field labels
    quantity: 'Määrä',
    location: 'Sijainti',
    priority: 'Prioriteetti',
    yearInstalled: 'Asennusvuosi',
    medium: 'Väliaine',

    // section / navigation labels
    inspection: 'Tarkastus',
    info: 'Tiedot',
    purpose: 'Tarkoitus',
    module: 'Moduuli',
    control: 'Ohjaus & Säätö',
    equipment: 'Laitteet',
    hvacSystems: 'LVI-järjestelmät',
    thermalZones: 'Lämpövyöhykkeet',
    zones: 'Vyöhykkeet',
    heatingCooling: 'Lämmitys & jäähdytys',
    heatingAndCooling: 'Lämmitys ja jäähdytys',
    heatingOnly: 'Vain lämmitys',
    domesticHotWater: 'Käyttövesi',
    centralEnergy: 'Keskitetty energia',
    excessEnergy: 'Ylijäämäenergia',
    solarPv: 'Aurinkosähkö',
    solarThermal: 'Aurinkolämpö',
    solarCells: 'Aurinkosähkö',
    attachments: 'Liitteet',
    annualSimulation: 'Vuosisimulaatio',
    energyLabel: 'Energiatodistus',
    actions: 'Toimenpiteet',
    lighting: 'Valaistus',
    report: 'Raportti',
    hvac: 'LVI',
    windows: 'Ikkunat',
    doors: 'Ovet',
    gates: 'Portit',
    walls: 'Seinät',
    exteriorWalls: 'Ulkoseinät',
    floor: 'Maata vasten oleva lattia',
    roof: 'Katto',
    basement: 'Kellarirakenne',
    groundConditions: 'Maaperän olosuhteet',
    airLeakage: 'Ilmavuoto',
    thermalMass: 'Terminen massa',
    internalLoads: 'Sisäiset kuormat',
    productionEquipment: 'Tuotantolaitteet',
    ground: 'Maaperä',
    zone: 'Vyöhyke',
    wall: 'Seinä',
    window: 'Ikkuna',
    door: 'Ovi',
    gate: 'Portti',

    // climate
    climate: 'Ilmasto',
    climatized: 'Ilmastoitu',
    partlyClimatized: 'Osittain ilmastoitu',
    unclimatized: 'Ei ilmastoitu',
    floorHeight: 'Kerroskorkeus (m)',

    // units and physical quantities
    area: 'Pinta-ala (m²)',
    areaShort: 'Pinta-ala',
    volume: 'Tilavuus (L)',
    volumeShort: 'Tilavuus',
    length: 'Pituus (m)',
    power: 'Teho (kW)',
    powerShort: 'Teho',
    uValue: 'U-arvo (W/m²K)',
    uValueShort: 'U-arvo',
    coverageArea: 'Kattavuusalue (m²)',
    coverageAreaShort: 'Kattavuusalue',
    coverageVolume: 'Kattavuustilavuus',
    heatingEffect: 'Lämmitysteho (kW)',
    coolingEffect: 'Jäähdytysteho (kW)',
    effect: 'Teho (kW)',
    cop: 'COP',
    eer: 'EER',
    seasonalCOP: 'Kausi-COP',
    seasonalEER: 'Kausi-EER',
    efficiency: 'Hyötysuhde',
    systemEfficiency: 'Järjestelmän hyötysuhde (%)',
    co2eEmissionFactor: 'CO₂e-päästökerroin (g/kWh)',
    temperatureSupply: 'Menolämpötila (°C)',
    temperatureReturn: 'Paluulämpötila (°C)',
    avgTemp: 'Keskilämpö',
    sfp: 'SFP',
    bra: 'BRA',
    airVolume: 'Ilmamäärä',
    heatRecovery: 'Lämmöntalteenotto',
    panelArea: 'Paneelin pinta-ala',
    cellType: 'Kennotyyppi',
    azimuth: 'Atsimuutti',
    value: 'Arvo',
    unit: 'Yksikkö',

    // system / fuel
    systemType: 'Järjestelmätyyppi',
    systemTypeShort: 'Järjestelmätyyppi',
    energySource: 'Energialähde',
    energySourceShort: 'Energialähde',
    specificFuelType: 'Polttoainetyyppi',
    selectSpecificFuelType: 'Valitse polttoaine...',
    inverterControlled: 'Invertteriohjattu',
    nominalLoad: 'Nimelliskuorma',
    minimumLoad: 'Minimikuorma',
    degradeCoeff: 'Heikkenemiskerroin',
    heatPump: 'Lämpöpumppu',
    electric: 'Sähkö',
    oil: 'Öljy',
    gas: 'Kaasu',
    rock: 'Kallio',
    coolingOnly: 'Vain jäähdytys',

    // performance / magnitude grades
    high: 'Korkea',
    low: 'Matala',
    normal: 'Normaali',

    // dimensions
    width: 'Leveys (m)',
    height: 'Korkeus (m)',
    depth: 'Syvyys (m)',

    // zone editor
    userDefined: 'Käyttäjän määrittämä',
    calculator: 'Laskin',
    compass: {
      N: 'P',
      NE: 'KO',
      E: 'I',
      SE: 'KA',
      S: 'E',
      SW: 'LO',
      W: 'L',
      NW: 'LU',
    },
    directions: {
      n: 'Pohjoinen (0°)',
      ne: 'Koillinen (45°)',
      e: 'Itä (90°)',
      se: 'Kaakko (135°)',
      s: 'Etelä (180°)',
      sw: 'Lounas (225°)',
      w: 'Länsi (270°)',
      nw: 'Luode (315°)',
    },
    structuralNodes: 'Rakenteelliset solmut',
    structuralNode: 'Rakenteellinen solmu',
    addStructuralNode: 'Lisää rakenteellinen solmu',
    copyStructuralNode: 'Kopioi rakenteellinen solmu',
    confirmDeleteStructuralNode: 'Poistetaanko tämä rakenteellinen solmu?',
    boundary: 'Reunaehto',
    boundaryInteriorAir: 'Sisäilma',
    boundaryExterior: 'Ulkoseinä',
    boundaryAdjacentZone: 'Viereinen vyöhyke',
    boundaryAdiabatic: 'Adiabaattinen',
    node: 'Solmu',
    addNode: 'Lisää solmu',
    copyNode: 'Kopioi solmu',
    confirmDeleteNode: 'Poistetaanko tämä solmu?',
    surfaceType: 'Pintatyyppi',
    surfaceCeiling: 'Katto (sisäkatto)',
    surfaceArea: 'Pinta-ala (m\u00B2)',
    heatTransferCoeff: 'Lämmönsiirtokerroin (W/m\u00B2K)',
    totalMass: 'Kokonaismassa (kg/m\u00B3)',
    specificHeatCapacity: 'Ominaislämpökapasiteetti (J/kgK)',

    // insulation grades
    insulated: 'Eristetty',
    uninsulated: 'Eristämätön',
    poorlyInsulated: 'Huonosti eristetty',
    normallyInsulated: 'Normaalisti eristetty',
    wellInsulated: 'Hyvin eristetty',
    veryWellInsulated: 'Erittäin hyvin eristetty',
    selectInsulation: 'Valitse eristys...',
    selectPerformance: 'Valitse hyötysuhde...',
    selectFuelType: 'Valitse polttoainetyyppi...',

    // UI layout
    basicSettings: 'Perusasetukset',
    additionalInfo: 'Lisätiedot',
    showAdvanced: 'Näytä lisäasetukset',
    hideAdvanced: 'Piilota lisäasetukset',
    advanced: 'Lisäasetukset',

    // actions
    settingUp: 'Valmistellaan...',
    co2PerKwh: 'CO₂ per kWh [g]',
    gridFee: 'Verkkomaksu [NOK/kWh]',
    enovaSupport: 'Enova-tuki [%]',
    descriptionPlaceholder:
      'Kuvaile toimenpide yksityiskohtaisesti: mitä muutetaan, miksi ja mikä on odotettu tulos. Sisällytä arvio oletetusta energiankäytön vähenemisestä toimenpiteen toteutuessa sekä arvio toimenpiteeseen liittyvistä kustannuksista ja vaikutuksista kosteuteen ja sisäilmastoon.',
    electricityZone: 'Sähköalue',
    selectZone: 'Valitse alue...',
    runSimulation: 'Suorita rakennussimulaatio',
    runningSimulation: 'Simulaatio käynnissä...',
    simulationDescription: 'Suorittaa tuntikohtaisen energiatasesimulaation',
    baselineProgress: 'Suoritetaan vertailusimulaatiota... (1/2)',
    actionProgress: 'Suoritetaan toimenpidesimulaatiota... (2/2)',
    baselineStarted: 'Perussimulointia aloitettu...',
    simulationStarted: 'Toimenpidesimulaatio aloitettu...',
    noAnnualSimulation:
      'Suorita ensin vuosisimulaatio, jotta toimenpidevertailu voidaan ottaa käyttöön.',
    simulationResults: 'Simulaatiotulokset',
    lastSimulated: 'Viimeksi simuloitu',
    nettEnergyDemand: 'Nettoenergiantarve',
    energyCategory: 'Energialuokka',
    baselineKwh: 'Vertailu (kWh)',
    actionKwh: 'Toimenpide (kWh)',
    savingsKwh: 'Säästö (kWh)',
    baselineKwhM2: 'Vertailu (kWh/m²)',
    actionKwhM2: 'Toimenpide (kWh/m²)',
    savingsPercent: 'Säästö (%)',
    baseline: 'Vertailu',
    afterAction: 'Toimenpiteen jälkeen',
    solarProduction: 'Aurinkosähkön tuotanto',
    savings: 'Säästö',
    costSavings: 'Kustannukset ja säästöt',
    annualEnergySavings: 'Vuotuinen energiansäästö',
    kwhYear: 'kWh/vuosi',
    energySavingsTooltip: 'Kokonaisenergiantarpeen väheneminen parannuksista',
    reduction: 'vähennys',
    increase: 'lisäys',
    annualCostSavings: 'Vuotuinen kustannussäästö',
    nokYear: 'NOK/vuosi',
    costSavingsTooltip:
      'Kokonaiskustannussäästö vähentyneestä energiankulutuksesta ja viedyn aurinkotuotannon tuloista',
    netCo2Reduction: 'Netto CO₂-vähennys',
    kgCo2Year: 'kg CO₂/vuosi',
    co2Tooltip: 'Käyttäen {value} g CO₂/kWh',
    tonnes: 'tonnia',
    paybackPeriod: 'Takaisinmaksuaika',
    paybackTooltip: 'Aika alkuinvestoinnin takaisinmaksuun',
    years: 'vuotta',
    investmentLabel: 'Investointi: {value} NOK',
    noInvestmentCost: 'Investointikustannusta ei määritetty',
    beforeExisting: 'Ennen - Nykyinen järjestelmä',
    afterNew: 'Jälkeen - Uusi järjestelmä',
    investment: 'Investointi',
    installationType: 'Asennustyyppi',
    simple: 'Yksinkertainen',
    complex: 'Monimutkainen',
    deliveredEnergy: 'Toimitettu energia',
    roiTitle: 'Sijoitetun pääoman tuotto',
    roiCumulativeSavings: 'Kumulatiiviset säästöt',
    roiNetValue: 'Nettoarvo (investoinnin jälkeen)',
    roiYears: 'Vuodet',
    roiBreakEven:
      'Nollapiste saavutetaan kun nettoarvo ylittää nollan (vuosi {value})',

    // misc
    presenceControl: 'Läsnäolotunnistus',
    distributionLosses: 'Jakelu- ja varastointihäviöt',
    installationCost: 'Asennuskustannus [NOK]',
    installationCostShort: 'Asennuskustannus',
    noZones:
      'Lämpövyöhykkeitä ei löytynyt. Lisää lämpövyöhykkeet ensin Lämpövyöhykkeet-osiossa.',

    // shared energy source labels
    energySources: {
      electricity: 'Sähkö',
      heatpumpAirToAir: 'Ilmalämpöpumppu',
      fossilOil: 'Fossiilinen öljy',
      fossilGas: 'Fossiilinen kaasu',
      fossilSolidFuel: 'Fossiilinen kiinteä polttoaine',
      bioOil: 'Bioöljy',
      bioGas: 'Biokaasu',
      bioSolidFuel: 'Biokiinteä polttoaine',
      districtHeating: 'Kaukolämpö',
      districtCooling: 'Kaukojäähdytys',
      otherSources: 'Muut lähteet',
    },

    // shared schedule block
    schedule: {
      operationalSchedule: 'Käyttöaikataulu',
      addSchedule: 'Lisää aikataulu',
      clickToToggle: 'Napsauta tunteja vaihtaaksesi päälle/pois',
      avgTemp: 'Keskilämpö',
      days: ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su'],
      months: [
        'Tammikuu',
        'Helmikuu',
        'Maaliskuu',
        'Huhtikuu',
        'Toukokuu',
        'Kesäkuu',
        'Heinäkuu',
        'Elokuu',
        'Syyskuu',
        'Lokakuu',
        'Marraskuu',
        'Joulukuu',
      ],
      hours: 'Tunnit',
      weekly: 'Viikoittain',
      annual: 'Vuosittain',
      on: 'PÄÄLLÄ',
      off: 'POIS',
      hoursPerDayUnit: 'h/pvä',
      hoursPerWeekUnit: 'h/vko',
      hoursPerYearUnit: 'h/vuosi',
      setpointPerHour: 'Asetuslämpötila tunnissa',
      setpointInfoTooltip:
        'Käytä PÄÄLLÄ/POIS hallitaksesi käyttötunteja. Asetusarvot PÄÄLLÄ-tunneille käytetään laskelmissa. POIS-tunnit ovat käyttöajan ulkopuolella.',
      copyToWeekdays: 'Kopioi arkipäiviin',
      copyToWeekends: 'Kopioi viikonloppuun',
      resetToStandards: 'Palauta',
      confirmDeleteSchedule: 'Poistetaanko tämä aikataulu?',
      fromMonth: 'Alkaen',
      toMonth: 'Asti',
    },
  },

  // List page labels
  lists: {
    quantity: 'Määrä',
    totalArea: 'Yhteensä (m²)',
    thermalZones: {
      duplicateZone: 'Kopioi vyöhyke',
      copySuffix: 'kopio',
      duplicateSuccess: 'Vyöhyke kopioitu onnistuneesti',
      duplicateError: 'Vyöhykkeen kopiointi epäonnistui',
    },
    exteriorWalls: {
      addFirst: 'Napsauta lisätäksesi ensimmäisen ulkoseinän',
      addWall: 'Lisää seinä',
      duplicateWall: 'Kopioi seinä',
    },
    windows: {
      addFirst: 'Napsauta lisätäksesi ensimmäisen ikkunan',
      addWindow: 'Lisää ikkuna',
    },
    doors: {
      addFirst: 'Napsauta lisätäksesi ensimmäisen oven',
      addDoor: 'Lisää ovi',
    },
    gates: {
      addFirst: 'Napsauta lisätäksesi ensimmäisen portin',
      addGate: 'Lisää portti',
    },
    productionEquipment: {
      addFirst: 'Napsauta lisätäksesi ensimmäisen tuotantolaitteen',
      addEquipment: 'Lisää tuotantolaite',
    },
    hvac: {
      addFirst: 'Napsauta lisätäksesi ensimmäisen LVI-yksikön',
      addHvac: 'Lisää LVI',
    },
    heatingCooling: {
      addFirstHeating:
        'Napsauta lisätäksesi lämmitys- tai jäähdytysjärjestelmän',
      addHeating: 'Lisää järjestelmä',
    },
    domesticHotWater: {
      add: 'Lisää käyttövesi',
      addFirst: 'Napsauta lisätäksesi käyttöveden',
    },
    centralEnergy: {
      add: 'Lisää keskitetty energiamoduuli',
      addFirst: 'Napsauta lisätäksesi keskitetty energiamoduuli',
    },
    excessEnergy: {
      add: 'Lisää ylijäämäenergiamoduuli',
      addFirst: 'Napsauta lisätäksesi ylijäämäenergiamoduuli',
    },
    solarPv: {
      add: 'Lisää aurinkosähkömoduuli',
      addFirst: 'Napsauta lisätäksesi aurinkosähkömoduuli',
    },
    batteries: {
      add: 'Lisää akku',
      addFirst: 'Lisää akku napsauttamalla',
    },
    attachments: {
      noInspectionFound: 'Tarkastusta ei löytynyt',
    },
  },

  // Edit page - Form fields
  inspector: 'Tarkastaja',
  selectBuilding: 'Valitse rakennus',
  selectedBuilding: 'Rakennus',
  selectBuildingPlaceholder: 'Valitse rakennus...',
  notes: 'Muistiinpanot',

  // Edit page - Map panel
  advancedComingSoon: 'Kehitteillä',
  mapPlaceholder: 'Sastech Kartta',

  // Status options
  statusDraft: 'Luonnos',
  statusInReview: 'Tarkistuksessa',
  statusCompleted: 'Valmis',

  // Validation & feedback
  buildingRequired: 'Valitse rakennus',
  gpsRequired: 'Valitulla rakennuksella on oltava GPS-sijainti',
  createSuccess: 'Tarkastus luotu',
  updateSuccess: 'Tarkastus päivitetty',
  saved: 'tallennettu',
  saveError: 'Tarkastuksen tallennus epäonnistui',
  loadError: 'Tarkastustietojen lataus epäonnistui',

  // Delete dialog
  deleteTitle: 'Poista tarkastus',
  deleteConfirm: 'Haluatko varmasti poistaa tämän tarkastuksen?',
  deleteSuccess: 'Tarkastus poistettu',
  deleteError: 'Tarkastuksen poistaminen epäonnistui',

  // Zone edit
  zoneName: 'Vyöhykkeen nimi',
  zoneCategory: 'Vyöhykeluokka',
  buildingSubcategory: 'Rakennuksen alaluokka',
  zoneSaved: 'Vyöhyke tallennettu',
  standardElementsUpdated: 'Päivitettiin {count} elementtiä arvoon {tek}',
  braRequired: 'BRA yli 0 vaaditaan',
  basementAreaRequired: 'Kellarin lattiapinta-alan on oltava suurempi kuin 0',
  categoryRequired: 'Valitse rakennusluokka',
  yearRequired: 'Anna rakennusvuosi',
  floorsRequired: 'Anna kerrosten lukumäärä',
  zoneCategoryRequired: 'Valitse vyöhykeluokka',
  subcategoryRequired: 'Valitse rakennuksen alaluokka',
  zoneClimateRequired: 'Valitse vyöhykkeen ilmasto',
  floorHeightRequired: 'Kerroskorkeus suurempi kuin 0 vaaditaan',
  airLeakageN50Required: 'Vuotoluku (n50) suurempi kuin 0 vaaditaan',
  thermalBridgePsiRequired: 'Normalisoitu kylmäsiltarvo vaaditaan',
  panelAreaRequired: 'Paneelin pinta-ala suurempi kuin 0 vaaditaan',
  yearInstalledRequired: 'Asennusvuosi vaaditaan',
  soilingLocationRequired: 'Valitse likaantumissijainti',
  cellTypeRequired: 'Valitse kennotyyppi',
  deleteZone: 'Poista vyöhyke',
  deleteZoneWarning: 'Tätä toimintoa ei voi peruuttaa',
  confirmDeleteZone: 'Poista tämä vyöhyke?',
  indoorTemp: 'Alkulämpötila (°C)',
  zoneClimate: 'Vyöhykkeen ilmasto',
  thermalBridgeCoeff: 'Kantava rakenne (kylmäsilta)',
  thermalBridgePsiValue: 'Normalisoitu kylmäsilta-arvo ψ (W/(m²·K))',
  thermalBridgeCoeffTypes: {
    custom: 'Mukautettu',
    wood: 'Rakennus puisella kantavalla rungolla',
    concrete_10cm:
      'Rakennus betoni-, muurattu- tai teräsrungolla ja 10 cm kylmäsillan katkaisijoilla julkisivuissa',
    concrete_5cm:
      'Rakennus betoni-, muurattu- tai teräsrungolla ja 5 cm kylmäsillan katkaisijoilla julkisivuissa',
  },
  addZone: 'Lisää vyöhyke',
  addFirstZone: 'Klikkaa lisätäksesi ensimmäinen vyöhyke',
  image: 'Kuva',
  upload: 'Lataa',

  // Heating/Cooling edit pages
  heatingCooling: {
    deleteModule: 'Poista järjestelmä',
    confirmDeleteModule: 'Poista tämä järjestelmä?',
    deleteHeating: 'Poista lämmitysmoduuli',
    deleteCooling: 'Poista jäähdytysmoduuli',
    confirmDeleteHeating: 'Poista tämä lämmitysmoduuli?',
    confirmDeleteCooling: 'Poista tämä jäähdytysmoduuli?',
    systemType: 'Tyyppi',
    priorityHelp: '1 = korkein prioriteetti (kattaa tarpeen ensin)',
    maxTemperatureSupplied: 'Max menolämpötila (°C)',
    systemTypeRequired: 'Valitse järjestelmätyyppi',
    energySourceRequired: 'Valitse energialähde',
    heatingEffectRequired: 'Lämmitysteho suurempi kuin 0 vaaditaan',
    coolingEffectRequired: 'Jäähdytysteho suurempi kuin 0 vaaditaan',
    systemEfficiencyRequired:
      'Järjestelmän hyötysuhde suurempi kuin 0 vaaditaan',
    copRequired: 'COP suurempi kuin 0 vaaditaan',
    eerRequired: 'EER suurempi kuin 0 vaaditaan',
  },

  domesticHotWater: {
    deleteDhw: 'Poista käyttövesi',
    confirmDelete: 'Poista tämä käyttövesimoduuli?',
    heaterType: 'Lämmitintyyppi',
    volume: 'Tilavuus (L)',
    setpointTemperature: 'Asetuslämpötila (°C)',
    heatingElementPower: 'Lämmityselementin teho (kW)',
    heaterTypes: {
      electric: 'Sähkö',
      centralHeating: 'Keskuslämmitys',
    },
    typeSection: 'Tyyppi',
    consumptionSection: 'Kulutus',
    distributionSection: 'Jakelujärjestelmä',
    greyWaterSection: 'Harmaan veden lämmöntalteenotto',
    tapFrequency: 'Hanataajuus',
    tapCyclesPerDay: 'Hanasyklejä päivässä',
    hasCirculation: 'Lämminvesijärjestelmä kierrolla',
    pipeSpecificLength: 'Ominaisputkipituus käyttövesi',
    circulationPipeLength: 'Ominaisputkipituus kierto',
    greyWaterRecoveryType: 'Talteenottoyksikön tyyppi',
    greyWaterEfficiencyGrade: 'Hetkellinen hyötysuhde',
    greyWaterShareType: 'Lämpimän veden osuus talteenottoon',
    greyWaterConnectionType: 'Liitäntävariantti',
    greyWaterPatternType: 'Hanakuvio',
    greyWaterHelperText:
      'Harmaasta vedestä talteen otettu energia vähennetään käyttöveden lämmityksen kokonaisenergiataatteesta.',
    tapFrequencyTypes: {
      high: 'Korkea hanataajuus',
      normal: 'Normaali hanataajuus',
      low: 'Matala hanataajuus',
      perDay: '/vrk',
    },
    dhwPipeLengthTypes: {
      residentialLong: 'Asuinrakennus, pitkät putkivedot',
      residentialNormal: 'Asuinrakennus, normaalit putkivedot',
      residentialShort: 'Asuinrakennus, lyhyet putkivedot',
      commercialLong: 'Liikerakennus, pitkät putkivedot',
      commercialNormal: 'Liikerakennus, normaalit putkivedot',
      commercialShort: 'Liikerakennus, lyhyet putkivedot',
    },
    circulationPipeLengthTypes: {
      circulationLong: 'Kiertojärjestelmä, pitkät putkivedot',
      circulationNormal: 'Kiertojärjestelmä, normaalit putkivedot',
      circulationShort: 'Kiertojärjestelmä, lyhyet putkivedot',
    },
    greyWaterRecoveryTypes: {
      verticalPipe: 'Pystyputkilämmönvaihdin',
      horizontalPipe: 'Vaakalämmönvaihdin',
      tankRecovery: 'Säiliöpohjainen lämmöntalteenotto',
    },
    greyWaterEfficiencyGrades: {
      low: 'Matala hyötysuhde',
      normal: 'Normaali hyötysuhde',
      high: 'Korkea hyötysuhde',
    },
    greyWaterShareTypes: {
      allShowers: 'Kaikki suihkut talteenottoon',
      halfShowers: '50 % suihkuista talteenottoon',
      thirdShowers: '30 % suihkuista talteenottoon',
    },
    greyWaterConnectionTypes: {
      hotWaterTankOnly: 'Liitetty vain lämminvesisäiliöön',
      coldWaterShowerOnly: 'Liitetty vain kylmävesisuihkupiiriin',
      hotWaterTankAndColdWaterShower:
        'Liitetty lämminvesisäiliöön ja kylmävesisuihkupiiriin',
    },
    greyWaterPatternTypes: {
      residentialWithAccumulation: 'Asuinrakennus harmaavesivarastolla',
      residentialWithoutAccumulation: 'Asuinrakennus ilman harmaavesivarastoa',
      showerWithoutAccumulation: 'Suihkutila ilman harmaavesivarastoa',
      showerWithAccumulation: 'Suihkutila harmaavesivarastolla',
    },
  },

  // Pipe Link configuration
  pipeLink: {
    localEnergySources: 'Paikalliset energialähteet',
    centralEnergySources: 'Keskitetyt energialähteet',
    noCentralModules: 'Keskitettyjä energiamoduuleja ei ole määritetty',
    pipeConfiguration: 'Putkiston konfiguraatio',
    spp: 'SPP (kW/(l/s))',
    constantFlow: 'Vakiovirtaus',
    variableFlow: 'Muuttuva virtaus',
    lengthOfPipe: 'Putken pituus (m)',
    percentageInHeatedSpace: '% lämmitetyssä tilassa',
    avgTempOutsideHeatedSpace:
      'Keskilämpötila lämmitetyn tilan ulkopuolella (°C)',
    waterSystemQuality: 'Vesijärjestelmän laatu',
    waterDistributionType: 'Vesijakelun tyyppi',
    pipeInsulationType: 'Putkieristys',
    qualityOptions: {
      poor: 'Huono vesijakelu',
      normal: 'Normaali vesijakelu',
      good: 'Hyvä vesijakelu',
    },
    distributionTypes: {
      radiatorFloorHeating: 'Lämmitysjärjestelmä, patteri/lattialämmitys',
      heatingBattery: 'Lämmitysjärjestelmä, lämmityspatteri ilmanvaihdossa',
      localCoolingCeilingBaffles:
        'Jäähdytysjärjestelmä, paikallinen jäähdytys/kattopaneelit',
      centralCoolingBattery:
        'Jäähdytysjärjestelmä, keskusjäähdytyspatteri ilmanvaihdossa',
      dhwCirculation: 'Käyttöveden kierto',
      energyWellBrine: 'Energiakaivo, liuos',
    },
    insulationTypes: {
      uninsulated: 'Eristämättömät putket',
      poorlyInsulated: 'Huonosti eristetyt putket',
      normallyInsulated: 'Normaalisti eristetyt putket',
      wellInsulated: 'Hyvin eristetyt putket',
      veryWellInsulated: 'Erittäin hyvin eristetyt putket',
    },
    distributionPipeLengthType: 'Putkipituus per BRA',
    distributionPipeLengthTypes: {
      localAndCentralLong:
        'Sekä paikallinen että keskuslämmitys, pitkät putkivedot',
      localAndCentralNormal:
        'Sekä paikallinen että keskuslämmitys, normaalit putkivedot',
      centralOnlyLong: 'Vain keskuslämmitys, pitkät putkivedot',
      centralOnlyShort: 'Vain keskuslämmitys, lyhyet putkivedot',
    },
    temperatureCannotBeZero: 'Lämpötila ei voi olla 0',
    pipeTemperatureZeroWarning:
      'Meno- ja/tai paluulämpötila on asetettu arvoon 0.',
  },

  // Production Equipment edit page
  productionEquipment: {
    deleteEquipment: 'Poista tuotantolaite',
    confirmDelete: 'Poista tämä tuotantolaite?',
    eligibleForHarvesting: 'Soveltuu energian talteenottoon',
    eligibleForHarvestingHelp:
      'Merkitse tämä laite oikeutetuksi ylijäämäenergian talteenottoon',
  },

  // Central Energy Module
  centralEnergy: {
    mode: 'Tila',
    heatPumpTypeRequired: 'Jokainen lämpöpumppu tarvitsee lämpöpumpputyypin',
    heatPumpNominalLoadRequired:
      'Jokainen lämpöpumppu tarvitsee nimelliskuorman suurempi kuin 0',
    heatPumpMinimumLoadRequired:
      'Jokainen lämpöpumppu tarvitsee vähimmäiskuorman suurempi kuin 0',
    combustionBoilerTypeRequired:
      'Jokainen polttokattila tarvitsee kattilatyypin',
    combustionBoilerFuelSourceRequired:
      'Jokainen polttokattila tarvitsee polttoaineen',
    fillRequiredFields: 'Täytä kaikki pakolliset kentät',
    requiredFieldsNotSaved:
      'Muutoksia ei tallenneta ennen kuin kaikki pakolliset kentät on täytetty',
    solarThermalSolarTypeRequired:
      'Jokainen aurinkolämpölähde tarvitsee keräintyypin',
    solarThermalCollectorAreaRequired:
      'Jokainen aurinkolämpölähde tarvitsee keräinpinta-alan suurempi kuin 0',
    otherSourceMaxCapacityRequired:
      'Jokainen muu lähde tarvitsee enimmäiskapasiteetin suurempi kuin 0',
    otherSourceEfficiencyRequired:
      'Jokainen muu lähde tarvitsee hyötysuhteen suurempi kuin 0',
    heatingAndHotWater: 'Lämmitys ja lämmin vesi',
    thermalZone: 'Lämpövyöhyke',
    thermalZoneHelp: 'Linkitä lämpövyöhykkeeseen ympäristölämpötilaa varten',
    noZone: 'Ei mitään (erillinen)',
    selectZone: 'Valitse vyöhyke...',
    ambientTemperature: 'Ympäristölämpötila',
    ambientTempHelp:
      'Lämpötila moduulin ympärillä kun ei linkitetty vyöhykkeeseen',
    moduleName: 'Keskitetty energiamoduuli',
    deleteModule: 'Poista keskitetty energiamoduuli',
    confirmDelete:
      'Poista tämä keskitetty energiamoduuli ja kaikki energialähteet?',
    notLinkedWarning:
      'Tätä moduulia ei ole yhdistetty mihinkään laitteeseen. Lisää se energialähteeksi lämmitykseen/jäähdytykseen, ilmanvaihtoon, käyttöveteen tai tuotantolaitteeseen.',
    notLinkedListWarning:
      '{name} ei ole yhdistetty mihinkään laitteeseen. Lisää se energialähteeksi käyttääksesi sitä.',
    notesAttachments: 'Muistiinpanot ja liitteet',
    energySources: 'Energialähteet',
    tanks: 'Säiliöt',
    performance: 'Hyötysuhde',

    // Accumulation tanks
    accumulationTanks: 'Varaajasäiliöt',
    addTank: 'Lisää säiliö',
    confirmDeleteTank: 'Poista tämä varaajasäiliö?',
    noTanks: 'Ei varaajasäiliöitä määritetty. Napsauta lisätäksesi.',
    dhwTank: 'KVV (käyttövesi)',
    heatingTank: 'Lämpöpuskuri',
    coolingTank: 'Jäähdytysvarasto',
    insulation: 'Eristys',
    setpoint: 'Asetusarvo (°C)',
    maxTemp: 'Maks lämpötila (°C)',
    minTemp: 'Min lämpötila (°C)',
    heatLoss: 'Lämpöhäviö (W/K)',

    // Electric boiler insulation (Table J.2)
    boilerInsulation: 'Kattilan eristysaste',
    boilerInsulationVeryLow: 'Erittäin huonosti eristetty',
    selectBoilerInsulation: 'Valitse eristys...',

    // Energy source configuration
    energySourceConfig: 'Energialähteen konfigurointi',
    sourceType: 'Energialähteen tyyppi',
    selectType: 'Valitse energialähteen tyyppi...',
    sourceName: 'Energialähteen nimi',
    usage: 'Käyttö',
    dhw: 'KVV',
    addToList: 'Lisää listaan',

    // Priority list
    priorityList: 'Prioriteettilista',
    dragToReorder: 'Napsauta muokataksesi. Vedä muuttaaksesi järjestystä',
    clickToEdit: 'Napsauta lähdettä muokataksesi',
    confirmDeleteSource: 'Poista tämä energialähde?',
    noPrioritySources: 'Ei vielä lisättyjä energialähteitä',
    noSources:
      'Ei vielä lisättyjä energialähteitä. Käytä yllä olevaa lomaketta lähteiden lisäämiseen.',

    // Energy source types
    districtHeating: 'Kaukolämpö',
    combustionBoiler: 'Polttokattila',
    electricBoiler: 'Sähkökattila',
    otherSource: 'Muu lähde',

    // Heat pump fields
    heatPumpType: 'Lämpöpumpputyyppi',
    airToAir: 'Ilma-ilma',
    airToWater: 'Ilma-vesi',
    liquidToWater: 'Neste-vesi',
    heatingCapacity: 'Lämmitysteho (kW)',
    liquidSource: 'Nestelähde',
    selectSource: 'Valitse lähde...',
    freshWater: 'Makea vesi',
    seaWater: 'Merivesi',
    sourceTemp: 'Lähdelämpötila (°C)',
    avgYearlyTemp: 'Keskim. vuosilämpötila (°C)',
    maxTemperatureSupplied: 'Korkein toimitettu lämpötila (°C)',
    SourceTempeAmplitude: 'Lämmönlähteen lämpötilavaihtelu (°C)',
    energyWellDimensioning: 'Energiakaivon käyttö ja mitoitus',
    energyWellHeatingOnlyUndersized:
      'Vain lämmitys (lämmönotto), hieman alimitoitettu energiakaivo',
    energyWellHeatingOnlyGood:
      'Vain lämmitys (lämmönotto), hyvin mitoitettu energiakaivo',
    energyWellSomeCoolingUndersized:
      'Lämmitys ja jonkin verran jäähdytystä, hieman alimitoitettu energiakaivo',
    energyWellSomeCoolingGood:
      'Lämmitys ja jonkin verran jäähdytystä, hyvin mitoitettu energiakaivo',
    energyWellBalancedUndersized:
      'Tasapainoinen lämmitys ja jäähdytys, hieman alimitoitettu energiakaivo',
    energyWellBalancedGood:
      'Tasapainoinen lämmitys ja jäähdytys, hyvin mitoitettu energiakaivo',
    highestSourceTemperature: 'Korkein toimitettu lähdelämpötila (°C)',
    waterSourceDepth: 'Lämmönoton syvyys meressä/vedessä',
    CO2EmissionFactor: 'CO₂-päästökerroin (g/kWh)',

    // District heating / Electric boiler / Other source fields
    maxCapacity: 'Maks kapasiteetti (kW)',
    energyPrice: 'Energian hinta (per kWh)',
    temperatureFromSource: 'Lämpötila lähteestä (°C)',
    // Combustion boiler fields
    boilerType: 'Kattilatyyppi',
    biomass: 'Biomassa',
    fuelSource: 'Polttoainelähde',
    otherFuelSource: 'Muu',
    fuelType: 'Polttoainetyyppi',
    flueGasCondensation: 'Savukaasulauhdutus',
    fuelConfig: 'Polttoainekonfiguraatio',
    fuelEnergyContent: 'Energiasisältö (kWh/L)',
    efficiencyLowLoad: 'Teho 30% kuormalla (kW)',
    effectFullLoad: 'Teho täydellä kuormalla (kW)',
    isCondensing: 'Kondensoiva kattila',
    operatingSchedule: 'Käyttöaikataulu',
    startDate: 'Alku (päivä/kuukausi)',
    endDate: 'Loppu (päivä/kuukausi)',
    startOfDay: 'Aloitustunti',
    endOfDay: 'Lopetustunti',
    seasonalMeanTemp: 'Kauden keskilämpötila (°C)',

    // Solar thermal fields
    solarType: 'Aurinkotyyppi',
    vacuumTube: 'Tyhjiöputki',
    flatPlate: 'Tasokeräin',
    tilt: 'Kallistus (°)',
    area: 'Kokonaispinta-ala (m²)',
    collectorArea: 'Keräinpinta-ala (m²)',
    pipeLength: 'Putken pituus (m)',
    pipeUValue: 'Putken U-arvo (W/mK)',
    collectorSpecs: 'Keräimen tekniset tiedot',
    efficiencyNormal: 'Hyötysuhde η₀',
    heatLossLinear: 'Lämpöhäviö a₁ (W/m²K)',
    heatLossSecond: 'Lämpöhäviö a₂ (W/m²K²)',
    opticalEfficiency: 'Optinen hyötysuhde',
    heatLossCoeff: 'Lämpöhäviökerroin',
    shadingWinter: 'Varjostuskerroin talvi',
    shadingSummer: 'Varjostuskerroin kesä',
    adjustmentFactor: 'Säätökerroin',
    tankSpiralPlacementFactor: 'Säiliön kierukan sijoituskerroin',
    temperatureColdWater: 'Kylmän veden lämpötila (°C)',
    temperatureInCollectionTank: 'Varaajasäiliön lämpötila (°C)',
    percentageOfCollectorLoopOutside: 'Ulkona olevan keräinpiirin osuus (%)',
    snowCoverageMonths: 'Lumipeitteiset kuukaudet',
    selectMonths: 'Valitse kuukaudet...',
    insulationFactorForCollectionLoop: 'Keräinpiirin eristyskerroin',
    selectInsulationFactorForCollectionLoop: 'Valitse eristyskerroin...',

    // District heating tables O.1, O.2, O.3
    heatExchangerInsulation: 'Lämmönvaihtimen eristys',
    selectHeatExchangerInsulation: 'Valitse eristys...',
    outletTemperatureRange: 'Ulostulolämpötila-alue',
    selectOutletTempRange: 'Valitse alue...',
    outletTempLow: '≤ 50 °C',
    outletTempMedium: '50–70 °C',
    outletTempHigh: '≥ 70 °C',
    bdhCoefficient: 'Lämmönvaihtimen häviö',
    bdhValue: 'Häviökerroin',
    supplyTemperatureRange: 'Syöttölämpötila-alue',
    selectSupplyTempRange: 'Valitse alue...',
    supplyTempHigh: '≥ 150 °C',
    supplyTempMedium: '105–150 °C',
    supplyTempLow: '≤ 105 °C',
    ddhCoefficient: 'Jakelun lämpöhäviö',
    ddhValue: 'Häviökerroin',
    coolingHeatExchangerInsulation: 'Jäähdytyslämmönvaihtimen eristys',
    selectCoolingHxInsulation: 'Valitse eristys...',
    coolingHeatExchangerUValue: 'Jäähdytyslämmönvaihdin',
    coolingHxUValue: 'U-arvo (W/m²K)',

    // CHP tables Q.1, Q.2
    isCHP: 'Yhteistuotanto (CHP)',
    chpSettings: 'CHP-asetukset',
    chpFuelType: 'CHP polttoainetyyppi',
    selectChpFuelType: 'Valitse polttoainetyyppi...',
    chpSolidFuel: 'Kiinteä polttoaine',
    chpLiquidFuel: 'Nestemäinen polttoaine',
    chpGas: 'Kaasu',
    chpPerformanceLevel: 'Suoritustaso',
    selectChpPerformance: 'Valitse suoritustaso...',
    chpThermalEfficiency: 'Lämpöhyötysuhde (%)',
    chpElectricalEfficiency: 'Sähköhyötysuhde (%)',
    chpTotalEfficiency: 'Kokonaishyötysuhde (%)',
    chpBoilerType: 'CHP kattilatyyppi',
    selectChpBoilerType: 'Valitse kattilatyyppi...',
    chpBiopellets: 'Biopelletit',
    chpWoodChips: 'Hake',
    gasOrOilBoiler: 'Kaasu- tai öljykattila',
    chpC7: 'C\u2087',
    chpC8: 'C\u2088',
    chpN: 'n',

    // Solar thermal pipe insulation table H.2
    pipeInsulationType: 'Putkieristystyyppi',
    selectPipeInsulation: 'Valitse eristys...',
  },

  // Excess Energy Module
  excessEnergy: {
    eligibleForHarvesting: 'Oikeutettu energian talteenottoon',
    eligibleForHarvestingHelp:
      'Merkitse tämä moduuli oikeutetuksi ylijäämäenergian talteenottoon',

    // Duct dimensions
    ductDimensions: 'Kanavamitat',
    ductShape: 'Kanavan muoto',
    diameter: 'Halkaisija (mm)',
    width: 'Leveys (mm)',
    height: 'Korkeus (mm)',
    airspeed: 'Ilman nopeus (m/s)',

    // Flow properties
    flowProperties: 'Virtausominaisuudet',
    temperature: 'Poistolämpötila (C)',
    volumeFlow: 'Tilavuusvirta',
    volumeFlowAir: 'Tilavuusvirta (m³/h)',
    volumeFlowLiquid: 'Tilavuusvirta (L/h)',

    // Delete
    deleteModule: 'Poista ylijäämäenergiamoduuli',
    confirmDelete: 'Poistetaanko tämä ylijäämäenergiamoduuli?',
    noModuleFound: 'Ylijäämäenergiamoduulia ei löytynyt',
  },

  // Solar PV Module
  solarPv: {
    soilingFactors: 'Likaantumiskertoimet (\u03C6_soil)',
    panelProperties: 'Paneelin ominaisuudet',
    lossesCoefficients: 'Häviöt ja kertoimet',
    panelAngle: 'Paneelin kulma',
    tiltRange: 'Kallistusalue: {range}°',
    angleOutOfRange: 'Kulma alueen ulkopuolella',
    selectLocation: 'Valitse sijainti...',
    usingStandardTable:
      'Käytetään {standard} taulukkoa kallistusalueelle {range}°',
    selectCellType: 'Valitse kennotyyppi...',
    nominalEfficiency: 'Nimellistehokkuus (0-1)',
    panelAzimuth: 'Paneelin atsimuutti (0-360°)',
    shadingFactor: 'Varjostuskerroin (0-1)',
    mountingType: 'Asennustyyppi',
    selectMountingType: 'Valitse asennustyyppi...',
    windExposure: 'Tuulialtistus',
    selectWindExposure: 'Valitse tuulialtistus...',
    heatLossFactor: 'Lämpöhäviökerroin (W/m²K)',
    inverterEfficiency: 'Invertteritehokuus (0-1)',
    degradationLoss: 'Rappeutumishäviö (0-1)',
    inverterLoss: 'Invertterihäviö (0-1)',
    transmissionProduct: 'Läpäisytuote (0-1)',
    temperatureCoefficient: 'Lämpötilakerroin (%/°C)',
    incidentAngleModifier: 'Tulokulmakerroin (0-1)',
    deleteModule: 'Poista aurinkosähkömoduuli',
    confirmDelete: 'Poistetaanko tämä aurinkosähkömoduuli?',
  },

  // Battery edit page
  battery: {
    annualSimOnly:
      'Akut ovat tällä hetkellä mukana vain vuosisimulaatioissa. Ne eivät vielä sisälly energiamerkinnän laskentaan.',
    maxCapacity: 'Enimmäiskapasiteetti (kWh)',
    maxChargePower: 'Suurin latausteho (kW)',
    maxDischargePower: 'Suurin purkuteho (kW)',
    chargeEfficiency: 'Latauksen hyötysuhde (0-1)',
    dischargeEfficiency: 'Purun hyötysuhde (0-1)',
    minStateOfCharge: 'Pienin varaustaso (0-1)',
    maxStateOfCharge: 'Suurin varaustaso (0-1)',
    peakShavingThreshold: 'Tehohuippujen raja (kW)',
    preChargeStateOfCharge: 'Esilatauksen varaustaso (0-1)',
    maxCapacityRequired: 'Enimmäiskapasiteetin on oltava suurempi kuin 0',
    maxChargePowerRequired: 'Suurimman lataustehon on oltava suurempi kuin 0',
    maxDischargePowerRequired: 'Suurimman purkutehon on oltava suurempi kuin 0',
    deleteBattery: 'Poista akku',
    confirmDelete: 'Poistetaanko tämä akku?',
  },

  // HVAC system type options
  hvacSystemTypes: {
    balanced: 'Tasapainotettu',
    exhaust: 'Poisto',
    supply: 'Tulo',
  },

  // HVAC edit page
  hvac: {
    deleteUnit: 'Poista LVI-yksikkö',
    confirmDelete: 'Poista tämä LVI-yksikkö?',
    heatRecoveryShort: 'Lämmöntalteenotto',
    airVolumeShort: 'Ilmamäärä',
    addDxSystem: 'Lisää DX-järjestelmä',
    confirmDeleteDxSystem: 'Poista tämä DX-järjestelmä?',
    addHeatingBattery: 'Lisää lämmityspatteri',
    confirmDeleteHeatingBattery: 'Poista tämä lämmityspatteri?',
    addCoolingBattery: 'Lisää jäähdytyspatteri',
    confirmDeleteCoolingBattery: 'Poista tämä jäähdytyspatteri?',

    // Section headers
    namePlaceholder: 'Ilmanvaihtokoneen nimi',
    dxSystemNamePlaceholder: 'DX-järjestelmän nimi',
    batteryNamePlaceholder: 'Patterin nimi',
    flowSfpSettings: 'Ilmamäärä ja SFP-asetukset',
    temperatureMeasurements: 'Lämpötilamittaukset',
    dxSystems: 'DX (Suora paisunta)',
    heatingBatteries: 'Lämmityspatterit',
    coolingBatteries: 'Jäähdytyspatterit',
    naturalVentilation: 'Painovoimainen ilmanvaihto',

    // SFP fields
    sfpCalculationMethod: 'SFP-laskentamenetelmä',
    sfpAsFunction: 'Ominaissähköteho',
    yearBands: {
      pre1985: 'Ennen 1985',
      '1985to1995': '1985 - 1995',
      '1995to2005': '1995 - 2005',
      '2005to2013': '2005 - 2013',
      '2013to2020': '2013 - 2020',
      from2020: '2020 ja uudemmat',
    },
    suggestions: {
      yearHelp:
        'Vuosi jolloin ilmanvaihtokone asennettiin. Se määrittää ajalle tyypillisen moottorityypin, SFP:n ja lämmöntalteenoton.',
      hintLabel: 'Ehdotus',
      calculatedLabel: 'Laskettu',
      apply: 'Käytä',
      applyAll: 'Käytä ({count}) ehdotusta',
      noSuggestions: 'Ei ehdotuksia',
      applyAllHelp: 'Käytä kaikkia tämän sivun ehdotettuja arvoja.',
    },

    // Flow fields
    fanPower: 'Puhaltimen teho',
    coverage: 'Kattavuus',
    fanPowerIn: 'Puhaltimen teho tulo (kW)',
    fanPowerOut: 'Puhaltimen teho poisto (kW)',
    supplyAirVolume: 'Supply Air Volume',
    airVolumeOperating: 'Operating (m³/h)',
    airVolumeCapacity: 'Capacity (m³/h)',
    airVolumeNonOperating: 'Non-Operating (m³/h)',
    extractionAirVolume: 'Extraction Air Volume',
    airVolumeExtractionOperating: 'Operating (m³/h)',
    airVolumeExtractionCapacity: 'Capacity (m³/h)',
    airVolumeExtractionNonOperating: 'Non-Operating (m³/h)',

    // Heat recovery
    heatRecoveryType: 'Lämmöntalteenottotapa',
    efficiencyHR: 'Hyötysuhde LTO (%)',
    frostProtection: 'Pakkassuojaus',
    frostProtectionTemperature: 'Pakkassuojauslämpötila (°C)',

    // Temperature
    measuredSupplyTemp: 'Mitattu tuloilman lämpötila (°C)',
    measuredExhaustTemp: 'Mitattu poistoilman lämpötila (°C)',

    // DX System
    dxSystem: 'DX-järjestelmä',
    dxType: 'Tyyppi',

    // Battery fields
    heatingBattery: 'Lämmityspatteri',
    coolingBattery: 'Jäähdytyspatteri',
    batteryType: 'Tyyppi',

    // Priority lists
    heatingPriorityList: 'Lämmitysprioriteetti',
    coolingPriorityList: 'Jäähdytysprioriteetti',
    priorityListHelp: 'Vedä järjestääksesi prioriteetti laskelmia varten',
    noPriorityItems: 'Ei määritettyjä kohteita',

    // zone linking
    linkedZones: 'Linkitetyt vyöhykkeet',
    noLinkedZones: 'Ei linkitettyjä vyöhykkeitä',
    manageZones: 'Hallitse vyöhykkeitä',
    useZoneMap: 'Käytä vyöhykekarttaa',
    linkZonesTitle: 'Linkitä lämpövyöhykkeet',
    noZonesAvailable: 'Ei lämpövyöhykkeitä saatavilla',
    zonesLinked: 'Vyöhykkeet linkitetty',
    noZoneWarning:
      'Tätä ilmanvaihtoyksikköä ei ole yhdistetty lämpövyöhykkeeseen.',
    noZoneListWarning: '{name} ei ole yhdistetty lämpövyöhykkeeseen.',
    sfp100Required: 'SFP @ 100 % suurempi kuin 0 vaaditaan',
    airVolumeOperatingRequired:
      'Tuloilman käyttötilavuus suurempi kuin 0 vaaditaan',
    airVolumeCapacityRequired:
      'Tuloilman kapasiteetti suurempi kuin 0 vaaditaan',
    airVolumeExtractionOperatingRequired:
      'Poistoilman käyttötilavuus suurempi kuin 0 vaaditaan',
    dxEnergySourceRequired: 'Jokainen DX-järjestelmä tarvitsee energialähteen',
    dxSystemEfficiencyRequired:
      'Jokainen DX-järjestelmä tarvitsee hyötysuhteen suurempi kuin 0',
    heatingBatteryPowerRequired:
      'Jokainen lämmityspatteri tarvitsee tehon suurempi kuin 0',
    heatingBatterySystemEfficiencyRequired:
      'Jokainen lämmityspatteri tarvitsee hyötysuhteen suurempi kuin 0',
    heatingBatteryEnergySourceRequired:
      'Jokainen lämmityspatteri tarvitsee energialähteen',
    coolingBatteryPowerRequired:
      'Jokainen jäähdytyspatteri tarvitsee tehon suurempi kuin 0',
    coolingBatterySystemEfficiencyRequired:
      'Jokainen jäähdytyspatteri tarvitsee hyötysuhteen suurempi kuin 0',
    coolingBatteryEnergySourceRequired:
      'Jokainen jäähdytyspatteri tarvitsee energialähteen',

    supplementaryFactor: 'Lisäkerroin',

    motorType: 'Moottorityyppi',
    motorTypes: {
      none: 'Ei mitään',
      belt: 'Hihnakäyttö',
      axial: 'Aksiaalipuhallin',
      EC: 'EC-moottori',
      AC: 'AC-moottori',
      DC: 'DC-moottori',
      VSD: 'Taajuusmuuttaja (VSD)',
      other: 'Muu',
    },

    dxTypes: {
      cooling: 'Vain jäähdytys',
      heating: 'Vain lämmitys',
      both: 'Sekä lämmitys että jäähdytys',
    },

    flowTypes: {
      variable: 'Muuttuva ilmamäärä',
      constant: 'CAV, vakioilmamäärä',
      optimal: 'DCV, tarpeenmukainen',
    },

    batteryTypes: {
      water: 'Vesi',
      electric: 'Sähkö',
      heatPump: 'Lämpöpumppu',
      other: 'Muu',
    },

    heatRecoveryTypes: {
      rotaryWheel: 'Pyörivä lämmönsiirrin',
      crossFlow: 'Ristivirta levylämmönsiirrin',
      plateCounterflow: 'Vastavirta levylämmönsiirrin',
      runAroundCoil: 'Nestekiertoinen patteri',
      heatPipe: 'Lämpöputki',
      none: 'Ei mitään',
    },
  },

  // Exterior wall edit page
  exteriorWall: {
    namePlaceholder: 'Seinän nimi',
    direction: 'Suunta',
    type: 'Seinätyyppi',
    shadingFactor: 'Varjostuskerroin',
    deleteWall: 'Poista seinä',
    confirmDelete: 'Poista tämä seinä?',
    directionRequired: 'Valitse seinän suunta',
    areaRequired: 'Seinän pinta-ala suurempi kuin 0 vaaditaan',
    uValueRequired: 'U-arvo suurempi kuin 0 vaaditaan',
    windowsExceedArea:
      'Ikkunoiden kokonaispinta-ala ylittää seinän pinta-alan.',
    doorsExceedArea: 'Ovien kokonaispinta-ala ylittää seinän pinta-alan.',
    gatesExceedArea: 'Porttien kokonaispinta-ala ylittää seinän pinta-alan.',
    combinedExceedArea:
      'Ikkunoiden, ovien ja porttien yhteispinta-ala ylittää seinän pinta-alan.',
    windowsExceedAreaList:
      '{name}: ikkunoiden kokonaispinta-ala ylittää seinän pinta-alan.',
    doorsExceedAreaList:
      '{name}: ovien kokonaispinta-ala ylittää seinän pinta-alan.',
    gatesExceedAreaList:
      '{name}: porttien kokonaispinta-ala ylittää seinän pinta-alan.',
    combinedExceedAreaList:
      '{name}: ikkunoiden, ovien ja porttien yhteispinta-ala ylittää seinän pinta-alan.',
    options: {
      custom: 'Mukautettu',
      standard: 'Vakio',
      timberFrame36_150: 'Puurunko 36mm, 150mm eristys',
      timberFrame36_200: 'Puurunko 36mm, 200mm eristys',
      timberFrame36_250: 'Puurunko 36mm, 250mm eristys',
      timberFrame48_150: 'Puurunko 48mm, 150mm eristys',
      timberFrame48_200: 'Puurunko 48mm, 200mm eristys',
      timberFrame48_250: 'Puurunko 48mm, 250mm eristys',
      epsBlock310: 'EPS-harkko 310mm (140mm betonisydän)',
      epsBlock370: 'EPS-harkko 370mm (140mm betonisydän)',
      epsBlock430: 'EPS-harkko 430mm (140mm betonisydän)',
      iProfile200: 'I-profiili teräsrunko, 200mm eristys',
      iProfile300: 'I-profiili teräsrunko, 300mm eristys',
      iProfile400: 'I-profiili teräsrunko, 400mm eristys',
      lwaBlock250: 'Kevytsoraharkko (Isoblokk) 250mm',
      lwaBlock300: 'Kevytsoraharkko (Isoblokk) 300mm',
      lwaBlock350: 'Kevytsoraharkko (Isoblokk) 350mm',
      slottedSteel200: 'Uritettu teräs, 200mm eristys',
      slottedSteel250: 'Uritettu teräs, 250mm eristys',
      slottedSteel300: 'Uritettu teräs, 300mm eristys',
      unslottedSteel200: 'Urittamaton teräs, 200mm eristys',
      unslottedSteel250: 'Urittamaton teräs, 250mm eristys',
      unslottedSteel300: 'Urittamaton teräs, 300mm eristys',
    },
  },

  // Building types (NS 3031 categories)
  buildingTypes: {
    label: {
      smallHouse: 'Pientalo',
      apartmentBlock: 'Kerrostalo',
      kindergarten: 'Päiväkoti',
      officeBuilding: 'Toimisto',
      schoolBuilding: 'Koulu',
      universityCollege: 'Yliopisto/korkeakoulu',
      hospital: 'Sairaala',
      nursingHome: 'Hoivakoti',
      hotelBuilding: 'Hotelli',
      sportsBuilding: 'Urheilutila',
      commercialBuilding: 'Liikerakennus',
      culturalBuilding: 'Kulttuuri',
      lightIndustry: 'Kevyt teollisuus/varasto',
    },
    description: {
      smallHouse:
        'Omakotitalo, paritalo, rivitalo, ketjutalo tai muu pieni asuinrakennus.',
      apartmentBlock: 'Asuinkerrostalo, jossa on kaksi tai useampi kerros.',
      kindergarten: 'Päiväkotikäyttöön suunniteltu rakennus.',
      officeBuilding:
        'Toimistotilat, ilmastoidut toimistot tai näyttely-/kongressirakennukset.',
      schoolBuilding:
        'Opetustilat, mukaan lukien koulut, joissa on uima-allas tai liikuntahalli.',
      universityCollege:
        'Yliopisto- tai korkeakoulurakennukset, laboratoriot tai tutkimuslaitokset.',
      hospital:
        'Sairaalat, sairaalahotellit tai lääketieteelliset laboratoriorakennukset.',
      nursingHome: 'Hoivakodit pitkäaikaiseen asumishoitoon.',
      hotelBuilding:
        'Hotellit, ravintolarakennukset tai muut majoitusrakennukset.',
      sportsBuilding:
        'Liikuntahallit, uimahallit ja muut urheilutilat suihkutiloilla.',
      commercialBuilding:
        'Kaupat, myymälät kylmä-/pakastetiloineen tai huoltoasemat.',
      culturalBuilding:
        'Elokuvateatterit, museot, kirjastot ja uskonnolliset rakennukset.',
      lightIndustry:
        'Teollisuusrakennukset, varastot, maatalousrakennukset tai muut työpajat.',
    },
  },

  buildingSubcategories: {
    1: 'Omakotitalo',
    2: 'Omakotitalo vuokrausosalla',
    3: 'Paritalo (vaakasuora)',
    4: 'Paritalo (pystysuora)',
    5: 'Neljän asunnon talo',
    6: 'Ketjutalo',
    7: 'Rivitalo',
    8: 'Loma-asunto',
    9: 'Muu pientalo',
    10: 'Kerrostaloasunto',
    11: 'Muu asuinrakennus',
    12: 'Päiväkotirakennus',
    13: 'Yksinkertaiset toimistot',
    14: 'Toimistot ilmanvaihdolla ja jäähdytyksellä',
    15: 'Messu-/kongressirakennus',
    16: 'Muu toimistorakennus',
    17: 'Opetustilat',
    18: 'Koulu uimahallilla',
    19: 'Koulu liikuntahallilla',
    20: 'Opetusrakennus',
    21: 'Laboratoriorakennus',
    22: 'Muu tutkimusrakennus',
    23: 'Sairaala',
    24: 'Sairaalahotelli',
    25: 'Sairaalanlaboratorio',
    26: 'Hoivakoti',
    27: 'Hotellirakennus',
    28: 'Majoitusrakennus',
    29: 'Ravintolarakennus',
    30: 'Muu hotellirakennus',
    31: 'Liikuntahalli',
    32: 'Liikuntahalli suihkutiloilla',
    33: 'Liikuntahalli uimahallilla',
    34: 'Kauppa',
    35: 'Kauppa kylmähuoneella',
    36: 'Huoltoasema',
    37: 'Kulttuurirakennus',
    38: 'Elokuvateatteri',
    39: 'Museo/kirjasto',
    40: 'Uskonnollinen rakennus',
    41: 'Teollisuusrakennus',
    42: 'Energiantuotantorakennus',
    43: 'Varastorakennus',
    44: 'Kalastus-/maatalousrakennus',
    45: 'Muu teollisuus',
  },

  thermalZones: {
    schedule: {
      heatingSchedule: 'Lämmitysaikataulu',
      coolingSchedule: 'Jäähdytysaikataulu',
      addHeatingSchedule: 'Lisää lämmitysaikataulu',
      addCoolingSchedule: 'Lisää jäähdytysaikataulu',
    },
    yearPeriods: {
      TEK50: 'Ennen 1969',
      TEK70: '1970 - 1979',
      TEK80: '1980 - 1986',
      TEK87: '1987 - 1996',
      TEK97: '1997 - 2006',
      TEK07: '2007 - 2009',
      TEK10: '2010 - 2016',
      TEK17: '2017 ja myöhemmin',
    },
    hasFloorToGround: 'Vyöhykkeellä on maata vasten oleva lattia',
    hasRoof: 'Vyöhykkeellä on katto',
    isBasement: 'Vyöhyke on kellari',
    floor: {
      type: 'Maata vasten olevan lattian tyyppi',
      area: 'Maata vasten oleva lattia (m²)',
      options: {
        custom: 'Mukautettu',
        standard: 'Vakio',
        tiles: 'Laatat betonilla',
        parquetChipBoard: 'Parketti lastulevyllä',
        carpetConcrete: 'Matto betonilla',
      },
    },
    roof: {
      type: 'Kattotyyppi',
      optionsTitle: 'Kattorakenne',
      angle: 'Katon kulma',
      hasWindows: 'Katossa on ikkunoita',
      areaRequired: 'Katon pinta-ala suurempi kuin 0 vaaditaan',
      windowArea: 'Ikkunapinta-ala (m²)',
      glassType: 'Lasityyppi',
      pitchTypes: {
        flat: 'Tasakatto',
        lowSlope: 'Loiva kaltevuus',
        gentlePitch: 'Kevyt kaltevuus',
        standardPitch: 'Normaali kaltevuus',
        steepPitch: 'Jyrkkä kaltevuus',
        verySteepPitch: 'Erittäin jyrkkä kaltevuus',
      },
      options: {
        custom: 'Mukautettu',
        standard: 'Vakio',
        compactConcrete200: 'Tasakatto, betoni, 200mm eriste',
        compactConcrete300: 'Tasakatto, betoni, 300mm eriste',
        compactConcrete400: 'Tasakatto, betoni, 400mm eriste',
        compactSteel200: 'Tasakatto, profiilipelti, 200mm eriste',
        compactSteel300: 'Tasakatto, profiilipelti, 300mm eriste',
        compactSteel400: 'Tasakatto, profiilipelti, 400mm eriste',
        pitched48mm200: 'Harjakatto, 48mm kattotuolit, 200mm eriste',
        pitched48mm300: 'Harjakatto, 48mm kattotuolit, 300mm eriste',
        pitched48mm400: 'Harjakatto, 48mm kattotuolit, 400mm eriste',
        pitchedIBeam200: 'Harjakatto, I-palkit, 200mm eriste',
        pitchedIBeam300: 'Harjakatto, I-palkit, 300mm eriste',
        pitchedIBeam450: 'Harjakatto, I-palkit, 450mm eriste',
        coldAttic200: 'Kylmä ullakko, 200mm eriste',
        coldAttic300: 'Kylmä ullakko, 300mm eriste',
        coldAttic450: 'Kylmä ullakko, 450mm eriste',
      },
    },
    basement: {
      dimensions: 'Mitat',
      area: 'Lattiapinta-ala maata vasten (m²)',
      wallPerimeter: 'Maata vasten olevan seinän piiri (m)',
      fillHeight: 'Syvyys maanpinnan alapuolella (m)',
      wallThickness: 'Seinän paksuus (m)',
      wallConstruction: 'Kellarin seinä',
      wallConstructionType: 'Seinätyyppi',
      wallUValue: 'Seinän U-arvo (W/m²K)',
      floorConstruction: 'Kellarin lattia',
      floorConstructionType: 'Lattiatyyppi',
      floorUValue: 'Lattian U-arvo (W/m²K)',
      intro:
        'Muista pienentää yläpuolisen vyöhykkeen maanvaraista lattiaa kellarin pinta-alan verran.',
      floorConstructionOptions: {
        none: 'Ei mitään',
        standard: 'Standardi',
        concrete100: 'Betoni maalla + 100mm eriste',
        concrete150: 'Betoni maalla + 150mm eriste',
        concrete200: 'Betoni maalla + 200mm eriste',
        concrete250: 'Betoni maalla + 250mm eriste',
        concrete300: 'Betoni maalla + 300mm eriste',
        concrete350: 'Betoni maalla + 350mm eriste',
        concrete400: 'Betoni maalla + 400mm eriste',
        wood200: 'Puupalkisto + 200mm eriste',
        wood250: 'Puupalkisto + 250mm eriste',
        wood300: 'Puupalkisto + 300mm eriste',
      },
    },
    groundConditions: {
      type: 'Maaperän tyyppi',
      thermalConductivity: 'Lämmönjohtavuus λ (W/(m·K))',
      heatCapacity: 'Lämpökapasiteetti Cv (Wh/(m³·K))',
      penetrationDepth: 'Jaksollinen tunkeutumissyvyys δ (m)',
      options: {
        clay: 'Savi/siltti',
        sand: 'Hiekka/sora',
        rock: 'Kallio',
      },
    },
    thermalMass: {
      buildingHeatCapacity: 'Vyöhykkeen lämpökapasiteetti',
      heatCapacityCategory: 'Lämpökapasiteettiluokka',
      normalizedHeatCapacity: 'Normalisoitu lämpökapasiteetti (Wh/m²K)',
      interiorWalls: 'Sisäseinät',
      cladding: 'Verhous',
      heatCapacity: 'Lämpökapasiteetti (Wh/m²K)',
      furniture: 'Kalusteet',
      furnitureGrade: 'Kalusteluokka',
      massFactor: 'Massakerroin (Wh/m²K)',
      heatCapacityCategoryRequired: 'Valitse lämpökapasiteettiluokka',
      claddingRequired: 'Valitse verhouksen tyyppi',
      furnitureGradeRequired: 'Valitse kalusteluokka',
      labelFirstOption: 'Erittäin kevyt vyöhyke',
      labelSecondOption: 'Kevyt vyöhyke',
      labelThirdOption: 'Keskipainoinen vyöhyke',
      labelFourthOption: 'Painava vyöhyke',
      labelFifthOption: 'Erittäin painava vyöhyke',
      shortDescriptionFirstOption:
        'Kevyt palkkilattia, ohut lattiapäällyste, kevyet seinät',
      shortDescriptionSecondOption:
        'Akustiikkakatto, matto betonin päällä, kevyet seinät',
      shortDescriptionThirdOption:
        'Vähän näkyvissä betoni (20%), parketti betonin päällä',
      shortDescriptionFourthOption: 'Pääasiassa näkyvissä betoni (70%)',
      shortDescriptionFifthOption:
        'Näkyvissä betoni katossa, seinissä ja lattiassa',
      claddingOptions: {
        custom: 'Mukautettu',
        standard: 'Standardi',
        concrete100: '100mm (tai enemmän) betoni',
        concrete80: '80mm betoni',
        aeratedConcrete: 'Kevytbetoni',
        gypsum13: 'Kipsi 13mm',
        lightBrick: 'Kevyt tiili',
        lwa: 'Kevytkiviaines',
        solidWood40: 'Massiivipuu (paksuus yli 40mm)',
        woodPanel15: 'Puupaneeli 15mm',
        heavyBrick: 'Raskas (kompakti) tiili',
      },
      furnitureOptions: {
        none: 'Ei mitään',
        standard: 'Standardi',
        light: 'Kevyt',
        medium: 'Keskitaso',
        heavy: 'Raskas',
      },
    },
    airLeakage: {
      tekStandard: 'TEK-standardi',
      n50: 'Vuotoluku n50 (h⁻¹)',
      tekOptions: {
        TEK50: 'Rakentamismääräys 1950–1969',
        TEK70: 'Rakentamismääräys 1970–1979',
        TEK80: 'Rakentamismääräys 1980–1986',
        TEK87: 'TEK 87 (1987-1996)',
        TEK97: 'TEK 97 (1997-2006)',
        TEK07: 'TEK 07 (2007-2009)',
        TEK10: 'TEK 10 (2010-2016)',
        TEK17: 'TEK 17 (2017+)',
      },
    },
    windows: {
      deleteWindow: 'Poista ikkuna',
      confirmDelete: 'Poista tämä ikkuna?',
      gValue: 'g-arvo',
      frameFraction: 'Karmitekijä',
      shadingFactor: 'Varjostuskerroin (0-1)',
      externalBlinds: 'Ulkoiset sälekaihtimet (gt)',
      externalBlindsGt: 'Ulkoiset sälekaihtimet gt',
      externalScreen: 'Ulkoinen markiisi (gt)',
      externalScreenGt: 'Ulkoinen markiisi gt',
      internalShading: 'Sisäinen aurinkosuoja (gt)',
      internalShadingGt: 'Sisäinen aurinkosuoja gt',
      windowTypes: {
        none: 'Ei mitään',
        custom: 'Mukautettu',
        singleGlass: 'Yksilasi',
        twoLayerGlass: '2-kerroslasi',
        twoLayerEnergyGlass: '2-kerros energialasi',
        twoLayerSolarReflective: '2-kerros aurinkoheijastava lasi',
        threeLayerEnergyGlass: '3-kerros energialasi',
      },
    },
    doors: {
      deleteDoor: 'Poista ovi',
      confirmDelete: 'Poista tämä ovi?',
      type: 'Ovityyppi',
      doorTypes: {
        custom: 'Mukautettu',
        standard: 'Standardi',
        insulated: 'Eristetty',
        normal: 'Normaali',
        wellInsulated: 'Hyvin eristetty',
        uninsulated: 'Eristämätön',
      },
    },
    gates: {
      deleteGate: 'Poista portti',
      confirmDelete: 'Poista tämä portti?',
      type: 'Porttityyppi',
      gateTypes: {
        custom: 'Mukautettu',
        standard: 'Standardi',
        insulated: 'Eristetty',
        sectional: 'Nosto-ovi',
        roller: 'Rullaportti',
        wellInsulated: 'Hyvin eristetty',
      },
    },
    internalLoads: {
      internalLoadsNotice:
        'Näitä arvoja ei käytetä energiamerkinnän luonnissa. Vain valaistuksen läsnäolotunnistus otetaan huomioon.',
      hotWater: 'Kuuma vesi',
      equipment: 'Tekniset laitteet',
      occupancy: 'Henkilöt',
      weekday: 'Arkipäivä (260 päivää)',
      weekend: 'Viikonloppu (105 päivää)',
      resetToStandards: 'Palauta',
      hourlyProfile: 'Tuntiprofiili',
      editHourlyValues: 'Muokkaa tuntiarvoja',
      peak: 'Huippu',
      avg: 'Keskim.',
      daily: 'Päivittäin',
      annual: 'Vuosittain',
      appliances: 'Kodinkoneet',
      appliancesDescription:
        'Vähennä sähkön tarvetta kytkemällä kodinkoneet kuumaan veteen.',
      dishwasherLabel: 'Astianpesukone (kuuma vesi)',
      washingMachineLabel: 'Pesukone (kuuma vesi)',
      tumbleDryerLabel: 'Kuivausrumpu (kuuma vesi)',
      applianceShareLabel: 'Lämpöosuus [%]',
      heatGainShareLabel: 'Lämpökuorma vyöhykkeelle [1-100%]',
      lampTypes: 'Lampputyypit',
      lampType: 'Lampputyyppi',
      selectLampType: 'Valitse lampputyyppi',
      ballast: 'Liitäntälaite',
      electronic: 'Elektroninen',
      electromechanical: 'Sähkömekaaninen',
      sharePercent: 'Osuus (%)',
      efficiencyFactorFL: 'Tehokkuuskerroin (FL)',
      lampTypeNames: {
        ledNew: 'LED vuodesta 2016 ja uudempi',
        ledOld: 'LED vuosilta 2010–2015',
        fluorescentT5: 'Loisteputki T5',
        fluorescentT8: 'Loisteputki T8',
        metalHalide: 'Monimetallilamppu',
        highPressureSodium: 'Suurpainenatriumlamppu',
        compactFluorescent: 'Pienloistelamppu',
        halogen: 'Halogeenilamppu',
        incandescent: 'Hehkulamppu',
      },
      addLampType: 'Lisää lampputyyppi',
      deleteLampType: 'Poistetaanko tämä lampputyyppi?',
    },
    heatingEmissionSystem: 'Lämmönluovutusjärjestelmä',
    heatingEmissionSystems: {
      radiator_thermostat_80_60:
        'Patteri/konvektori termostaattiventtiilillä tai paikallisella huonesäätimellä',
      radiator_thermostat_60_40:
        'Patteri/konvektori termostaattiventtiilillä tai paikallisella huonesäätimellä',
      radiator_thermostat_40_35:
        'Patteri/konvektori termostaattiventtiilillä tai paikallisella huonesäätimellä',
      radiator_sd_80_60: 'Patteri/konvektori yhdistetty rakennusautomaatioon',
      radiator_sd_60_40: 'Patteri/konvektori yhdistetty rakennusautomaatioon',
      radiator_sd_40_35: 'Patteri/konvektori yhdistetty rakennusautomaatioon',
      fan_coil_heat_pump:
        'Puhallinkonvektori / lämpöpumpun sisäyksikkö / aktiivinen jäähdytyspalkki / lämmitys tuloilmalla',
      floor_heating_thermostat:
        'Lattialämmitys termostaattiventtiilillä tai paikallisella huonesäätimellä',
      floor_heating_sd: 'Lattialämmitys yhdistetty rakennusautomaatioon',
      panel_heater_pre_2010: 'Paneelilämmitin – ennen 2010',
      panel_heater_post_2010: 'Paneelilämmitin – jälkeen 2010',
    },
    coolingEmissionSystem: 'Jäähdytyksen luovutusjärjestelmä',
    coolingEmissionSystems: {
      chilled_beam_thermostat:
        'Passiivinen jäähdytyspalkki termostaattiventtiilillä tai paikallisella huonesäätimellä',
      chilled_beam_sd:
        'Passiivinen jäähdytyspalkki yhdistetty rakennusautomaatioon',
      fan_coil_cool_pump:
        'Aktiivinen jäähdytyspalkki / puhallinkonvektori paikallisella huonesäätimellä',
      fan_coil_cool_pump_sd:
        'Aktiivinen jäähdytyspalkki / puhallinkonvektori yhdistetty rakennusautomaatioon',
      floor_cooling_thermostat: 'Lattiajäähdytys paikallisella huonesäätimellä',
      floor_cooling_sd: 'Lattiajäähdytys yhdistetty rakennusautomaatioon',
      chilled_ceiling_thermostat:
        'Jäähdytyskatto paikallisella huonesäätimellä',
      chilled_ceiling_sd: 'Jäähdytyskatto yhdistetty rakennusautomaatioon',
    },
    effectiveSetpoint: 'Todellinen asetusarvo',
  },

  // Thermal Zone Links
  thermalZoneLinks: {
    linkZones: 'Linkitä vyöhykkeet',
    resetLayout: 'Palauta asettelu',
    resetLayoutConfirm:
      'Palautetaanko kartan asettelu? Kaikki vyöhykkeet palaavat ehdotettuun sijaintiin.',
    confirmLink: 'Vahvista linkitys',
    linkDialogTitle: 'Linkitä lämpövyöhykkeet',
    linkingZones: 'Linkitettävät vyöhykkeet',
    sourceZone: 'Lähdevyöhyke',
    targetZones: 'Kohdevyöhykkeet',
    areaUnit: 'm²',
    uValueUnit: 'W/m²K',
    selectSourceFirst: 'Valitse ensin lähdevyöhyke, sitten kohdevyöhykkeet',
    minTwoZones: 'Valitse vähintään 2 vyöhykettä linkitettäväksi',
    linkSuccess: 'Vyöhykkeet linkitetty',
    externalZone: 'Ulkoinen vyöhyke',
    zoneConnections: 'Vyöhykekytkentä',
    addConnection: 'Lisää kytkentä',
    noConnections: 'Ei vyöhykekytkentöjä',
    connectionDeleted: 'Kytkentä poistettu',
    deleteConnectionError: 'Liitosta ei voitu poistaa',
    connectionAdded: 'Kytkentä lisätty',
    connectionUpdated: 'Kytkentä päivitetty',
    editConnection: 'Muokkaa kytkentää',
    deleteConnection: 'Poista kytkentä',
    confirmDeleteConnection: 'Poista vyöhykekytkentä?',
    connectToExisting: 'Olemassa oleva vyöhyke',
    connectToExternal: 'Ulkoinen vyöhyke',
    chooseConnectionType: 'Yhdistä',
    zoneMap: 'Vyöhykekartta',
    zoneMapEmpty: 'Ei vyöhykeliitoksia',
    notLinked: 'Ei liitetty',
    autoLinked: 'Liitetty automaattisesti',
    linkModeHintSource: 'Napsauta lähdevyöhykettä',
    deleteModeHint: 'Napsauta vyöhykettä, jonka liitoksia haluat poistaa',
    ventilation: 'Ilmanvaihto',
    zoneMapSubtitle: 'Siirrä vyöhykkeitä muokataksesi asettelua.',
    noVentilationUnits: 'Ei ilmanvaihtokoneita saatavilla',
    noHeatingCoolingModules: 'Ei lämmitystä tai jäähdytystä saatavilla',
    linkAny: 'Yhdistä',
    linkModeHintSourceAny: 'Napsauta lähdettä',
    linkModeHintTargetAny: 'Napsauta kohdetta tai valitse ulkoinen vyöhyke',
    deleteModeHintAny:
      'Napsauta vyöhykettä tai ilmanvaihtokonetta, jonka liitoksia haluat poistaa',
    linkModeHintTarget: 'Napsauta kohdevyöhykettä tai valitse ulkoinen vyöhyke',
  },

  analytics: {
    energyToggle: 'Energia',
    analyticsToggle: 'Analyysi',
    compareToggle: 'Vertaa',
    runSimulation: 'Suorita simulaatio',
    runCoverNeedSimulation: 'Suorita vähimmäisvaatimussimulaatio',
    coverNeedTooltip:
      'Suorittaa simulaation vähimmäisvaatimusten mukaisilla kuvitteellisilla järjestelmillä, jotka kattavat koko energiantarpeen, kun järjestelmät puuttuvat tai eivät riitä',
    coverNeedAssumptionsTitle: 'Vähimmäisvaatimussimulaation oletukset',
    simulating: 'Simuloidaan...',
    exportToExcel: 'Vie Exceliin',
    sendToEnova: 'Lähetä Enovaan',
    resendToEnova: 'Lähetä Enovaan uudelleen',
    downloadEnovaPdf: 'Lataa Enova PDF',
    sentToEnovaSuccess: 'Lähetetty Enovaan',
    sendToEnovaError: 'Enovaan lähetys epäonnistui',
    simulationStartedRefresh:
      'Laskenta on alkanut, päivitä sivu tai palaa tälle sivulle 10 sekunnin kuluttua',
    simulationStartError: 'Simulaation käynnistäminen epäonnistui',
    runRequiresZoneSelection:
      'Valitse vähintään yksi vyöhyke ennen simulaation suorittamista.',
    solarNotIncludedInZones:
      'Aurinkotuotanto lasketaan rakennustasolla eikä sitä sisällytetä vyöhykekohtaisiin tuloksiin ja vertailuihin.',
    resultsCalculatedAt: 'Laskettu {datetime}',
    resultsCalculatedWithStandard:
      'Laskettu {datetime} standardin {standard} mukaan',
    enovaMissingTiltakDescription:
      'Täytä kuvaus Energiamerkin Toimenpiteet-osiossa.',
    enovaNoIncludedActions:
      'Ota käyttöön vähintään yksi sisällytettävä toimenpide tai poista Sisällytä toimenpiteet -valinta ja kirjoita kuvaus.',
    enovaMissingActionDescriptions: 'Täytä kuvaukset kohteille: {actions}',
    enovaMissingCredentials:
      'Täytä {fields} käyttäjäprofiiliisi ennen Enovaan lähettämistä.',
    enovaNoMatrikkelSelected:
      'Valitse vähintään yksi bruksenhet Matrikkeldata-osiosta ennen Enovaan lähettämistä.',
    enovaZonesNotSimulated:
      'Suorita energiamerkkisimulaatio valituille vyöhykkeille ennen Enovaan lähettämistä.',
    enovaNonResidentialMultipleUnits:
      'Ei-asuinkäyttöön tarkoitetuille osastoille voidaan valita vain yksi huoneisto.',
    confirmSendToEnovaMessage: 'Haluatko varmasti lähettää Enovaan?',
    enovaSendWithMessagesWarning:
      'Simulaatiossa on {count} viestiä. Tarkista ne ennen kuin lähetät Enovaan.',
    simulationProgress: 'Rakennuksen energiasimulaatiota suoritetaan...',
    simulationMessages: 'Simulaatioviestit',
    energyCalcWithStandard:
      'Energialaskelmat {standard}-standardin mukaisesti.',
    energyCalc: 'Energialaskelmat',
    noResults:
      'Ei simulointituloksia saatavilla. Suorita simulaatio nähdäksesi energiatiedot.',
    analyticsPlaceholder: 'Analyysikaaviot näytetään tässä.',
    monthlyEnergyBudget: 'Kuukausittainen energiabudjetti (tarve)',
    deliveredEnergyTitle: 'Toimitetut energialähteet',
    deliveredEnergyDesc:
      'Kokonaistoimitettu energia edustaa kaikkia rakennukseen toimitettuja energialähteitä.',
    energyComparisonTitle: 'Energiavertailu (Netto / Häviö / Brutto)',
    energyComparisonDesc:
      'Vertaa nettoenergiatarvetta, jakeluhäviöitä ja bruttoenergiaa jokaiselle kategorialle. Brutto = Netto + Häviö.',
    showTemperature: 'Näytä lämpötilaviiva',
    energySourcesChartLabel: 'Energialähteet',
    totalDeliveredEnergy: 'Kokonaistoimitettu energia',
    visible: 'Näkyvissä',
    noData: 'Ei tietoja',
    nettEnergy: 'Nettoenergia',
    grossEnergy: 'Bruttoenergia',
    distributionLossLabel: 'Jakelu- ja varastointihäviö',
    noMonthlyData: 'Kuukausitietoja ei ole saatavilla tälle simuloinnille.',
    monthlyChartHelp:
      'Jokainen pinottu palkki edustaa kuukausittaista nettoenergiatarvetta luokittain.',
    netEnergyDemand: 'Nettoenergiantarve',
    distributionLosses: 'Jakelu- ja varastointihäviöt',
    grossEnergyDemand: 'Bruttoenergiantarve',
    energySourcesTitle: 'Energial\u00E4hteet (Toimitettu energia)',
    deliveredExportedEnergyTitle: 'Toimitettu ja viety energia',
    climaCorrectedEnergyTitle: 'Ilmastokorjattu toimitettu ja vietyi energia',
    netEnergyTitle: 'Nettoenergia (Nettoenergiantarve)',
    distributionLossTitle: 'Jakeluhäviöt (Jakelu- ja varastointihäviöt)',
    grossEnergyTitle: 'Bruttoenergia (Bruttoenergiantarve)',
    category: 'Kategoria',
    value: 'Arvo',
    unit: 'Yksikkö',
    co2: 'CO₂ kg',
    energyType: 'Energiatyyppi',
    electricityCategory: '1. Sähkö',
    fossilCategory: '2-3. Fossiiliset polttoaineet',
    renewableCategory: '4. Uusiutuva lämmitys',
    districtCategory: '5. Kaukoenergia',
    otherCategory: '6-8. Muut lähteet',
    totalCategory: 'Yhteensä',
    elSpecific: 'Sähkö, erityiskohteet',
    elHeating: 'Sähkö tilalämmitykseen',
    elCooling: 'Sähkö jäähdytysjärjestelmään',
    elDHW: 'Sähkö käyttöveteen',
    elProducedUsed: 'Sähkön tuotanto omaan käyttöön',
    elProducedExported: 'Sähkön tuotanto viety',
    oil: 'Öljy',
    gas: 'Kaasu',
    solidFuel: 'Kiinteä polttoaine',
    solidBiofuel: 'Kiinteä biopolttoaine',
    liquidBiofuel: 'Nestemäinen biopolttoaine',
    gaseousBiofuel: 'Kaasumainen biopolttoaine',
    districtHeating: 'Kaukolämpö',
    districtCooling: 'Kaukojäähdytys',
    other: 'Muu',
    sumDelivered: 'Yhteensä',
    spaceHeating: 'Tilalämmitys',
    ventilationHeating: 'Ilmanvaihdon lämmitys',
    hotWater: 'Lämmin vesi',
    spaceCooling: 'Tilajäähdytys',
    ventilationCooling: 'Ilmanvaihdon jäähdytys',
    fans: 'Puhaltimet',
    pumps: 'Pumput',
    lighting: 'Valaistus',
    technicalEquipment: 'Tekniset laitteet',
    total: 'Yhteensä',
    // Heat loss
    heatLossTitle: 'Lämpöhäviö',
    heatLossDesc:
      'Rakennuksen lämpöhäviön jakautuminen komponenteittain. Arvot kWh.',
    hlWalls: 'Seinät',
    hlRoof: 'Katto',
    hlFloor: 'Maata vasten oleva lattia',
    hlWindows: 'Ikkunat',
    hlDoors: 'Ovet',
    hlThermalBridge: 'Kylmäsillat',
    hlInfiltration: 'Ilmanvaihto (vuoto)',
    hlVentilation: 'Ilmanvaihto',
    hlTotal: 'Yhteensä',
    // Lämpöhäviöbudjetti (taulukko 3 NS 3031:2025)
    hlBudgetTitle: 'Lämpöhäviöbudjetti',
    hlBudgetCategory: 'Lämpöhäviölaji',
    hlBudgetValue: 'Lämpöhäviökerroin',
    hlWindowsDoors: 'Ikkunat ja ovet',
    hlTransmissionSum: 'Lämpöhäviökerroin, johtuminen, summa 1–5',
    hlClimateScreenSum: 'Lämpöhäviökerroin, vaippa, summa 1–6',
    hlTotalSum: 'Lämpöhäviökerroin, yhteensä, summa 1–7',
    // Primäärienergia
    peDeliveredEnergy: 'Toimitettu energia (sähkö)',
    peDeliveredFuel: 'Toimitettu polttoaine',
    peDistrictHeating: 'Kaukolämpö',
    peDistrictCooling: 'Kaukojäähdytys',
    peOtherDelivered: 'Muu toimitettu energia',
    peElExport: 'Sähköntuotanto vientiin',
    energyLabelTitle: 'Energiamerkintä',
    supplementaryEnergyTitle: 'Lisäenergia',
    primaryEnergyFactorsTitle: 'Primaarienergian painotuskertoimet',
    carCharging: 'Auton lataus',
    otherEnergyNeeded: 'Muu energiantarve',
    energyNeedForOtherBuildings: 'Muiden rakennusten energiantarve',
    peFossilOil: 'Fossiilinen öljy',
    peFossilGas: 'Fossiilinen kaasu',
    peFossilSolid: 'Fossiilinen kiinteä polttoaine',
    peBioOil: 'Bioöljy',
    peBioGas: 'Biokaasu',
    peBioSolid: 'Kiinteä biopolttoaine',
    ventilationSpecsTitle: 'Ilmanvaihdon ja puhaltimen tekniset tiedot',
    specificFanPower: 'Ominaisvirrankulutus (SFP)',
    specificAirFlowIn: 'Ominaistuloilmavirta käyttöaikana',
    specificAirFlowOut: 'Ominaistuloilmavirta käyttöajan ulkopuolella',
    specificExhaustAirFlowIn: 'Ominaispoistoilmavirta käyttöaikana',
    specificExhaustAirFlowOut: 'Ominaispoistoilmavirta käyttöajan ulkopuolella',
    hcsHeatingTitle: 'Lämmitysjärjestelmät',
    hcsCoolingTitle: 'Jäähdytysjärjestelmät',
    hcsType: 'Tyyppi',
    hcsHeatingFactor: 'Hyötysuhde lämpökerroin',
    hcsCoolingFactor: 'Hyötysuhde jäähdytyskerroin',
    hcsEnergyCoverage: 'Energiakateaste',
    hcsInndata: 'Lähtötiedot',
    hcsInstalledHeatingEffect:
      'Ominaisasennettu teho tila- ja ilmanvaihtolämmitykselle',
    hcsInstalledCoolingEffect:
      'Ominaisasennettu teho tila- ja ilmanvaihtojäähdytykselle',
    hcsSetpointInOperation: 'Ekvivalentti asetuslämpötila käytössä',
    hcsSetpointOutOfOperation:
      'Ekvivalentti asetuslämpötila käytön ulkopuolella',
    wpeTitle: 'Ilmastokorjattu painotettu toimitettu energia',
    wpeColSource: 'Energialähde',
    wpeColDelivered: 'Ilmastokorjattu toimitettu ja vietyi energia',
    wpeColFactor: 'Painokerroin',
    wpeColWeighted: 'Ilmastokorjattu painotettu toimitettu energia',
    wpeTotal: 'Yhteensä, summa 1-6',
    wpeElectricity: 'Toimitettu sähkö',
    wpeSolidBio: 'Toimitettu kiinteä biopolttoaine',
    wpeLiquidBio: 'Toimitettu nestemäinen biopolttoaine',
    wpeGasBio: 'Toimitettu kaasumainen biopolttoaine',
    wpeSolidFossil: 'Toimitettu kiinteä fossiilinen polttoaine',
    wpeLiquidFossil: 'Toimitettu nestemäinen fossiilinen polttoaine',
    wpeGasFossil: 'Toimitettu kaasumainen fossiilinen polttoaine',
    wpeDistrictHeating: 'Toimitettu kaukolämpö',
    wpeDistrictCooling: 'Toimitettu kaukokylmä',
    wpeOther: 'Muut toimitetut energialähteet',
    wpeElExport: 'Sähköntuotanto vientiin (vähennys)',
    ekBasisHeader: 'Energialuokituksen perusta',
    ekValueHeader: 'Arvo',
    ekSpecificWeighted:
      'Ominainen ilmastokorjattu painotettu toimitettu energia',
    meTitle: 'Mitattu energiankulutus (kWh/vuosi)',
    meColSource: 'Energialähde',
    meColYearGroup: 'Vuosi',
    meColAverage: 'Keskiarvo',
    meTotalDelivered: 'Toimitettu energia yhteensä',
    meTotalNetDelivered:
      'Nettotoimitettu energia yhteensä (vähennettynä mahdollisella viennillä)',
    icTitle: 'Sisälämpötila',
    icSubtitle: 'Kuukausikeskiarvo tuntiarvojen perusteella',
    icZoneLabel: 'Vyöhyke',
    icSingleZoneLabel: 'Sisälämpötila',
    dhcLocalHeatingElectricity: 'Paikallinen lämpö — sähkö',
    dhcLocalHeatingFossilOil: 'Paikallinen lämpö — fossiilinen öljy',
    dhcLocalHeatingFossilGas: 'Paikallinen lämpö — fossiilinen kaasu',
    dhcLocalHeatingFossilSolid:
      'Paikallinen lämpö — fossiilinen kiinteä polttoaine',
    dhcLocalHeatingBioOil: 'Paikallinen lämpö — bioöljy',
    dhcLocalHeatingBioGas: 'Paikallinen lämpö — biokaasu',
    dhcLocalHeatingBioSolid: 'Paikallinen lämpö — kiinteä biopolttoaine',
    dhcLocalDistrictHeating: 'Paikallinen kaukolämpö',
    dhcLocalHeatPump: 'Paikallinen lämpöpumppu',
    dhcLocalHeatingOther: 'Paikallinen lämpö — muut lähteet',
    dhcCentralHeatPump: 'Keskitetty lämpöpumppu',
    dhcCentralHeatingElectricity: 'Keskitetty lämpö — sähkö',
    dhcCentralHeatingFossilOil: 'Keskitetty lämpö — fossiilinen öljy',
    dhcCentralHeatingFossilGas: 'Keskitetty lämpö — fossiilinen kaasu',
    dhcCentralHeatingFossilSolid:
      'Keskitetty lämpö — fossiilinen kiinteä polttoaine',
    dhcCentralHeatingBioOil: 'Keskitetty lämpö — bioöljy',
    dhcCentralHeatingBioGas: 'Keskitetty lämpö — biokaasu',
    dhcCentralHeatingBioSolid: 'Keskitetty lämpö — kiinteä biopolttoaine',
    dhcCentralDistrictHeating: 'Keskitetty kaukolämpö',
    dhcCentralHeatingOther: 'Keskitetty lämpö — muut lähteet',
    dhcCentralSolarThermal: 'Keskitetty aurinkolämpö',
    dhcCentralCogeneration: 'Keskitetty yhteistuotanto',
    dhcLocalCooling: 'Paikallinen jäähdytys',
    dhcCentralCoolingAirWater: 'Keskitetty jäähdytys — ilma/vesi',
    dhcCentralCoolingLiquidWater: 'Keskitetty jäähdytys — neste/vesi',
    dhcCentralFreeCooling: 'Keskitetty vapaajäähdytys',
    dhcCentralDistrictCooling: 'Keskitetty kaukojäähdytys',
    // Sisäiset kuormat
    internalLoadsTitle: 'Sisäiset kuormat',
    internalLoadEnergyTitle: 'Sisäiset kuormat - Energiantarve',
    internalLoadHeatTitle: 'Sisäiset kuormat - Lämpökuormat',
    ilLighting: 'Valaistus',
    ilEquipment: 'Tekniset laitteet',
    ilHotWater: 'Lämmin vesi',
    ilPeople: 'Henkilöt',
    internalLoadsChartTitle: 'Sisäiset kuormat (Energiantarve vs Lämpökuormat)',
    internalLoadsChartDesc:
      'Vertaa energiantarvetta ja lämpökuormia sisäisistä kuormalähteistä.',
    ilEnergyNeed: 'Energiantarve',
    ilSpecificEnergyNeed: 'Ominaisenergiantarve',
    ilSpecificHeatGain: 'Ominaislämpökuorma',
    ilHeatGain: 'Lämpökuorma',
    // Month names
    month: 'Kuukausi',
    monthJan: 'Tammi',
    monthFeb: 'Helmi',
    monthMar: 'Maalis',
    monthApr: 'Huhti',
    monthMay: 'Touko',
    monthJun: 'Kesä',
    monthJul: 'Heinä',
    monthAug: 'Elo',
    monthSep: 'Syys',
    monthOct: 'Loka',
    monthNov: 'Marras',
    monthDec: 'Joulu',
    // Information table (general + climate)
    bdTitle: 'Tiedot',
    bdParameter: 'Yleinen',
    bdInputValue: 'Syöttöarvo',
    bdBuildingCategory: 'Rakennusluokka',
    bdBuildingType: 'Rakennustyyppi',
    bdYearOfConstruction: 'Rakennusvuosi',
    bdTekStandard: 'TEK-standardi',
    bdCalculationDate: 'Laskentapäivä',
    bdClimateInformation: 'Ilmasto',
    bdClimateStationSource: 'Ilmastoaseman lähde',
    bdClimateStation: 'Ilmastoasema',
    bdClimateCorrectionFactor: 'Ilmastokorjauskerroin',
    bdYearlyAverageTemperature: 'Vuoden keskilämpötila',
    efTitle: 'Energiavirta',
    efColCategory: 'Energialaji',
    efColNet: 'Netto energiantarve',
    efColDist: 'Jakelu- ja varastointihäviöt',
    efColGross: 'Brutto energiantarve',
    efColSpf: 'SPF',
    efColDelivered: 'Toimitettu energia',
    efTotal: 'Yhteensä',
    // Energialähteiden painokertoimet (T.2 NS 3031:2025)
    wfTitle: 'Energialähteiden painokertoimet',
    wfType: 'Tyyppi',
    wfWeightFactor: 'Painokerroin',
    wfClimateFactor: 'Kasvihuonekaasukerroin (CO²-ekvivalentti)',
    wfEnergyPrice: 'Energian hinta',
    wfOtherWeighting: 'Muu painotus',
    wfElectricity: 'Toimitettu sähkö',
    wfBioSolid: 'Kiinteä biopolttoaine',
    wfBioLiquid: 'Nestemäinen biopolttoaine',
    wfBioGas: 'Kaasumainen biopolttoaine',
    wfFossilSolid: 'Kiinteä fossiilinen polttoaine',
    wfFossilLiquid: 'Nestemäinen fossiilinen polttoaine',
    wfFossilGas: 'Kaasumainen fossiilinen polttoaine',
    wfDistrictHeating: 'Kaukolämpö',
    wfDistrictCooling: 'Kaukokylmä',
    wfOther: 'Muu',
    wfExportedElectricity: 'Viety sähkö',
    // Jakelujärjestelmät
    dsTitle: 'Jakelujärjestelmät',
    dsCategory: 'Parametri',
    dsValue: 'Syöttöarvo',
    dsRoomHeating: 'Tilojen lämmitys',
    dsVentilationHeating: 'Ilmanvaihdon lämmitys',
    dsDhwCirculation: 'Lämpimän käyttöveden kierto',
    dsRoomCooling: 'Tilojen jäähdytys',
    dsVentilationCooling: 'Ilmanvaihdon jäähdytys',
    dsPipeLength: 'Jakeluputken pituus lämmitettyä pinta-alaa kohti',
    dsPumpPower: 'Pumppujen ominaisteho',
    // Sähkö (taulukko T.2 NS 3031:2025)
    elTitle: 'Sähkö',
    elCategory: 'Parametri',
    elValue: 'Syöttöarvo',
    elSolarEfficiency: 'Aurinkosähköjärjestelmän vuosihyötysuhde',
    elSolarInstalled: 'Aurinkosähkölaitoksen asennettu teho (Ppeak)',
    elSolarCoverage: 'Aurinkosähkön osuus sähköominaisenergian tarpeesta',
    elWindCoverage: 'Tuulivoiman osuus sähköominaisenergian tarpeesta',
    elChpEfficiency:
      'Yhteistuotannon sähköntuotannon keskimääräinen vuosihyötysuhde',
    elChpCoverage: 'Yhteistuotannon osuus sähköominaisenergian tarpeesta',
  },

  energyLabelConfig: {
    airLeakageTitle: 'Ilmavuoto',
    airLeakageMeasured: 'Ilmavuoto mitattu',
    airLeakageMeasuredDate: 'Mittauspäivä',
    airLeakageGradeAHint:
      'Luokka A edellyttää mitattua ilmavuotoa mittauspäivällä. Ilman sitä luokitus on enintään B.',
    actionsTitle: 'Toimenpiteet',
    includeMeasures: 'Sisällytä arvioitavat toimenpiteet',
    includeActivatedActions: 'Sisällytä aktivoidut toimenpiteet',
    loadingActions: 'Ladataan toimenpiteitä…',
    actionNameVentilation: 'Ilmanvaihtotoimenpide',
    actionNameHeating: 'Lämmitys- ja jäähdytystoimenpide',
    actionNameLighting: 'Valaistustoimenpide',
    actionNameSolar: 'Aurinkopanelitoimenpide',
    actionNameControl: 'Ohjaus & Säätö toimenpide',
    actionsDescription:
      'Jos toimenpiteitä ei ole mukana, kuvaile sen sijaan syy (esim. uudisrakennus).',
    includedMeasuresInfo:
      'Sisällytettyjen toimenpiteiden luettelo sisältää arvion kustannuksista ja vaikutuksista kosteuteen ja sisäilmastoon kunkin energiatoimenpiteen osalta. Luetteloa voidaan käyttää perustana rakennuksen kunnossapito- ja parannusohjelman suunnittelulle.',
    description: 'Kuvaus',
    measuredValuesTitle: 'Mitatut arvot',
    measuredValuesCheckbox: 'Mitatut arvot',
    measuredValuesDescription:
      'Energiankulutusmittaukset lähdetyypin mukaan viimeisten 3 vuoden ajalta.',
    energySourcePlaceholder: 'Energialähde (kWh)',
    addMeasurement: 'Lisää mittaus',
    confirmDeleteMeasurement: 'Poistetaanko tämä mittausrivi?',
    deliveredElectricity: 'Toimitettu sähkö (kWh)',
    exportedElectricity: 'Viety sähkö (kWh)',
    fossilOil: 'Fossiilinen öljy (kWh)',
    fossilGas: 'Fossiilinen kaasu (kWh)',
    fossilSolidFuel: 'Fossiilinen kiinteä polttoaine (kWh)',
    bioOil: 'Bioöljy (kWh)',
    bioGas: 'Biokaasu (kWh)',
    bioSolidFuel: 'Biokiinteä polttoaine (kWh)',
    districtHeating: 'Kaukolämpö (kWh)',
    districtCooling: 'Kaukojäähdytys (kWh)',
    other: 'Muu (kWh)',
    // matrikkel data accordion
    matrikkelDataTitle: 'Matrikkelitiedot',
    noUnitsFound: 'Yksiköitä ei löydy',
    street: 'Osoite',
    addressCode: 'Osoitekoodi',
    postcode: 'Postinumero',
    city: 'Kaupunki',
    municipality: 'Kunta',
    municipalityNumber: 'Kuntanumero',
    gnrBnr: 'Gnr/Bnr',
    leaseholdNumber: 'Vuokraoikeuden numero',
    buildingNumber: 'Rakennusnumero',
    buildingType: 'Rakennustyyppi',
    buildingStatus: 'Rakennuksen tila',
    industryType: 'Toimialaluokka',
    unitNumber: 'Yksikkönumero',
    unitId: 'Yksikkötunnus',
    unitType: 'Yksikkötyyppi',
    sectionNumber: 'Osanumero',
    sectionType: 'Osiotyyppi',
  },

  zoneSelection: {
    title: 'Simuloitavat vyöhykkeet',
    selectAll: 'Valitse kaikki',
    deselectAll: 'Poista kaikki valinnat',
    selected: '{count}/{total} valittu',
  },

  buildingTool: {
    showAll: 'Näytä kaikki',
    hideAll: 'Piilota kaikki',
    updateZone: 'Päivitä vyöhyke',
    deleteZone: 'Poista vyöhyke',
    title: 'Rakennustyökalu',
    description:
      'Piirrä monikulmio kartalle rakennuksen pohjapiirustuksen hahmottamiseksi, säädä parametreja ja luo vyöhyke seinillä.',
    numberOfFloors: 'Kerrosten lukumäärä',
    floorHeight: 'Kerroskorkeus (m)',
    startFloor: 'Aloituskerros',
    wallSegments: 'Seinäsegmentit',
    totalPerimeter: 'Kokonaisympärysmitta',
    creating: 'Luodaan...',
    createZoneAndWalls: 'Luo vyöhyke ja seinät',
    createSuccess: 'Vyöhyke ja {count} seinä(ä) luotu onnistuneesti',
    createError: 'Vyöhykkeen ja seinien luominen epäonnistui',
    joinBearings: 'Yhdistä ilmansuunnan mukaan',
    splitBearings: 'Näytä kaikki segmentit',
    joinButton: 'Yhdistä',
    splitButton: 'Jaa',
    floorArea: 'Lattiapinta-ala (m²)',
    roofArea: 'Kattopinta-ala (m²)',
    autoSelect: 'Auto',
    autoSelectHint: 'Napsauta rakennusta valitaksesi pohjapiirustuksen',
    noBuildingFound: 'Rakennusta ei löytynyt',
    createAnother: 'Luo uusi vyöhyke',
    autoSelectTooltip: 'Automaattivalinta',
    drawPolygonTooltip: 'Piirrä monikulmio',
    drawStackedTooltip: 'Lisää kerros vyöhykkeen päälle',
    drawStackedTooltipDisabled:
      'Lisää kerros vyöhykkeen päälle (tarvitaan olemassa oleva vyöhyke)',
    drawStackedHint: 'Napsauta vyöhykettä lisätäksesi kopion sen päälle',
    snapToggleOn: 'Tartunta päällä',
    snapToggleOff: 'Tartunta pois',
    splitTooltip: 'Jaa vyöhyke',
    splitTooltipDisabled: 'Jaa vyöhyke (tarvitaan vyöhyke ensin)',
    splitTargetHint: 'Napsauta jaettavaa vyöhykettä',
    view3dTooltip: '3D-näkymä',
    splitPanelTitle: 'Jaa vyöhyke',
    splitPanelDescription:
      'Vedä liukusäätimiä asettaaksesi leikkauslinjan. Vyöhyke jakautuu kahteen osaan.',
    splitPanelPickTargetHint:
      'Napsauta vyöhykettä kartalla valitaksesi jaettavan.',
    splitPanelSplittingZone: 'Jaetaan: {name}',
    splitPanelCutPositionLabel: 'Leikkauskohta: {value}',
    splitPanelCutAngleLabel: 'Leikkauskulma: {value}°',
    splitPanelCutLengthLabel: 'Leikkauspituus: {value}',
    splitPanelCutOffsetLabel: 'Leikkaussiirtymä: {value}',
    splitPanelConfirm: 'Vahvista jako',
    splitPanelCommitting: 'Jaetaan…',
    errorUpdateZone: 'Vyöhykkeen päivitys epäonnistui',
    errorCreateStackedZone:
      'Kerroksen lisääminen vyöhykkeen päälle epäonnistui',
    errorSplitZone: 'Vyöhykkeen jakaminen epäonnistui',
    errorDeleteZone: 'Vyöhykkeen poistaminen epäonnistui',
  },

  underDevelopment: 'Tämä sivu on kehitteillä.',

  // excel export labels for the input data sheet
  excelExport: {
    headerSection: 'Osio',
    headerName: 'Nimi',
    headerParameter: 'Parametri',
    headerValue: 'Arvo',
    headerUnit: 'Yksikkö',
    inputDataSheetName: 'Lähtötiedot',
    boolYes: 'Kyllä',
    boolNo: 'Ei',
    sectionThermalZones: 'Lämpövyöhykkeet',
    sectionExteriorWalls: 'Ulkoseinät',
    sectionHvacUnits: 'IV-koneet',
    sectionHeatingCoolingModules: 'Lämmitys-/jäähdytysmoduulit',
    sectionCentralEnergyModules: 'Keskitetyt energiamoduulit',
    sectionHeatPumps: 'Lämpöpumput',
    sectionDistrictHeating: 'Kaukolämpö',
    sectionCombustionBoilers: 'Polttokattilat',
    sectionElectricBoilers: 'Sähkökattilat',
    sectionSolarThermal: 'Aurinkolämpö',
    sectionOtherEnergySources: 'Muut energialähteet',
    sectionSolarPv: 'Aurinkosähkö',
    sectionDomesticHotWater: 'Lämmin käyttövesi',
    sectionPipeConfigurations: 'Putkikonfiguraatiot',
    sectionProductionEquipment: 'Tuotantolaitteet',
    sectionExcessEnergy: 'Ylijäämäenergia',
    // excel-specific short labels
    area: 'Pinta-ala',
    uValue: 'U-arvo',
    yearInstalled: 'Asennusvuosi',
    energySource: 'Energialähde',
    systemEfficiency: 'Järjestelmähyötysuhde',
    usedForHeating: 'Käytetään lämmitykseen',
    usedForCooling: 'Käytetään jäähdytykseen',
    usedForDHW: 'Käytetään käyttöveteen',
    maxCapacity: 'Maks. kapasiteetti',
    heatingCapacity: 'Lämmityskapasiteetti',
    cop: 'COP',
    heatingEffect: 'Lämmitysteho',
    coolingEffect: 'Jäähdytysteho',
    co2eEmissionFactor: 'CO\u2082e-päästökerroin',
    energyPrice: 'Energian hinta',
    power: 'Teho',
    // entity prefixes
    prefixWall: 'Seinä',
    prefixWindow: 'Ikkuna',
    prefixDoor: 'Ovi',
    prefixGate: 'Portti',
    prefixPipe: 'Putki',
    prefixHeatingBattery: 'Lämmityspatteri',
    prefixCoolingBattery: 'Jäähdytyspatteri',
    prefixDxSystem: 'DX-järjestelmä',
    prefixEnergySource: 'Energialähde',
    prefixTank: 'Säiliö',
    prefixCopEntry: 'COP-merkintä',
    // thermal zones
    heatedFloorArea: 'Lämmitetty lattia-ala (BRA)',
    numberOfFloors: 'Kerrosten lukumäärä',
    floorHeight: 'Kerroskorkeus',
    indoorTemperature: 'Alkulämpötila',
    zoneClimate: 'Vyöhykeilmasto',
    airLeakageGrade: 'Ilmanvuoto - Luokka',
    airLeakageN50: 'Ilmanvuoto - n50',
    setpointHeating: 'Asetusarvo - Lämmitys',
    setpointCooling: 'Asetusarvo - Jäähdytys',
    thermalBridgeType: 'Kylmäsilta - Tyyppi',
    thermalBridgePsiValue: 'Kylmäsilta - \u03C8-arvo',
    floorType: 'Maata vasten oleva lattia - Tyyppi',
    floorArea: 'Maata vasten oleva lattia - Pinta-ala',
    floorUValue: 'Maata vasten oleva lattia - U-arvo',
    floorHeatLossCoeff: 'Maata vasten oleva lattia - Lämpöhäviökerroin',
    roofType: 'Katto - Tyyppi',
    roofArea: 'Katto - Pinta-ala',
    roofUValue: 'Katto - U-arvo',
    roofAngle: 'Katto - Kulma',
    roofWindowArea: 'Katto - Ikkunapinta-ala',
    roofWindowUValue: 'Katto - Ikkuna U-arvo',
    roofWindowGValue: 'Katto - Ikkuna g-arvo',
    basementArea: 'Kellari - Lattiapinta-ala',
    basementWallPerimeter: 'Kellari - Maata vasten oleva piiri',
    basementFillHeight: 'Kellari - Syvyys maanpinnan alapuolella',
    basementWallThickness: 'Kellari - Seinän paksuus',
    basementWallUValue: 'Kellari - Seinä U-arvo',
    basementFloorUValue: 'Kellari - Lattia U-arvo',
    groundThermalConductivity: 'Maaperä - Lämmönjohtavuus',
    groundHeatCapacity: 'Maaperä - Lämpökapasiteetti',
    groundPenetrationDepth: 'Maaperä - Tunkeutumissyvyys',
    thermalMassCategory: 'Terminen massa - Kategoria',
    thermalMassHeatCapacity: 'Terminen massa - Lämpökapasiteetti',
    thermalMassNormalized: 'Terminen massa - Normalisoitu lämpökapasiteetti',
    // windows
    gValue: 'g-arvo',
    shadingFactor: 'Varjostuskerroin',
    externalBlinds: 'Ulkosälekaihtimet',
    externalBlindsGt: 'Ulkosälekaihtimet Gt',
    externalScreen: 'Ulkoscreen',
    externalScreenGt: 'Ulkoscreen Gt',
    internalShading: 'Sisäaurinkosuoja',
    internalShadingGt: 'Sisäaurinkosuoja Gt',
    // hvac
    heatRecoveryType: 'Lämmön talteenottotyyppi',
    motorType: 'Moottorityyppi',
    flowType: 'Virtaustyyppi',
    sfpSupply: 'SFP (tuloilma)',
    sfpExtract: 'SFP (poistoilma)',
    sfpNonOperating: 'SFP ei-käyttöaika',
    coverageArea: 'Palvelualue',
    coverageVolume: 'Palvelutilavuus',
    fanPowerSupply: 'Puhallinterho (tuloilma)',
    fanPowerExtract: 'Puhallinterho (poistoilma)',
    heatRecoveryEfficiency: 'LTO-hyötysuhde',
    frostProtection: 'Pakkassuoja',
    frostProtectionTemperature: 'Pakkassuojalämpötila',
    airVolumeOperatingSupply: 'Ilmamäärä käyttö (tuloilma)',
    airVolumeCapacitySupply: 'Ilmamäärä kapasiteetti (tuloilma)',
    airVolumeNonOperatingSupply: 'Ilmamäärä ei-käyttö (tuloilma)',
    airVolumeOperatingExtract: 'Ilmamäärä käyttö (poistoilma)',
    airVolumeCapacityExtract: 'Ilmamäärä kapasiteetti (poistoilma)',
    airVolumeNonOperatingExtract: 'Ilmamäärä ei-käyttö (poistoilma)',
    supplyTemperature: 'Tuloilmalämpötila',
    onlyNaturalPassiveVentilation: 'Vain luonnollinen/passiivinen ilmanvaihto',
    batteryEer: 'EER',
    systemType: 'Järjestelmätyyppi',
    coolingOnly: 'Vain jäähdytys',
    ambientTemperature: 'Ympäristölämpötila',
    tankPurpose: 'Tarkoitus',
    tankVolume: 'Tilavuus',
    tankInsulationGrade: 'Eristysluokka',
    tankHeatLossCoeff: 'Lämpöhäviökerroin',
    tankSetpointTemp: 'Asetuslämpötila',
    tankMaxTemp: 'Maks. lämpötila',
    tankMinTemp: 'Min. lämpötila',
    heatPumpType: 'Lämpöpumpputyyppi',
    nominalLoad: 'Nimelliskuorma',
    minimumLoad: 'Minimikuorma',
    degradationCoefficient: 'Heikkenemiskerroin',
    liquidSource: 'Nestelähde',
    sourceTemperature: 'Lähteen lämpötila',
    sourceYearlyAvgTemp: 'Lähteen vuosikeskilämpötila',
    sourceTempAmplitude: 'Lähteen lämpötila-amplitudi',
    copSourceTemp: 'Lähteen lämpötila',
    copMaxEffectLow: 'Maks. teho (matala lämpö)',
    copMaxEffectHigh: 'Maks. teho (korkea lämpö)',
    copFullLoadLow: 'COP täyskuorma (matala lämpö)',
    copFullLoadHigh: 'COP täyskuorma (korkea lämpö)',
    copNormalLoadLow: 'COP normaalikuorma (matala lämpö)',
    copNormalLoadHigh: 'COP normaalikuorma (korkea lämpö)',
    copLowLoadLow: 'COP osakuorma (matala lämpö)',
    copLowLoadHigh: 'COP osakuorma (korkea lämpö)',
    boilerType: 'Kattilatyyppi',
    efficiencyAtLowerLoad: 'Hyötysuhde osakuormalla',
    effectAtFullLoad: 'Teho täyskuormalla',
    isCondensing: 'Kondensoiva',
    seasonalMeanTemperature: 'Kauden keskilämpötila',
    fuelSource: 'Polttoainelähde',
    fuelEnergyContent: 'Polttoaineen energiasisältö',
    fuelCo2EmissionFactor: 'Polttoaine CO\u2082-kerroin',
    operatingStart: 'Käyttöaika alku',
    operatingEnd: 'Käyttöaika loppu',
    phi: 'Phi',
    insulationGrade: 'Eristysluokka',
    tilt: 'Kallistus',
    collectorArea: 'Keräinpinta-ala',
    pipeLength: 'Putken pituus',
    pipeUValue: 'Putki U-arvo',
    efficiencyAtNormalConditions: 'Hyötysuhde normaaliolosuhteissa',
    heatLossLinearCoefficient: 'Lämpöhäviö lineaarikerroin',
    heatLossCoefficient: 'Lämpöhäviökerroin',
    fuelType: 'Polttoainetyyppi',
    panelArea: 'Paneelipinta-ala',
    nominalEfficiency: 'Nimellishyötysuhde',
    panelAngle: 'Paneelikulma',
    panelAzimuth: 'Paneelin atsimuutti',
    inverterEfficiency: 'Invertterihyötysuhde',
    degradationLoss: 'Heikkenemishäviö',
    inverterLoss: 'Invertterihäviö',
    transmissionProduct: 'Transmissiotulo (0-1)',
    temperatureCoefficient: 'Lämpötilakerroin (%/°C)',
    incidentAngleModifier: 'Tulokulmamodifioija (0-1)',
    heatLossFactor: 'Lämpöhäviökerroin',
    pvMountingType: 'Asennustyyppi',
    windExposure: 'Tuulialtistus',
    pvCellType: 'Kennotyyppi',
    heaterType: 'Lämmitin tyyppi',
    useNormedData: 'Käytä normitettuja tietoja',
    placementType: 'Sijoitustyyppi',
    volume: 'Tilavuus',
    setpointTemperature: 'Asetuslämpötila',
    heatingElementPower: 'Vastuksen teho',
    specificHeatLoss: 'Ominaislämpöhäviö',
    maxPowerDemand: 'Maks. tehontarve',
    usagePattern: 'Käyttöprofiili',
    heatContributionPercent: 'Lämpöosuusprosentti',
    distributionSystemType: 'Jakelujärjestelmätyyppi',
    pipeSpecificLength: 'Ominainen putkipituus',
    tapCyclesPerDay: 'Vesipistekierrot päivässä',
    pipesInHeatedRoom: 'Putket lämmitetyssä tilassa',
    specificPumpPower: 'Ominaispumppausteho',
    pipeLinearUValue: 'Putki lineaarinen U-arvo',
    avgTempOutsideHeatedRoom: 'Keskilämpötila lämmitetyn tilan ulkopuolella',
    greyWaterRecovery: 'Harmaaveden talteenotto',
    greyWaterEfficiency: 'Harmaaveden hyötysuhde',
    greyWaterShare: 'Harmaaveden osuus',
    greyWaterConnectionLossFactor: 'Harmaavesi liitoshäviökerroin',
    greyWaterPatternLossFactor: 'Harmaavesi kuviohäviökerroin',
    waterSystemQuality: 'Vesijärjestelmän laatu',
    pipeInsulationType: 'Putkieristystyyppi',
    spp: 'SPP',
    constantFlow: 'Vakiovirtaus',
    lengthOfPipe: 'Putken pituus',
    percentageInHeatedSpace: 'Osuus lämmitetyssä tilassa',
    avgTempOutsideHeatedSpace: 'Keskilämpötila lämmitetyn tilan ulkopuolella',
    temperatureReturn: 'Paluulämpötila',
    temperatureSupply: 'Menolämpötila',
    eligibleForHarvesting: 'Soveltuu energian talteenottoon',
    medium: 'Väliaine',
    temperature: 'Lämpötila',
    amount: 'Määrä',
    ductShape: 'Kanavan muoto',
    diameter: 'Halkaisija',
    width: 'Leveys',
    height: 'Korkeus',
    airSpeed: 'Ilmanopeus',
  },

  actions: {
    ventilation: {
      pageTitle: 'Ilmanvaihto',
      ventilationUnits: 'Ilmanvaihtokoneet',
      noHvacUnits:
        'LVI-yksiköitä ei löytynyt. Lisää LVI-yksiköt LVI-osiossa ensin.',
      usingUnits:
        'Käytetään {count} käytössä olevaa ilmanvaihtoyksikköä rakennustarkastuksesta.',
      enableUnitsHint:
        'Ota ilmanvaihtoyksiköt käyttöön alla sisällyttääksesi ne toimenpiteeseen.',
    },
    lighting: {
      pageTitle: 'Valaistus',
      thermalZones: 'Lämpövyöhykkeet',
      noZones:
        'Lämpövyöhykkeitä ei löytynyt. Lisää lämpövyöhykkeet ensin Lämpövyöhykkeet-osiossa.',
      usingZones:
        'Käytetään {count} käytössä olevaa lämpövyöhykettä valaistustoimenpiteeseen.',
      enableZonesHint:
        'Ota lämpövyöhykkeet käyttöön alla sisällyttääksesi ne valaistustoimenpiteeseen.',
      unit: 'W/m\u00B2',
      presenceControl: 'Läsnäolotunnistus (valaistus)',
      presenceControlLabel: 'Läsnäolotunnistus:',
      presenceYes: 'Kyllä (kerroin: {value})',
      presenceNo: 'Ei',
    },
    heating: {
      pageTitle: 'Lämmitys & jäähdytys',
      thermalZones: 'Lämpövyöhykkeet',
      usingZones:
        'Käytetään {count} käytössä olevaa lämpövyöhykettä lämmitystoimenpiteessä.',
      enableZonesHint:
        'Ota lämpövyöhykkeet käyttöön alla sisällyttääksesi ne lämmitystoimenpiteeseen.',
      addNewSystem: 'Lisää uusi järjestelmä',
      addSystemDialogTitle: 'Lisää uusi järjestelmä',
      template: 'Malli',
      systemName: 'Järjestelmän nimi',
      priorityHelp: '1 = korkein prioriteetti',
      unnamed: 'Nimetön',
      chipNew: 'UUSI',
      chipRemoved: 'POISTETTU',
      chipModified: 'MUOKATTU',
      remove: 'Poista',
      delete: 'Poista',
      confirmDelete: 'Haluatko varmasti poistaa tämän järjestelmän?',
      undo: 'Kumoa',
      noExistingSystems:
        'Ei olemassa olevia lämmitys-/jäähdytysjärjestelmiä tässä vyöhykkeessä.',
      enableZoneHint:
        'Ota tämä vyöhyke käyttöön määrittääksesi lämmitys-/jäähdytysjärjestelmät.',
      existingSystems: '{count} olemassa oleva(a) järjestelmä(ä)',
      templateAirWaterHP: 'Ilma/vesi-lämpöpumppu',
      templateAirAirHP: 'Ilma/ilma-lämpöpumppu',
      templateAirToAirHP: 'Ilma/ilma-lämpöpumppu',
      templateGroundSourceHP: 'Maalämpöpumppu',
      templateElectricBoiler: 'Sähkökattila',
      templateDistrictHeating: 'Kaukolämpö',
      templateDistrictCooling: 'Kaukojäähdytys',
    },
    solar: {
      pageTitle: 'Aurinkosähkö',
      solarPvModules: 'Aurinkosähkömoduulit',
      noModules:
        'Aurinkosähkömoduuleja ei löytynyt. Lisää moduuleja Aurinkosähkö-osiossa.',
      usingModules:
        'Käytetään {count} käytössä olevaa aurinkosähkömoduulia rakennustarkastuksesta.',
      enableModulesHint:
        'Ota aurinkosähkömoduulit käyttöön alla sisällyttääksesi ne toimenpiteeseen.',
      addNewModule: 'Lisää uusi moduuli',
      chipNew: 'Uusi',
      noExistingModules: 'Ei olemassa olevia aurinkosähkömoduuleja.',
    },
    control: {
      pageTitle: 'Ohjaus & Säätö',
      energyReductionPercent: 'Energian vähennys [%]',
      energyReductionHint:
        'Prosentuaalinen vähennys kokonaistoimitetusta energiasta perussimulointiin verrattuna.',
    },
    overview: {
      overviewTitle: 'Toimenpiteiden yleiskatsaus',
      combinedResults: 'Yhdistetyt simulointitulokset',
      notSimulated: 'Ei vielä simuloitu',
      noActiveActions:
        'Ei aktiivisia toimenpiteitä. Ota toimenpiteet käyttöön yksittäisillä toimenpidesivuilla.',
      activeActions: 'Aktiiviset toimenpiteet',
      runCombinedSimulation: 'Suorita rakennussimulaatio',
      noUnitsSelected: 'Ei yksiköitä valittu',
      noZonesSelected: 'Ei lämpövyöhykkeitä valittu',
      noModulesSelected: 'Ei moduuleja valittu',
      totalInvestment: 'Kokonaisinvestointi',
      priorityUpdateFailed: 'Prioriteetin päivitys epäonnistui',
    },
  },

  scenarioSync: {
    outOfSync:
      'Tarkastus on muuttunut sen jälkeen, kun tämä skenaario viimeksi synkronoitiin.',
    legacyOutOfSync:
      'Tarkastus on muuttunut tämän skenaarion luomisen jälkeen. Skenaario on synkronointitukea vanhempi, joten luo uusi skenaario saadaksesi uusimmat muutokset mukaan.',
    reviewChanges: 'Tarkista muutokset',
    notSet: 'Ei asetettu',
    items: 'kohdetta',
    dialogTitle: 'Päivitä skenaario tarkastuksesta',
    dialogIntro:
      'Tarkastuksen muutokset otetaan käyttöön automaattisesti ja omat skenaarion muutoksesi säilytetään. Kun molemmat ovat muuttaneet samaa kenttää, valitse kumpi arvo säilytetään.',
    conflictsHeading: 'ristiriitaa vaatii päätöksesi',
    noConflicts: '0 ristiriitaa',
    added: 'Uusi',
    removed: 'Poistettu',
    removedInScenario: 'Poistettu tässä skenaariossa, poisto säilytetään',
    removeConflict:
      'Poistettu tarkastuksessa, mutta muutettu tässä skenaariossa',
    keepEntity: 'Säilytä',
    removeEntity: 'Poista',
    keepScenario: 'Säilytä skenaarion arvo',
    takeParent: 'Käytä tarkastuksen arvoa',
    keptOverrides:
      'kenttää säilyttää skenaarioon tekemäsi muutokset (päivitys ei korvaa niitä)',
    noChanges: 'Ei synkronoitavia eroja.',
    markSynced: 'Merkitse synkronoiduksi',
    applySync: 'Päivitä skenaario',
    syncSuccess: 'Skenaario päivitetty tarkastuksesta',
    syncError: 'Skenaarion synkronointi epäonnistui',
    resimulateHint: 'Suorita simulointi uudelleen päivittääksesi tulokset.',
    collections: {
      inspection: 'Tarkastus',
      thermalZones: 'Vyöhykkeet',
      exteriorWalls: 'Ulkoseinät',
      windowAreas: 'Ikkunat',
      doorAreas: 'Ovet',
      gateAreas: 'Portit',
      operationalLoads: 'Sisäiset kuormat',
      thermalZoneLinks: 'Vyöhykeliitokset',
      hvacUnits: 'Ilmanvaihtojärjestelmät',
      heatingCoolingModules: 'Lämmitys ja jäähdytys',
      centralEnergyModules: 'Keskitetty energia',
      combustionBoilers: 'Polttokattilat',
      districtHeatings: 'Kaukolämpö',
      electricBoilers: 'Sähkökattilat',
      otherSources: 'Muut energialähteet',
      solarTermals: 'Aurinkolämpö',
      heatPumps: 'Lämpöpumput',
      productionEquipments: 'Tuotantolaitteet',
      solarPvModules: 'Aurinkosähkö',
      excessEnergyModules: 'Ylijäämäenergia',
      domesticHotWaters: 'Käyttövesi',
      actionModules: 'Toimenpiteet',
      pipeLinks: 'Putkiliitokset',
      batteries: 'Akut',
    },
  },

  scenario: {
    intro:
      'Luo yksi tai useampi muokattava kopio tästä tarkastuksesta. Muuta kopiossa mitä tahansa, suorita sitten simulointi ja vertaa alkuperäiseen.',
    introExisting:
      'Tarkastuksen skenaariokopio on jo olemassa. Avaa se jatkaaksesi muokkausta tai aloita alusta alkuperäisen nykytilasta.',
    bannerNotice:
      'Skenaario. Muutokset täällä eivät vaikuta alkuperäiseen tarkastukseen.',
    createScenario: 'Luo skenaario',
    addScenario: 'Lisää skenaario',
    scenarioName: 'Skenaarion nimi',
    scenarioNamePlaceholder: 'esim. Uusi ilmanvaihtojärjestelmä',
    unnamedScenario: 'Nimetön skenaario',
    creating: 'Luodaan…',
    createNewScenario: 'Luo uusi skenaario',
    renameScenario: 'Muokkaa toimenpiteen nimeä ja prioriteettia',
    deleteScenario: 'Poista skenaario',
    confirmDeleteScenario: 'Poistetaanko tämä skenaario?',
    working: 'Käsitellään…',
    backToOriginal: 'Takaisin alkuperäiseen',
    confirmReplace:
      'Korvataanko nykyinen skenaario uudella kopiolla alkuperäisestä? Nykyinen skenaario hylätään.',
    createFailed: 'Skenaarion luonti epäonnistui',
    replaceFailed: 'Skenaarion korvaus epäonnistui',
    renameFailed: 'Skenaarion uudelleennimeäminen epäonnistui',
    deleteFailed: 'Skenaarion poisto epäonnistui',
    existingCreated: 'Luotu {date}',
    existingCreatedBy: 'Luotu {date}, {name}',
    generalNotes: 'Yleiset muistiinpanot',
    generalNotesPlaceholder:
      'Selitä toimenpide mahdollisimman yksityiskohtaisesti: mitä konkreettisesti muutettiin ja miksi.',
    notesRequired: 'Yleiset muistiinpanot vaaditaan',
    investmentCost: 'Investointikustannus [NOK]',
    runToCompare: 'Suorita skenaarion simulointi vertaillaksesi',
    savingsUnavailable:
      'Säästöjä ei voitu vielä laskea. Hintatiedot puuttuvat tai ovat puutteelliset.',
    compareLeftLabel: 'Alkuperäinen',
    compareRightLabel: 'Skenaario',
    compareAgainst: 'Vertaa',
    noComparison: 'Ei vertailua',
    actionTypeLabel: 'Toimenpiteen tyyppi',
    selectActionType: 'Valitse toimenpiteen tyyppi',
    actionTypes: {
      buildingShell: 'Rakennuksen vaippa',
    },
  },

  report: {
    dragDropHint: 'Muuta lukujen ja kenttien järjestystä sivuvalikossa.',
    generateReport: 'Luo raportti',
    reportLanguage: 'Raportin kieli',
    addChapter: 'Lisää luku',
    exportToWord: 'Vie Wordiin',
    exportingToWord: 'Viedään Wordiin...',
    exportingProgress: 'Vie Wordiin — {current}/{total}: {label}',
    sources: 'Lähteet',
    noChapters: 'Ei lukuja vielä. Lisää luku aloittaaksesi.',
    editTitle: 'Muokkaa otsikkoa',
    removeChapter: 'Poista luku',
    noFields: 'Ei tekstikenttiä vielä. Lisää kenttä aloittaaksesi.',
    fieldTitlePlaceholder: 'Uuden kentän otsikko...',
    addField: 'Lisää kenttä',
    confirmRemoveChapter: 'Poista luku "{title}"?',
    generateWithAI: 'Luo tekoälyllä',
    hideAuditLog: 'Piilota tarkastusloki',
    showAuditLog: 'Näytä tarkastusloki',
    removeField: 'Poista kenttä',
    promptLabel: 'Kehote (käytetään AI-generointiin)',
    promptPlaceholder: 'Kirjoita ohjeet AI-generointia varten...',
    generateText: 'Luo teksti',
    textPlaceholder: 'Kirjoita sisältö tähän tai käytä AI-generointia',
    confirmRemoveField: 'Poista kenttä "{title}"?',
    addChapterTitle: 'Lisää uusi luku',
    chapterTitleLabel: 'Luvun otsikko',
    chapterTitlePlaceholder: 'Esim. Sisäilmasto ja mukavuus',
    fetchError: 'Raporttia ei voitu hakea',
    saveError: 'Raporttia ei voitu tallentaa',
    generateError: 'Tekstiä ei voitu luoda',
    generatingStatus:
      'Raporttia luodaan tekoälyllä. Tämä voi kestää useita minuutteja — sivu päivittyy automaattisesti, kun se on valmis.',
    generateSuccess: 'Raportti luotu onnistuneesti',
    generateTimeout:
      'Raportin luominen aikakatkaistiin. Palvelu saattaa vielä käsitellä — yritä päivittää sivu myöhemmin.',
    noContent:
      'Ei vielä sisältöä. Luo raportti tai lisää tekstiä nähdäksesi esikatselun.',
    generationPromptLog: 'Luotu kehotteella:',
  },
};

export default BUILDING_INSPECTION;
